{
  "agent": {
    "welcome": {
      "mcp_prompt_title": "Vous utilisez Claude ou ChatGPT ?",
      "mcp_prompt_description": "Connectez notre serveur MCP et laissez-le configurer votre assistant."
    },
    "off": "Assistant désactivé",
    "on": "Assistant activé",
    "messages_modal": {
      "button": "Messages envoyés",
      "title": "Messages envoyés par l'assistant",
      "description": "Messages envoyés par l'assistant IA à vos contacts.",
      "empty": "Aucun message envoyé par l'assistant pour l'instant."
    },
    "settings": {
      "title": "Personnalité",
      "additional_options": "Options avancées",
      "auto_like": "Like automatique des messages positifs ❤️",
      "description": "Votre Assistant IA répondra différemment selon la personnalité que vous définissez. Vous pouvez l'ajuster au ton de votre marque.",
      "formal": "Ton formel",
      "language": "Langue",
      "make_jokes": "Faire des blagues  🤪",
      "neutral": "Ton neutre",
      "tone_of_voice": "Ton des messages",
      "upbeat": "Ton enjoué",
      "update_agent": "Mettre à jour la personnalité",
      "use_emojis": "Utiliser des emojis 😀",
      "request_human": {
        "message_title": "Envoyer le message suivant",
        "message_placeholder": "Entrez votre message",
        "title": "Si le contact demande à parler à un humain :",
        "add_to_folder": "Ajouter au dossier",
        "send_email": "Envoyer un email à"
      },
      "message_length": {
        "10": "Courte (~10 mots)",
        "25": "Normale (~25 mots)",
        "50": "Longue (~50 mots)",
        "title": "Taille des messages"
      },
      "contact_properties": {
        "notice": "Vous pouvez donner ces informations votre assistant afin de personnaliser les réponses pour chaque contact.",
        "title": "Propriétés des contacts"
      },
      "no_reply": {
        "add_to_folder": "Ajouter au dossier",
        "default_message_placeholder": "Laisser vide pour ne rien envoyer",
        "default_message_title": "Envoyer un message par défaut",
        "notice": "L'assistant ne répondra que s'il trouve la réponse dans la donnée d'entraînement.",
        "send_email": "Envoyer un email à",
        "subtitle": "Si l'assistant ne peut pas répondre :",
        "title": "Limiter les réponses à la donnée d'entraînement"
      },
      "reply_delay": {
        "label": "Répondre uniquement si aucune réponse n'a été envoyée au bout de",
        "notice": "Utile si vous avez des scénarios actifs ou que vous répondez manuellement avant l'assistant.",
        "title": "Délai de réponse"
      },
      "role": {
        "placeholder": "social media assistant",
        "title": "Profil de l'assistant",
        "notice": "Le profil est utilisé pour adapter la personnalité de l'assistant. Il doit être écrit en anglais."
      }
    },
    "title": "Assistant IA",
    "training": {
      "cancel_changes": "Annuler les modifications",
      "data": "Données d'entraînement",
      "data_changed": "Nouvelles données détectées",
      "data_placeholder": "Entrez toutes les informations que vous souhaitez que votre Assistant apprenne. Plus vous ajoutez d'information, plus il sera précis. Utilisez votre FAQ, base de connaissances ou tout autre donnée textuelle.",
      "data_unchanged": "Entraînement à jour",
      "description": "Votre Assistant IA peut répondre aux questions les plus fréquentes grâce à la donnée que vous lui fournissez.",
      "last_trained": "Dernier entraînement le {{date}}",
      "title": "Entraînement",
      "train": "Entraîner mon Assistant",
      "training_in_progress": "Entraînement en cours",
      "characters_left_one": "{{count}} caractères restant",
      "characters_left_other": "{{count}} caractères restant",
      "generate_data": "Générer les données automatiquement",
      "generate_data_confirm": "Utiliser l'IA pour générer automatiquement les données sur votre compte Instagram ?",
      "improve_data": "Améliorer la donnée",
      "improve_data_confirm": "Utiliser l'IA pour améliorer la donnée automatiquement ?",
      "remove_formatting": "Retirer la mise en forme",
      "remove_formatting_confirm": "Voulez-vous retirer toute la mise en forme ?"
    },
    "chat": {
      "title": "Discutez avec votre Assistant",
      "chat_as": "Discuter en tant que",
      "reset_chat": "Réinitialiser",
      "select_a_contact": "Choisir un contact",
      "tooltip": "Choisissez un de vos contact pour simuler la conversation avec l'Assistant.",
      "detected_property": "Propriété de contact détectée",
      "triggered_actions": {
        "folder": "Ajouté au dossier",
        "scenario": "Scénario déclenché"
      }
    },
    "personality": {
      "analysis_error": "Erreur pendant l'analyse",
      "title": "Voix et personnalité",
      "about": {
        "label": "À propos",
        "description": "Qui vous êtes, ce que vous proposez et à qui vous parlez.",
        "placeholder": "ex. Nous sommes un petit atelier à Mérida qui fabrique des tote bags personnalisés pour des marques, des hôtels et des événements partout au Mexique."
      },
      "voice_rules": {
        "label": "Règles de style",
        "description": "Comment votre agent écrit, une règle à la fois.",
        "placeholder": "ex. N'utilise jamais de points d'exclamation",
        "add_button": "Ajouter une règle"
      },
      "sections": {
        "profile": {
          "title": "Profil",
          "description": "Pour qui votre agent parle et la longueur de ses messages."
        }
      },
      "message_length": {
        "label": "Longueur des messages",
        "options": {
          "10": "Courts",
          "25": "Normaux",
          "50": "Longs"
        },
        "words_one": "~{{count}} mot",
        "words_other": "~{{count}} mots"
      },
      "message_examples": {
        "label": "Exemples de messages",
        "description": "De vrais messages dont votre agent doit reprendre le ton.",
        "placeholder": "ex. Merci pour votre message ! Comment puis-je vous aider ? 😊",
        "add_button": "Ajouter un exemple"
      },
      "auto_like": "Aimer automatiquement les messages positifs ❤️"
    },
    "account_data": {
      "analysis_error": "Erreur pendant l'analyse",
      "title": "Objectif et instructions",
      "goal": {
        "label": "Objectif",
        "description": "Ce que votre agent cherche à obtenir. Une automatisation peut lui donner une autre tâche.",
        "placeholder": "ex. Répondre aux questions, puis demander la taille et le nombre de pièces pour envoyer un devis."
      },
      "instructions": {
        "label": "Instructions",
        "description": "Suivies partout, y compris dans les automatisations et les réponses aux commentaires.",
        "placeholder": "ex. Ne jamais promettre de date de livraison",
        "add_button": "Ajouter une instruction",
        "count_one": "{{count}} instruction",
        "count_other": "{{count}} instructions"
      }
    },
    "knowledge_items": {
      "text": {
        "retrieval_label": "Include cette information dans toutes les requêtes",
        "retrieval_alert_title": "Clé OpenAI requise",
        "retrieval_alert_message": "Cette fonctionnalité nécessite actuellement une clé API OpenAI.",
        "retrieval_alert_confirm": "Fournir ma clé API"
      }
    },
    "trigger_mode": {
      "trigger_intents": {
        "empty_confirm": {
          "title": "Aucun intent ajouté",
          "body": "Votre assistant ne répondra à aucun message tant qu'aucun intent n'aura été ajouté. Continuer quand même ?",
          "confirm": "Continuer quand même",
          "cancel": "Ajouter un intent"
        }
      }
    },
    "feedback": {
      "title": "Améliorer votre agent",
      "label": "Que faut-il changer ?",
      "placeholder": "ex. La livraison prend une semaine maintenant, et pas de points d'exclamation",
      "suggest": "Proposer des modifications",
      "applied": "Agent mis à jour",
      "before": "Avant",
      "after": "Après",
      "improve": "Améliorer la réponse",
      "ops": {
        "add_rule": "Nouvelle {{kind}}",
        "edit_rule": "Modifier la règle",
        "delete_rule": "Supprimer la règle",
        "set_about": "Modifier « À propos »",
        "set_goal": "Modifier l'objectif",
        "add_example": "Ajouter un exemple de message",
        "remove_example": "Supprimer l'exemple de message"
      },
      "kinds": {
        "voice": "règle de style",
        "instruction": "instruction"
      },
      "apply": "Appliquer les modifications",
      "empty_value": "Ne peut pas être vide"
    }
  },
  "api_errors": {
    "title": "Erreurs API",
    "search": "Rechercher dans les erreurs",
    "empty": "Aucune erreur API enregistrée pour le moment",
    "apis": {
      "facebook": "Meta"
    },
    "table": {
      "columns": {
        "api": "API",
        "code": "Code",
        "message": "Message",
        "created_at": "Date"
      }
    },
    "detail": {
      "title": "Détails de l'erreur",
      "code": "Code",
      "subcode": "Sous-code",
      "message": "Message",
      "created_at": "Date",
      "request": "Requête",
      "body": "Corps de la réponse",
      "trace": "Trace"
    }
  },
  "automation": {
    "ai_credits": {
      "badge_one": "{{count}} crédit",
      "badge_other": "{{count}} crédits",
      "tooltip_one": "Utilise {{count}} crédit IA à chaque exécution",
      "tooltip_other": "Utilise {{count}} crédits IA à chaque exécution"
    },
    "calendly_links": {
      "send": "Envoyer un lien Calendly",
      "send_confirm_title": "Êtes-vous sûrs ?"
    },
    "conversion_links": {
      "delete_image": "Supprimer l'image",
      "fields": {
        "add_image": "Ajouter une image",
        "change_image": "Changer l'image"
      },
      "send": "Envoyer un lien suivi",
      "send_confirm_title": "Êtes-vous sûr ?",
      "url_invalid": "L'URL est invalide"
    },
    "scenarios": {
      "action_groups": {
        "most_used": {
          "title": "Les plus utilisés",
          "description": "Les actions les plus populaires"
        },
        "actions": {
          "description": "Demander une action ou envoyer un lien",
          "title": "Actions"
        },
        "comments": {
          "description": "Répondre ou cacher les commentaires",
          "title": "Commentaires"
        },
        "contact": {
          "description": "Organiser ou modifier le contact",
          "title": "Contacts"
        },
        "conversions": {
          "description": "Demander une action ou envoyer un lien",
          "title": "Conversions"
        },
        "logic": {
          "description": "Ajouter un délai ou une logique complexe",
          "title": "Logique"
        },
        "messages": {
          "description": "Envoyer un DM, une photo, vidéo, etc.",
          "title": "Messages"
        },
        "ai": {
          "description": "Demander de l'aide à votre Assistant IA",
          "title": "IA"
        },
        "integrations": {
          "description": "Intégrer des services externes",
          "title": "Intégrations"
        }
      },
      "actions": {
        "collect_email": {
          "description": "Le scénario attendra que le contact envoie son adresse mail puis la sauvegardera dans la fiche du contact.",
          "title": "Collecter l'adresse mail",
          "no_email": "Si aucune adresse email n'a été reçue après",
          "when_email": "Quand une addresse email est reçue",
          "auto_follow_up_label": "Envoyer une relance si pas de réponse",
          "follow_up_label": "Relance après {{duration}} {{unit}}"
        },
        "collect_property": {
          "title": "Collecter une propriété",
          "description": "Posez une question, puis détectez et sauvegardez automatiquement la réponse dans une propriété de contact grâce à l'IA.",
          "when_property": "Quand la propriété est collectée",
          "when_incorrect": "Quand la valeur n'est pas détectée",
          "no_property": "Si aucune valeur valide n'a été reçue après",
          "content_title": "Votre message initial",
          "content_description": "Demandez aux contacts d'envoyer l'information à collecter",
          "property_label": "Propriété de contact à collecter",
          "no_description_notice": "Cette propriété n'a pas de description. En ajouter une aide l'IA à détecter la valeur plus précisément.",
          "autoreply_label": "Renvoyer si la valeur n'est pas détectée",
          "incorrect_label_placeholder": "Demandez aux contacts d'envoyer l'information à nouveau",
          "incorrect_label_title": "Message si la valeur n'est pas détectée",
          "incorrect_label_description": "Demandez aux contacts d'envoyer l'information à nouveau",
          "max_attempts_label": "Essais maximum",
          "max_attempt_mode_expire": "Expirer",
          "max_attempt_mode_continue": "Continuer",
          "auto_follow_up_label": "Envoyer une relance si pas de réponse",
          "follow_up_label": "Relance après {{duration}} {{unit}}",
          "max_attempts_mode_label": "Après le dernier essai",
          "max_attempts_continue": "Aller à l'étape suivante",
          "max_attempts_expire": "Marque comme expiré",
          "skip_ai_detection_label": "Ignorer la détection IA (sauvegarder le message brut)"
        },
        "comment": {
          "placeholder": "Entrer votre commentaire",
          "title": "Répondre au commentaire",
          "autowrite": "Réécrire le commentaire automatiquement",
          "description": "Écrire un commentaire en réponse sur un de vos posts",
          "add_variant": "Ajouter une variante",
          "variant_notice": "Une variante sera choisie au hasard pour éviter la répétition",
          "like_comment": "Liker le commentaire original ❤️",
          "progressive_limiting": "La probabilité de réponse s'ajuste automatiquement : 100% pour les 10 premiers commentaires, diminuant progressivement jusqu'à 10% à 200 commentaires, puis restant à 10%"
        },
        "conversion_link": {
          "placeholder": "Choisir un lien...",
          "title": "Lien de conversion",
          "add_to_folder": "Au clic, ajouter au dossier",
          "no_click": "Si le lien n'a pas été cliqué après",
          "when_click": "Quand le lien est cliqué",
          "description": "Envoyer un lien avec mesure des clics",
          "loading": "Chargement du contenu..."
        },
        "delay": {
          "seconds_one": "seconde",
          "seconds_other": "secondes",
          "title": "Délai de temps",
          "wait": "Attendre",
          "description": "Attendre un temps défini avant de continuer"
        },
        "engagement_condition": {
          "if": "Si cette personne m'a contacté",
          "in": "dans le(s) dernier(s)",
          "title": "Filtre sur l'engagement"
        },
        "folder": {
          "title": "Ajouter à un dossier",
          "add": "Ajouter au dossier",
          "remove": "Retirer le contact du dossier",
          "description": "Choisir un dossier ou en créer un nouveau",
          "excluded_folder_warning": "L'un des dossiers sélectionnés est exclu de ce scénario. Ajouter le contact à ce dossier interrompra la suite du scénario."
        },
        "contact_status": {
          "opt_in": "Opt-in du contact",
          "opt_out": "Opt-out du contact",
          "title": "Modifier le statut du contact",
          "description": "Activer ou désactiver le contact pour la messagerie"
        },
        "like": {
          "title": "Liker le dernier message",
          "description": "Like du dernier message envoyé par le contact. Ne s'applique pas aux commentaires"
        },
        "message": {
          "placeholder": "Écrivez votre message",
          "title": "Envoyer un message",
          "insert_variable": "Insérer une variable",
          "description": "Écrire un message en insérant des variables"
        },
        "audio_message": {
          "placeholder": "Écrivez votre message",
          "title": "Envoyer un message audio",
          "loading": "Chargement du message audio",
          "description": "Enregistrer ou charger un fichier audio"
        },
        "media_message": {
          "send_images": "Envoyer plusieurs images",
          "title": "Envoyer une photo/vidéo",
          "upload_media": "Choisir un fichier",
          "no_file_uploaded": "Aucun fichier sélectionné",
          "loading": "Chargement du fichier...",
          "description": "Charger une photo ou une vidéo",
          "select_media": "Choisir le média",
          "use_url": "Utiliser une URL",
          "url_placeholder": "https://... ou {{variable}}",
          "upload_file_instead": "Charger un fichier"
        },
        "media": {},
        "payment_link": {
          "placeholder": "Saisir le montant...",
          "title": "Lien de paiement",
          "description": "Demander un paiement par DM"
        },
        "shopify_link": {
          "placeholder": "Choisissez un produit ...",
          "title": "Lien Shopify",
          "description": "Envoyer un lien vers un produit sur votre boutique Shopify"
        },
        "wait_for_reply": {
          "description": "Le scénario se mettra en pause en attendant que le contact réponde.",
          "title": "Attendre une réponse",
          "when_contact_replies": "Quand le contact répond",
          "no_reply": "Si le contact n'a pas répondu après",
          "else_if_message_contains": "sinon, si le message contient",
          "if_message_contains": "Si le message contient"
        },
        "http_request": {
          "add_header": "Ajouter un en-tête",
          "add_param": "Ajouter un paramètre",
          "body": "Corps",
          "description": "Envoyer une requête à un serveur ou un webhook",
          "header_key": "Clé",
          "header_value": "Valeur",
          "headers": "En-têtes",
          "param_key": "Clé",
          "param_value": "Valeur",
          "title": "Requête HTTP",
          "url_placeholder": "https://exemple.fr",
          "if_failure": "Si la requète échoue",
          "if_success": "Si la requète réussit",
          "encode_params": "Encoder les paramètres",
          "body_mode_key_value": "Clé / Valeur",
          "body_mode_json": "JSON",
          "json_placeholder": "{ \"clé\": \"valeur\" }",
          "learn_more": "Comment envoyer de la donnée dans ma requête HTTP ?"
        },
        "scenario_condition": {
          "description": "Continuer ou interrompre le scénario si la condition est remplie.",
          "is_follower": "le contact vous suit",
          "title": "Conditions du scénario",
          "condition_options": {
            "emojis": "Un emoji",
            "keywords": "Un mot-clé spécifique"
          },
          "folder": "Choisir un dossier",
          "is_in_folder": "le contact dans un dossier",
          "message_contains": "le message ou commentaire contient",
          "message_contains_placeholder": "Entrer un mot-clé",
          "branches": {
            "option_false": "Si la condition n'est pas remplie",
            "option_true": "Si la condition est remplie"
          },
          "contact_property": "Une propriété du contact",
          "contact_property_value": "Entrer une valeur",
          "variable": "Condition sur une variable",
          "variable_placeholder": "{{ variable }}"
        },
        "share_media": {
          "title": "Partager un post/reel",
          "description": "Parmi vos publications récentes",
          "loading": "Chargement en cours..."
        },
        "survey": {
          "title": "Envoyer un sondage",
          "placeholder": "Choisir un sondage...",
          "no_fill": "Si le sondage n'a pas été rempli après",
          "no_reply": "Si le contact n'a pas répondu après",
          "when_filled": "Quand le sondage est rempli",
          "when_replied": "Quand le contact répond",
          "description": "Poser une ou plusieurs questions et sauvegarder les réponses",
          "loading": "Chargement du sondage..."
        },
        "not_found": {
          "title": "Action introuvable"
        },
        "content_filter": {
          "add_to_folder": "Ajouter au dossier",
          "description": "Interrompre le scénario si le message ou commentaire contient du spam ou des propos haineux",
          "title": "Filtre spam & haine"
        },
        "hide_comment": {
          "description": "Cache le commentaire sur Instagram. Vous pourrez toujours le voir dans la section Commentaires cachés.",
          "title": "Cacher le commentaire"
        },
        "ask_question": {
          "add_reply": "Ajouter une réponse",
          "delete_reply_confirm_message": "Toutes les actions liées à cette réponse seront supprimées. Cette action ne peut pas être annulée.",
          "delete_reply_confirm_title": "Supprimer cette réponse ?",
          "description": "Déclencher différentes actions selon la réponse.",
          "no_replies": "Si le contact n'a pas répondu au bout de",
          "option_placeholder": "Entrer une réponse",
          "question_placeholder": "Entrer une question",
          "save_reply_to": "Sauvegarder la réponse dans une propriété",
          "title": "Poser une question",
          "when_reply": "Si le contact répond",
          "warning": "Si vous ajoutez beaucoup d'options, vos contacts sont moins susceptibles de répondre.",
          "when_reply_other": "Quand le contact répond autre chose",
          "when_incorrect": "Relancer si la réponse ne correspond pas",
          "incorrect_label_placeholder": "Envoyer un message pour demander de réessayer",
          "incorrect_reply": "Réponse incorrecte",
          "ai_detection": "Détection par IA",
          "ai_detection_description": "L'IA détectera quelle réponse correspond le mieux si aucune correspondance exacte n'est trouvée.",
          "disable_quick_replies": "Cacher les suggestions de réponse",
          "max_attempts_label": "Essais maximum",
          "auto_follow_up_label": "Envoyer une relance si pas de réponse",
          "follow_up_label": "Relance après {{duration}} {{unit}}"
        },
        "agent_question": {
          "title": "Question Agent IA",
          "description": "Poser une question et détecter les réponses avec l'IA."
        },
        "update_property": {
          "description": "Mettre à jour l'email, le téléphone ou une autre propriété du contact.",
          "placeholder": "Valeur de la propriété",
          "title": "Modifier le contact"
        },
        "send_email": {
          "title": "Envoyer un email",
          "description": "Envoyer un email à une adresse spécifiée.",
          "edit_email": "Modifier l'email",
          "from": "De",
          "manage_emails": "Gérer",
          "to": "À",
          "cc": "Cc",
          "bcc": "Cci",
          "reply_to": "Répondre à",
          "subject_label": "Objet",
          "subject_placeholder": "Entrez l'objet de l'email",
          "email_placeholder": "adam@exemple.com",
          "content_label": "Contenu de l'email",
          "content_placeholder": "Rédigez votre email...",
          "content_notice": "Vous pouvez utiliser la syntaxe Markdown et insérer des variables.",
          "attachments": "Pièces jointes",
          "attachments_count_one": "{{count}} pièce jointe",
          "attachments_count_other": "{{count}} pièces jointes",
          "add_recipient": "Ajouter un destinataire"
        },
        "send_file": {
          "title": "Envoyer un fichier",
          "description": "Envoyer un fichier avec un bouton de téléchargement",
          "file_label": "Téléverser le fichier",
          "upload_file": "Téléverser un fichier (image, audio, vidéo)",
          "change_file": "Changer de fichier",
          "title_label": "Texte du message",
          "title_placeholder": "Entrez un message...",
          "button_label": "Libellé du bouton (optionnel)",
          "button_placeholder": "Télécharger"
        },
        "trigger_scenario": {
          "description": "Lancer un autre scénario sur ce contact",
          "title": "Déclencher un scénario",
          "select_scenario": "Choisir un scénario",
          "current_scenario_warning": "Déclencher le même scénario peut créer une boucle infinie.",
          "trigger_data_label": "Données de déclenchement",
          "trigger_data_add": "Ajouter une donnée",
          "trigger_data_key": "Clé",
          "trigger_data_value": "Valeur"
        },
        "calendly_link": {
          "button_placeholder": "Texte du bouton",
          "description": "Envoyer un lien Calendly pour planifier un rendez-vous",
          "edit_button": "Modifier le bouton",
          "placeholder": "Choisir le lien Calendly",
          "title": "Lien Calendly",
          "free_plan": "Un compte Calendly Pro est nécessaire pour détecter les prises de rendez-vous.",
          "no_book": "Si le contact n'a pas converti après",
          "when_booked": "Quand le contact prend rendez-vous"
        },
        "keywords": {
          "add_keyword": "Ajouter un mot-clé",
          "keyword_placeholder": "Entrer le mot-clé",
          "add_branch": "Ajouter une branche",
          "notice": "Les mots-clé ignorent la casse et les accents",
          "or": "ou"
        },
        "agent_reply": {
          "description": "Laisser votre Assistant IA répondre par DM au dernier message ou commentaire",
          "title": "Réponse automatique de l'IA",
          "message_length": {
            "10": "Message court (~10 mots)",
            "25": "Message normal (~25 mots)",
            "50": "Message long (~50 mots)",
            "100": "Message très long (~100 mots)"
          }
        },
        "agent_message": {
          "title": "Message spécifique de l'IA",
          "description": "Demander à votre Assistant IA d'envoyer un message spécifique",
          "task_notice": "Écrire une instruction simple et en anglais pour de meilleurs résultats.",
          "task_placeholder": "Send today's weather, ask for information, etc.",
          "message_length": {
            "10": "Message court (~10 mots)",
            "25": "Message normal (~25 mots)",
            "50": "Message long (~50 mots)",
            "100": "Message très long (~100 mots)"
          }
        },
        "agent_handover": {
          "title": "Transférer à l'Assistant IA",
          "description": "Transférer tous les messages entrants à l'Assistant IA jusqu'à la fin de la conversation",
          "task_label": "Instructions spécifiques",
          "task_placeholder": "e.g. Donne des conseils, aide à commander, etc.",
          "add_task": "Ajouter des instructions",
          "auto_follow_up_label": "Relancer automatiquement après chaque message",
          "follow_up_label": "Relance après {{duration}} {{unit}}",
          "preview_message": "Message généré par l'assistant IA",
          "preview_follow_up": "Message de relance généré par l'assistant IA",
          "preview_wait": "Après {{duration}} {{unit}}",
          "preview_reply": "Réponse du contact",
          "task_completed_branch": "Tâche terminée",
          "expired_branch": "Transfert expiré"
        },
        "ai_condition": {
          "title": "Condition IA",
          "description": "Utiliser l'IA pour évaluer si une condition personnalisée est vraie ou fausse",
          "placeholder": "ex: le contact est intéressé par une réservation de rendez-vous",
          "branches": {
            "option_true": "Si la condition est vraie",
            "option_false": "Si la condition est fausse"
          }
        },
        "contact_filter_condition": {
          "title": "Filtre de contact",
          "description": "Brancher selon si le contact correspond à un ensemble de filtres.",
          "add_filter": "Ajouter un filtre",
          "logic_label": "Correspond",
          "no_filters": "Aucun filtre défini",
          "option_true": "Correspond aux filtres",
          "option_false": "Ne correspond pas"
        },
        "ab_testing": {
          "description": "Tester différentes logiques pour voir laquelle performe le mieux.",
          "notice": "Vous pouvez déclencher d'autres scénarios",
          "option_a": "50%",
          "option_b": "50%",
          "title": "Test A/B",
          "ratio_label": "Ratio option A",
          "ratio_description": "Option A : {{option_a}}% - Option B : {{option_b}}%"
        },
        "card_template": {
          "description": "Envoyer une carte avec un titre, description, image et boutons",
          "no_click": "Si le contact n'a pas cliqué après",
          "allow_multiple_clicks": "Autoriser plusieurs clics",
          "remove_card": "Retirer la carte",
          "subtitle_placeholder": "Description (optionnel)",
          "title": "Envoyer une carte actionnable",
          "title_placeholder": "Titre de la carte",
          "when_clicked": "Quand on clique sur le bouton"
        },
        "eleven_labs_audio": {
          "description": "Générer un message audio depuis Eleven Labs AI",
          "generate_audio": "Générer un message vocal",
          "text_placeholder": "Texte du message",
          "title": "Audio Eleven Labs",
          "voice_placeholder": "Choisir une voix"
        },
        "high_level_upsert_contact": {
          "title": "Synchroniser contact HighLevel",
          "description": "Créer ou mettre à jour un contact dans HighLevel CRM",
          "params_label": "Paramètres du contact",
          "params_empty": "Aucun paramètre configuré",
          "params_add": "Ajouter un paramètre",
          "params_key": "Nom du champ",
          "params_value": "Valeur"
        },
        "button_template": {
          "add_button": "Ajouter un bouton",
          "button_title_placeholder": "Titre du bouton",
          "content_placeholder": "Écrire le message",
          "description": "Écrire un message avec un ou plusieurs boutons",
          "no_click": "Si le bouton n'a pas été cliquée après",
          "title": "Envoyer un message avec bouton",
          "when_clicked": "Quand on clique sur le bouton",
          "add_image": "Ajouter une image",
          "fetch_opengraph_image": "Récupérer automatiquement l'image depuis l'URL de la légende",
          "fetch_opengraph_label": "Récupérer l'image du site"
        },
        "like_comment": {
          "title": "Liker le commentaire",
          "description": "Like le commentaire qui a déclenché ce scénario.",
          "comment_text": "Un commentaire sur votre post"
        }
      },
      "steps": {
        "select_post": {
          "title": "Sélectionner les posts",
          "description": "L'automatisation se déclenchera uniquement sur ces posts",
          "which_posts": "Quels posts souhaitez-vous utiliser ?",
          "select_option": "Sélectionner une option",
          "no_posts_selected": "Aucun post sélectionné",
          "all_posts": "Tous les posts",
          "next_post": "Prochain post uniquement",
          "next_post_notice": "L'automatisation se déclenchera uniquement sur le premier post après",
          "next_post_reset": "Réinitialiser la date",
          "caption_keywords": "Posts avec mot(s)-clé dans la description",
          "caption_keywords_label": "Entrer le(s) mot(s)-clé de la description",
          "caption_keywords_notice": "Utilisez un #hashtag, un mot spécifique ou un emoji. Les majuscules et accents sont ignorés. Les futurs posts seront également inclus.",
          "filter_keyword_caption": "Rechercher par hashtag, mot-clé ou emoji...",
          "no_posts_match": "Aucun post ne correspond au mot-clé",
          "posts_match_one": "{{count}} post correspond au mot-clé",
          "posts_match_other": "{{count}} posts correspondent au mot-clé",
          "caption_url": "Posts avec une URL dans la description",
          "caption_url_filter_label": "Uniquement si l'URL contient",
          "caption_url_filter_placeholder": "ex. superlien.com",
          "caption_url_filter_description": "Laisser vide pour correspondre à toutes les URLs.",
          "caption_url_notice": "Vous pouvez accéder à l'URL dans votre automatisation avec la variable **{{ trigger.caption_url }}**.",
          "select_posts": "Sélectionner les posts manuellement",
          "choose_posts": "Choisir un ou plusieurs posts",
          "selected_posts_one": "{{count}} post sélectionné",
          "selected_posts_other": "{{count}} posts sélectionnés",
          "search_posts": "Rechercher des posts",
          "no_posts": "Aucun post ne correspond à votre recherche"
        },
        "select_comments": {
          "title": "Filtrer les commentaires",
          "description": "L'automatisation se déclenchera uniquement sur les commentaires correspondants",
          "which_comments": "Quels commentaires doivent déclencher l'automatisation ?",
          "select_option": "Sélectionner une option",
          "no_comments_selected": "Aucun commentaire sélectionné",
          "all_comments": "Tous les commentaires",
          "comment_keywords": "Commentaires avec mot(s)-clé",
          "ai_detected": "Intention détectée par l'IA",
          "tag_someone": "Commentaires qui identifient quelqu'un",
          "ai_intent_label": "Décrire l'intention du commentaire",
          "ai_intent_notice": "Soyez aussi précis et spécifique que possible pour obtenir de meilleurs résultats.",
          "ai_intent_warning": "Les intentions détectées par l'IA peuvent ne pas toujours être précises.",
          "keywords_title": "Entrer les mots-clés des commentaires",
          "keywords_notice": "Les majuscules et accents sont ignorés et vous pouvez utiliser des emojis.",
          "no_keywords_notice": "Entrez au moins un mot-clé pour filtrer les commentaires.",
          "duplicate_keywords_notice": "Les majuscules et accents sont ignorés, vous pouvez supprimer les doublons.",
          "recent_comments": "Commentaires existants correspondants sur les posts",
          "recent_comments_notice": "Vous pouvez déclencher des automatisations sur des commentaires passés des 7 derniers jours uniquement.",
          "no_recent_comments": "Aucun commentaire récent ne correspond à vos mots-clés sur les posts sélectionnés",
          "all_comments_example": "n'importe quel commentaire",
          "all_comments_reply_example": "n'importe quelle réponse",
          "comment_keywords_example": "commentaire avec le mot-clé {{keyword}}",
          "comment_keywords_reply_example": "réponse avec le mot-clé {{keyword}}",
          "ai_detected_example": "commentaire avec intention détectée par l'IA",
          "ai_detected_reply_example": "réponse avec intention détectée par l'IA",
          "tag_someone_example": "j'adore ça @pierredemilly @inro.social",
          "tag_someone_reply_example": "tu devrais voir ça @pierredemilly",
          "_example": "un commentaire",
          "allow_replies": "Autoriser les réponses aux commentaires à déclencher l'automatisation",
          "allow_replies_notice": "Instagram n'autorise les réponses publiques que sur les commentaires de premier niveau : une action de réponse au commentaire sera donc ignorée pour ceux-ci — un DM peut toujours leur être envoyé.",
          "exclude_negative": "Exclure les commentaires haineux et négatifs",
          "ai_intent_placeholder": "e.g. le commentaire m'insulte, est raciste, etc."
        }
      },
      "add_step": "Ajouter une étape",
      "other_actions": "Autres actions…",
      "add_action_suggestions": {
        "message": "Envoyer un message",
        "ask_question": "Poser une question",
        "conversion_link": "Envoyer un lien"
      },
      "move_action": {
        "title": "Déplacer l'action",
        "description": "Choisissez comment vous souhaitez déplacer cette action :",
        "move_only": "Déplacer uniquement cette action",
        "move_only_description": "L'action sera déplacée sans ses enfants",
        "move_with_children": "Déplacer l'action et tous ses enfants",
        "move_with_children_description": "Toute la branche sera déplacée ensemble"
      },
      "delete_action": {
        "title": "Supprimer l'action",
        "description": "Choisissez comment vous souhaitez supprimer cette action :",
        "delete_only": "Supprimer uniquement cette action",
        "delete_only_description": "L'action sera supprimée mais ses enfants resteront",
        "delete_with_children": "Supprimer l'action et tous ses enfants",
        "delete_with_children_description": "Toute la branche sera définitivement supprimée"
      },
      "copy_action": {
        "title": "Copier l'action",
        "description": "Choisissez comment vous souhaitez copier cette action :",
        "copy_only": "Copier uniquement cette action",
        "copy_only_description": "L'action sera copiée sans ses enfants",
        "copy_with_children": "Copier l'action et tous ses enfants",
        "copy_with_children_description": "Toute la branche sera copiée ensemble"
      },
      "context_menu": {
        "copy": "Copier",
        "delete": "Supprimer",
        "retry_failed": "Réessayer tous les échecs",
        "retry_failed_confirm": "Réessayer toutes les exécutions échouées ?",
        "retry_failed_success": "Les nouvelles tentatives ont été planifiées avec succès."
      },
      "create_scenario": "Créer le scénario",
      "delete": "Supprimer le scénario",
      "delete_confirm": "Voulez-vous supprimer ce scénario ?",
      "executions": {
        "not_found": "Scénario introuvable",
        "started": "Débuté le {{date}}",
        "status_on": "{{status}} le {{date}}",
        "statuses": {
          "cancelled": "Annulé",
          "completed": "Terminé",
          "failed": "Échec",
          "interrupted": "Interrompu",
          "pending": "En attente",
          "running": "En cours",
          "scheduled": "Planifié",
          "waiting": "En attente",
          "started": "Démarré",
          "expired": "Expiré",
          "limited": "Limite atteinte",
          "disconnected": "Déconnecté",
          "restricted": "Mis en pause par Instagram",
          "skipped": "Ignoré",
          "partially_completed": "Partiellement terminé",
          "all": "Toutes les exécutions"
        },
        "title": "Historique d'automation",
        "pending": "Scénarios en cours",
        "no_executions": "Aucun historique trouvé",
        "needs_attention": "À traiter",
        "run_now": "Lancer",
        "cancel_confirm": "Annuler cette exécution ? Elle ne pourra pas être récupérée.",
        "actions_trail": "Actions de cette exécution",
        "earlier_steps_one": "{{count}} étape précédente",
        "earlier_steps_other": "{{count}} étapes précédentes",
        "view_conversation": "Voir la conversation",
        "limited": "Le scénario n'a pas exécuté car vous avez atteint votre limite mensuelle.",
        "interrupted": "Interrompu",
        "triggered_by": "Déclenché par",
        "tests": "Tests",
        "no_tests": "Aucun test pour l'instant",
        "full_history": "Voir tout l'historique"
      },
      "live_title": "Scénario automatique",
      "manual_title": "Scénario manuel",
      "new_scenario": "Nouveau scénario",
      "name_label": "Nom",
      "pause": "Mettre en pause",
      "pause_confirm": "Voulez-vous mettre ce scénario en pause ?",
      "run": "Lancer un scénario",
      "run_confirm": "Êtes-vous sûr ?",
      "save": "Sauvegarder le scénario",
      "options": {
        "rate_limiting": {
          "title": "Limiter la fréquence par contact",
          "toggle_label": "Limiter la fréquence du scénario pour chaque contact",
          "run_scenario": "Exécuter le scénario seulement",
          "options": {
            "once": "une fois",
            "once_every": "une fois tous les"
          },
          "per_contact": "par contact"
        },
        "interrupt_on_message": {
          "title": "Interrompre lors de réponses manuelles",
          "interrupt_on_message": "Interrompre quand vous répondez manuellement",
          "interrupt_on_reply": "Interrompre quand le contact répond"
        },
        "exclude_folders": {
          "title": "Exclure certains dossiers",
          "description": "Ce scénario ne s'exécutera pas pour les contacts dans les dossiers sélectionnés"
        },
        "scenario_folder": {
          "title": "Ajouter à un dossier de scénarios",
          "select_folder": "Sélectionner un dossier",
          "priority_label": "Définir la priorité (1 = plus haute priorité)",
          "create_folder": "Créer un nouveau dossier",
          "create_folder_label": "Nom du dossier",
          "create_folder_placeholder": "Entrez le nom du dossier",
          "priority_badge": "Priorité {{priority}}"
        }
      },
      "settings": {
        "interrupt_on_message": "Interrompre quand vous répondez manuellement",
        "is_template": "Sauvegarde comme template"
      },
      "start": "Démarrer le scénario",
      "start_confirm": "Voulez-vous démarrer ce scénario ?",
      "catch_up": {
        "counting": "Recherche des commentaires passés…",
        "title": "Rattraper",
        "button": "Rattraper",
        "reached": "**{{reached}}** personnes atteintes sur {{total}}",
        "can_reach_one": "{{count}} personne peut encore le recevoir",
        "can_reach_other": "{{count}} personnes peuvent encore le recevoir",
        "expires_one": "les plus anciennes restent joignables encore {{count}} jour",
        "expires_other": "les plus anciennes restent joignables encore {{count}} jours",
        "limited": "{{count}} tiennent dans les contacts de ce mois",
        "running": "Envoi à **{{total}}** personnes",
        "running_progress": "{{done}} sur {{total}} terminés",
        "caught_up": "Tout est rattrapé : **{{count}}** personnes atteintes ces 7 derniers jours",
        "badge_one": "{{count}} à rattraper",
        "badge_other": "{{count}} à rattraper",
        "badge_tooltip": "Personnes concernées ces 7 derniers jours qui ne l'ont pas encore reçu",
        "summary_one": "**{{count}} personne** peut encore être atteinte par vos automatisations",
        "summary_other": "**{{count}} personnes** peuvent encore être atteintes par vos automatisations",
        "summary_show": "Voir",
        "modal": {
          "period": "Période",
          "window_help": "Instagram accepte les réponses aux commentaires pendant 7 jours.",
          "periods": {
            "day": "Dernières 24 heures",
            "three_days": "3 derniers jours",
            "week": "7 derniers jours"
          },
          "people_one": "{{count}} personne",
          "people_other": "{{count}} personnes",
          "never_triggered": "**{{count}}** concernées mais jamais atteintes",
          "paused": "**{{count}}** mises en pause par une déconnexion",
          "skipped": "**{{count}}** ignorées à cause de la limite de contacts",
          "contacts_left": "Utilise jusqu'à {{count}} des {{remaining}} contacts restants ce mois-ci",
          "limited": "Seules les {{count}} plus récentes tiennent dans les contacts de ce mois",
          "upgrade": "Passer à Pro",
          "confirm_one": "Envoyer à {{count}} personne",
          "confirm_other": "Envoyer à {{count}} personnes"
        }
      },
      "title": "Scénarios",
      "title_placeholder": "Entrez un titre",
      "trigger_node": {
        "ad_id": "ID de la publicité",
        "add_keyword_filter": "Ajouter un mot-clé",
        "automated_title": "Déclenchement automatique",
        "initial_keyword_filter": "Filtrer par mot-clés",
        "keyword": "Mot-clé déclencheur",
        "manual_title": "Déclenchement manuel",
        "media_username": "Nom d'utilisateur du compte",
        "on_post_by": "sur un contenu de",
        "story_id": "ID de la story",
        "when": "Quand",
        "with_intent": "Avec l'intention",
        "with_keyword": "avec le mot-clé",
        "strict_keywords_match_label": "Uniquement les DMs qui contienne un mot-clé sans autre texte"
      },
      "trigger_type": {
        "categories": {
          "comments": "Commentaires",
          "direct_messages": "Messages privés",
          "mentions": "Mentions",
          "contacts": "Contacts",
          "external": "Externe",
          "integrations": "Intégrations"
        },
        "category_descriptions": {
          "comments": "Déclencher lorsque quelqu'un interagit avec vos posts",
          "direct_messages": "Déclencher lorsque les contacts vous envoient des messages",
          "mentions": "Déclencher lorsque vous êtes tagué dans des stories ou posts",
          "contacts": "Déclencheurs liés aux créations ou modifications de contacts",
          "external": "Déclencheurs externes",
          "integrations": "Déclencher depuis des intégrations tierces"
        },
        "comment": {
          "keyword_notice": "Ajoutez ce mot-clé ou hastag n'importe où dans le texte de votre post",
          "label": "Quelqu'un commente sur votre post",
          "description": "Déclencher une automatisation quand des utilisateurs commentent vos posts",
          "options": {
            "any": "Tous les posts",
            "specific": "Un post spécifique",
            "caption_keyword": "Posts avec un mot-clé dans la description",
            "keywords": "Commentaires incluant un mot-clé"
          },
          "title": "Commentaires"
        },
        "mention_comment": {
          "label": "Quelqu'un vous mentionne en commentaire",
          "description": "Déclencher lorsque vous êtes tagué dans des commentaires",
          "title": "Mentions en commentaire"
        },
        "mention_media": {
          "label": "Quelqu'un vous mentionne dans un post",
          "description": "Déclencher lorsque vous êtes tagué dans des publications",
          "title": "Mentions en post"
        },
        "messages": {
          "keyword_notice": "Les mots-clé ignorent la casse.",
          "label": "Quelqu'un vous envoie un DM",
          "description": "Configurer des filtres pour déclencher sur des messages spécifiques",
          "scope_label": "Quels messages",
          "scope": {
            "any": "Tous les messages",
            "first_message": "Premier message uniquement"
          },
          "content_label": "Contenu du message",
          "content": {
            "any": "N'importe quel contenu",
            "keywords": "Contient un mot-clé",
            "only_emojis": "Uniquement des emojis",
            "ai_detected": "Intention détectée par l'IA"
          },
          "content_descriptions": {
            "any": "Aucun filtre sur le contenu du message",
            "keywords": "Uniquement les messages contenant l'un des mots-clés définis",
            "only_emojis": "Uniquement les messages composés d'emojis, sans texte",
            "ai_detected": "Uniquement les messages correspondant à une intention que vous décrivez"
          },
          "preview": {
            "keywords": "message contenant {{keywords}}",
            "any": "n'importe quel message",
            "matched": "Déclenche",
            "grouping_notice": "Les messages envoyés coup sur coup sont regroupés.",
            "conversation": {
              "first": "Bonjour !",
              "second": "C'est toujours disponible ?",
              "third": "Et vous livrez en Espagne ?",
              "reply": "Merci pour votre message ! 👋"
            },
            "outgoing": {
              "manual": "Bonjour ! J'ai adoré votre dernier post 👋",
              "automated": "Vous acceptez de nouvelles collabs ce mois-ci ?"
            }
          },
          "title": "Messages",
          "options_label": "Filtrer les messages"
        },
        "outgoing_message": {
          "keyword_notice": "Les mots-clé sont sensibles à la casse. Les DMs automatiques ne déclenchent pas le scénario.",
          "label": "Vous envoyez un DM à quelqu'un",
          "description": "Configurer des filtres pour déclencher sur des messages spécifiques",
          "options": {
            "any": "N'importe quel message",
            "keywords": "Les messages avec un mot-clé"
          },
          "title": "Messages sortant",
          "sent_from": {
            "label": "Déclencher sur les messages envoyés",
            "instagram": "Manuellement depuis Instagram",
            "inbox": "Manuellement depuis Inrō",
            "agent": "Par l'Agent IA",
            "automation": "Par des automatisations",
            "api": "Par l'API ou MCP"
          }
        },
        "referral_ad": {
          "label": "Quelqu'un répond à votre publicité",
          "description": "Déclencher lorsque des utilisateurs répondent à vos publicités Meta",
          "options_label": "Type de correspondance",
          "options_description": "Choisissez comment identifier la publicité qui déclenche ce scénario",
          "options": {
            "keywords": "Réponses qui incluent un mot-clé",
            "ad_id": "ID spécifique"
          },
          "title": "Réponse aux publicités",
          "notice": "Vous pouvez trouver cette information dans votre Gestionnaire de Publicité Meta.",
          "option_label": "Identifier votre publicité",
          "help_title": "Besoin d'aide ?",
          "help_description": "L'interface de Meta peut être compliquée donc n'hésitez pas à lire l'article suivant ou à nous contacter directement.",
          "preview": {
            "title": "Message {{username}}",
            "greeting": "Bonjour ! Faites-nous savoir comment nous pouvons vous aider.",
            "write_message": "Écrivez votre propre message",
            "example_question_1": "Où êtes-vous situé ?",
            "example_question_2": "Pouvez-vous vérifier le prix d'un produit ?",
            "example_question_3": "Puis-je effectuer un achat ?",
            "ad_notice": "Vous avez ouvert cette conversation via une publicité. En répondant, {{username}} pourra voir vos informations publiques et la publicité sur laquelle vous avez cliqué."
          },
          "welcome_flow": {
            "label": "Message de bienvenue",
            "options_description": "Configurez le message que les utilisateurs voient lorsqu'ils cliquent sur votre publicité Instagram",
            "greeting_label": "Message d'accueil",
            "greeting_placeholder": "Saisissez un message d'accueil pour les utilisateurs qui cliquent sur votre publicité...",
            "quick_replies_label": "Boutons de réponse rapide",
            "help_title": "Qu'est-ce qu'un message de bienvenue ?",
            "help_description": "Lorsque quelqu'un clique sur votre publicité Instagram et ouvre une DM, il verra votre message d'accueil et vos boutons de réponse rapide. Après avoir créé ce flux, associez-le à votre publicité dans le Gestionnaire de Publicités Meta.",
            "greeting_missing": "Aucun message d'accueil défini",
            "quick_reply_placeholder": "Texte du bouton (20 caractères max)"
          }
        },
        "story_mention": {
          "label": "Quelqu'un vous mentionne en story",
          "description": "Déclencher lorsque vous êtes tagué dans des stories Instagram",
          "title": "Mentions en story",
          "options_label": "Filtrer les stories",
          "options_description": "Configurez des filtres pour ne déclencher le scénario que sur certaines mentions en story",
          "options": {
            "any": "Toute story qui vous mentionne",
            "keywords": "Stories avec un ou des mots-clés visibles",
            "visual_ai": "Stories montrant quelque chose"
          },
          "keyword_notice": "Le mot-clé doit être **clairement visible** dans toute la story.",
          "visual_condition_label": "Ce que montre la story",
          "options_descriptions": {
            "any": "Aucun filtre sur la story où vous êtes mentionné",
            "keywords": "Uniquement les stories où un mot-clé est lisible",
            "visual_ai": "Uniquement les stories dont le visuel correspond à votre description"
          }
        },
        "story_reply": {
          "keyword_notice": "Ajoutez une URL n'importe où en texte dans vos stories. Vous devez créer la story dans l'app Instagram.",
          "label": "Quelqu'un répond à votre story",
          "description": "Déclencher lorsque des utilisateurs répondent à vos stories",
          "options_label": "Filtrer les réponses",
          "options_description": "Configurez des filtres pour déclencher le scénario seulement sur certaines réponses à vos stories",
          "story_label": "Quelle story",
          "story": {
            "any": "N'importe quelle story",
            "caption_keyword": "La légende contient un mot-clé",
            "caption_url": "La légende contient une URL",
            "specific": "Une story spécifique",
            "visual_ai": "Stories montrant quelque chose"
          },
          "story_descriptions": {
            "any": "Aucun filtre sur la story à laquelle on répond",
            "caption_keyword": "Uniquement les stories dont la légende contient un mot-clé défini",
            "caption_url": "Uniquement les stories dont la légende contient une URL",
            "visual_ai": "Uniquement les stories dont le visuel correspond à votre description"
          },
          "content_label": "Contenu de la réponse",
          "content": {
            "any": "N'importe quel contenu",
            "keywords": "Contient un mot-clé",
            "only_emojis": "Uniquement des emojis",
            "ai_detected": "Intention détectée par IA"
          },
          "content_descriptions": {
            "any": "Aucun filtre sur le contenu de la réponse",
            "keywords": "Uniquement les réponses contenant l'un des mots-clés définis",
            "only_emojis": "Uniquement les réponses composées d'un seul emoji, sans texte",
            "ai_detected": "Uniquement les réponses correspondant à une intention que vous décrivez"
          },
          "caption_url_any": "N'importe quelle URL",
          "title": "Réponses aux stories",
          "ai_intent_label": "Décrivez l'intention de la réponse",
          "ai_intent_notice": "Soyez aussi précis et spécifique que possible pour de meilleurs résultats.",
          "ai_intent_warning": "Les intentions détectées par IA peuvent ne pas toujours être précises.",
          "preview": {
            "keywords": "réponse contenant {{keywords}}",
            "ai_intent_missing": "Réponse avec une intention"
          },
          "visual_condition_label": "Ce que montre la story"
        },
        "referral": {
          "icebreaker": "Prise de contact",
          "icebreaker_notice": "Les prises de contacts sont des suggestions de messages que voient vos contacts la première fois qu'ils ouvrent la conversation.",
          "label": "Quelqu'un clique sur un lien réferré",
          "description": "Déclencher lorsque des utilisateurs cliquent sur vos liens ou scannent des QR codes",
          "options": {
            "any": "Tous les liens referrés",
            "ref_code": "Lien avec une ref spécifique"
          },
          "title": "Lien referré",
          "copy_link": "Copier le lien",
          "link_notice": "Les liens ouvrent la conversation avec vous sur Instagram. <0>En savoir plus</0>",
          "qr_code": "Générer QR code",
          "qr_code_notice": "Demandez à vos contacts de scanner ce QR code pour vous parler sur Instagram.",
          "qr_code_trigger": "Quelqu'un scanne un QR code",
          "wildcard_hint": "Utilisez * comme caractère générique : campaign_* correspond à campaign_summer, campaign_winter, etc."
        },
        "webhook": {
          "label": "Un webhook est déclenché",
          "description": "Déclencher via des appels d'API externes et intégrations",
          "title": "Webhooks",
          "notice": "Vous devez envoyer une requête POST avec un paramètre pour identifier le contact.",
          "placeholder": "URL du webhook disponible après la sauvegarde"
        },
        "title": "Changer le déclencheur",
        "folder": {
          "label": "Un contact est ajouté à un dossier",
          "description": "Déclencher lorsque des contacts sont organisés dans des dossiers",
          "select_folder": "Sélectionner le dossier",
          "title": "Dossier"
        },
        "contact_create": {
          "label": "Un contact est créé",
          "description": "Déclencher lorsqu'un nouveau contact est créé",
          "title": "Contact créé",
          "status_label": "Statut du contact",
          "status_options": {
            "all": "Tous les contacts",
            "active": "Contacts actifs uniquement"
          }
        },
        "contact_update": {
          "label": "Un contact est mis à jour",
          "description": "Déclencher lorsque les attributs, dossiers ou propriétés d'un contact changent",
          "title": "Contact mis à jour",
          "status_label": "Statut du contact",
          "status_options": {
            "all": "Tous les contacts",
            "active": "Contacts actifs uniquement",
            "all_notice": "Vous pouvez envoyer des DMs uniquement aux contacts actifs"
          }
        },
        "recurring": {
          "label": "Sur une base récurrente",
          "description": "Déclencher automatiquement à intervalles réguliers pour une audience sélectionnée",
          "title": "Planification récurrente",
          "options_description": "Choisissez la fréquence d'exécution de ce scénario et les contacts concernés",
          "schedule_label": "Planification",
          "frequency_label": "Fréquence",
          "time_label": "Heure",
          "day_of_week_label": "Jour de la semaine",
          "day_of_month_label": "Jour du mois",
          "only_new_contacts_label": "Uniquement les nouveaux contacts correspondant aux filtres",
          "only_new_contacts_badge": "Nouveaux contacts uniquement",
          "audience_label": "Audience",
          "audience_description": "Sélectionnez les contacts pour lesquels ce scénario doit s'exécuter à chaque occurrence",
          "all_contacts": "Tous les contacts",
          "filters_count": "{{count}} filtre",
          "filters_count_plural": "{{count}} filtres",
          "add_filter": "Ajouter un filtre",
          "summary": {
            "daily": "Tous les jours à {{time}}",
            "weekly": "Chaque {{day}} à {{time}}",
            "monthly": "Le {{day}} de chaque mois à {{time}}"
          },
          "frequencies": {
            "daily": "Quotidienne",
            "weekly": "Hebdomadaire",
            "monthly": "Mensuelle"
          },
          "days_of_week": {
            "0": "Dimanche",
            "1": "Lundi",
            "2": "Mardi",
            "3": "Mercredi",
            "4": "Jeudi",
            "5": "Vendredi",
            "6": "Samedi"
          }
        },
        "custom_event": {
          "label": "Un Évenement est déclenché",
          "select_event": "Choisir l'événement",
          "title": "Événement externe"
        },
        "live_comment": {
          "label": "Quelqu'un commente sur votre Live",
          "description": "Déclencher une automatisation pendant des streams vidéo en direct",
          "options": {
            "any": "Tous les commentaires",
            "keywords": "Commentaires avec un mot-clé"
          },
          "title": "Commentaires Live"
        },
        "icebreaker": {
          "label": "Quelqu'un clique sur un ice breaker",
          "description": "Déclencher lorsque des utilisateurs sélectionnent un message d'accroche",
          "notice": "Les ice breakers sont proposés la première fois que quelqu'un vous contacte.",
          "select_icebreaker": "Choisir un ice breaker",
          "no_icebreaker": "Aucun ice breaker sélectionné",
          "title": "Ice breaker"
        },
        "shopify_orders_create": {
          "label": "Une commande Shopify est créée",
          "description": "Déclencher lors de la création d'une nouvelle commande dans votre boutique Shopify",
          "title": "Commande Shopify créée",
          "contact_matching_notice": "Les contacts sont associés aux commandes Shopify par adresse e-mail. Si aucune correspondance n'est trouvée, Inro recherche un paramètre `inro_id` ou `username` dans l'URL de la page d'atterrissage de la commande."
        },
        "visual_condition": {
          "placeholder": "ex : montre une de nos baskets",
          "notice": "Soyez précis : *une basket rouge sur fond blanc* vaut mieux que *notre produit*.",
          "warning": "La reconnaissance visuelle peut se tromper. Ajustez selon les résultats.",
          "examples": [
            "un de nos produits",
            "une confirmation de commande",
            "quelqu'un qui porte notre marque",
            "une photo au restaurant"
          ]
        }
      },
      "triggers": {
        "add_trigger": "Ajouter un déclencheur",
        "no_triggers": "Pas de déclencheurs",
        "triggered_by": "Déclenché par"
      },
      "autodelay_notice": "L'action est retardée automatiquement de 5 secondes",
      "count_one": "{{count}} scénario",
      "count_other": "{{count}} scénarios",
      "create_first": "Créer votre premier scénario",
      "edit": "Modifier le scénario",
      "no_scenarios": "Vous n'avez encore aucun scénario.",
      "table": {
        "columns": {
          "conversions": "Conversions",
          "executions": "Exécutions",
          "last_updated": "Modifié le",
          "status": "Statut",
          "title": "Titre",
          "name": "Nom",
          "last_executed": "Exécuté",
          "triggers": "Déclencheurs",
          "updated_at": "Modifié",
          "last_executed_at": "Exécuté",
          "scenario_type": "Type"
        },
        "items": {
          "last_7_days": "{{count}} les 7 derniers jours",
          "no_conversion": "Pas d'action de conversion",
          "total": "{{count}} en tout"
        }
      },
      "metrics": {
        "conversions_help": "Tous les clics sur des liens de conversion sont comptés comme des conversions",
        "conversions_one": "conversion",
        "conversions_other": "conversions",
        "executions_one": "exécution",
        "executions_other": "exécutions",
        "last_7_days": "7 derniers jours",
        "total": "Total"
      },
      "share": "Partager le scénario",
      "comment_to_dm": {
        "question": {
          "modes": {
            "button_template": "Message avec bouton",
            "message": "Message simple"
          },
          "message_label": "Votre message",
          "message_placeholder": "Merci pour ton commentaire ! Tu veux que je t'envoie le lien ? Réponds simplement à ce message.",
          "message_notice": "Le lien est envoyé dès que le contact répond"
        },
        "follow_up": {
          "enabled_label": "Envoyer une relance"
        },
        "review": {
          "title": "Vérifiez votre scénario",
          "description": "Assurez-vous que tout est bien configuré",
          "test_scenario": "Tester votre scénario",
          "select_contact": "Sélectionner un contact",
          "activate_scenario": "Activer le scénario",
          "deactivate_scenario": "Désactiver le scénario",
          "view_insights": "Voir les statistiques",
          "activate_scenario_notice": "Activez le scénario pour le déclencher sur les commentaires existants"
        }
      },
      "remove_from_folder": "Retirer du dossier",
      "view_history": "Voir l'historique",
      "empty_scenario": "Scénario vide",
      "empty_scenario_description": "Créer votre scénario à partir de zéro",
      "template": "Modèle",
      "title_label": "Nom du scénario",
      "action_executions": {
        "details": {
          "http_request": "Requête",
          "http_response": "Réponse",
          "rerun": "Relancer",
          "request": "Requète",
          "response": "Réponse",
          "view_details": "Voir les détails",
          "title": "Détails de l'exécution"
        },
        "status": {
          "started": "Démarré",
          "scheduled": "Planifié",
          "waiting": "En attente",
          "expired": "Expiré",
          "running": "En cours",
          "completed": "Terminé",
          "interrupted": "Interrompu",
          "failed": "Échoué",
          "cancelled": "Annulé",
          "skipped": "Ignoré"
        },
        "outcome": {
          "empty_value": "Vide",
          "waiting_until": "Expire le {{date}}",
          "continued_at": "A continué le {{date}}",
          "added_to": "Ajouté à",
          "removed_from": "Retiré de",
          "property_set": "{{property}} défini sur",
          "opted_out": "Contact désinscrit",
          "opted_in": "Contact réinscrit",
          "comment_hidden": "Commentaire masqué",
          "content_passed": "Aucun discours haineux ni spam détecté",
          "value_checked": "Valeur vérifiée",
          "ai_credits_exhausted": "Crédits IA épuisés : la condition n'a pas été évaluée.",
          "collected": "Enregistré dans {{property}}",
          "view_run": "Voir l'exécution",
          "not_started": {
            "suspended": "Non lancé : le scénario est suspendu.",
            "disconnected": "Non lancé : le compte Instagram est déconnecté.",
            "rate_limited": "Non lancé : le scénario a déjà été exécuté récemment pour ce contact.",
            "excluded_folder": "Non lancé : le contact est dans un dossier exclu de ce scénario.",
            "excluded_filter": "Non lancé : le contact correspond à un filtre d'exclusion.",
            "already_running": "Non lancé : cette exécution l'a déjà lancé."
          },
          "agent_task": "Tâche",
          "replied_to": "En réponse à",
          "agent_reply": "Réponse",
          "handover_completed": "Tâche terminée le {{date}}",
          "handover_expired": "Prise en charge terminée le {{date}}",
          "handover_checks_one": "Tâche vérifiée une fois, pas encore terminée",
          "handover_checks_other": "Tâche vérifiée {{count}} fois, pas encore terminée"
        }
      },
      "generation_status": {
        "title": "Génération de votre scénario",
        "phase_prompts": "Analyse de votre demande",
        "phase_triggers": "Construction des déclencheurs",
        "phase_actions": "Construction des actions",
        "error_generic": "Une erreur est survenue"
      },
      "suspended_status": {
        "title": "Automatisation suspendue",
        "message_before": "Cette automatisation a été suspendue pour non-respect de nos ",
        "message_after": " et ne peut plus s'exécuter, être modifiée ou copiée.",
        "terms_of_service": "conditions d'utilisation",
        "contact_support_before": "Si vous pensez qu'il s'agit d'une erreur, contactez ",
        "contact_support_email": "support@inroapp.com",
        "contact_support_after": " pour faire appel de cette décision."
      },
      "limit_reached": "Limite atteinte",
      "limit_reached_tooltip_one": "{{ count }} exécution n'a pas été déclenchée car vous avez atteint votre limite mensuelle",
      "limit_reached_tooltip_other": "{{ count }} exécutions n'ont pas été déclenchées car vous avez atteint votre limite mensuelle",
      "unsaved_changes": "Modifications non enregistrées",
      "unsaved_changes_kept": "Vous avez des modifications non enregistrées. Elles seront conservées comme brouillon jusqu'à ce que vous les enregistriez ou les annuliez. Fermer le scénario ?",
      "limited_executions_one": "<0>{{ count }} scénario</0> n'a pas été déclenché car vous avez atteinte votre limite mensuelle.",
      "limited_executions_other": "<0>{{ count }} scénarios</0> n'ont pas été déclenchés car vous avez atteinte votre limite mensuelle",
      "trigger_executions": "Gérer les exécutions limitées",
      "disconnected_badge": "Déconnecté",
      "disconnected_badge_tooltip_one": "{{ count }} exécution a été mise en pause car votre compte Instagram était déconnecté",
      "disconnected_badge_tooltip_other": "{{ count }} exécutions ont été mises en pause car votre compte Instagram était déconnecté",
      "disconnected_executions_one": "<0>{{ count }} exécution</0> a été mise en pause car votre compte Instagram était déconnecté",
      "disconnected_executions_other": "<0>{{ count }} exécutions</0> ont été mises en pause car votre compte Instagram était déconnecté",
      "reconnect_to_run": "Reconnecter Instagram",
      "run_disconnected_executions": "Lancer les exécutions en pause",
      "no_scenarios_help": "Par où commencer ?\n<0>Voici quelques idées</0> pour démarrer !",
      "test_sent": "Votre test a démarré.",
      "edit_with_agent": {
        "title": "Vous utilisez un assistant IA?",
        "description": "Modifiez ce scénario depuis Claude ou ChatGPT grâce à notre serveur MCP.",
        "cta": "Connecter un assistant"
      },
      "run_test_confirm": "Tester le scénario avec ce contact ?",
      "run_test": "Tester le scénario",
      "cancel_copy": "Annuler la copie",
      "select_scenario": "Choisir un scénario",
      "search_scenarios": "Chercher dans les scénarios",
      "warnings": {
        "title": "Avertissements",
        "suggestion": "Suggestion",
        "issue": "Problème",
        "issues_notice": "Cette automatisation a des problèmes non résolus qui pourraient l'empêcher de fonctionner comme prévu.",
        "view_issues": "Voir les problèmes",
        "activate_confirm": {
          "title": "Cette automatisation a encore des problèmes non résolus",
          "body": "Vous pouvez l'activer quand même, mais ces problèmes pourraient l'empêcher de fonctionner comme prévu.",
          "confirm": "Activer quand même",
          "cancel": "Retour",
          "triggers_label": "Déclencheurs",
          "steps_label": "Étapes"
        }
      },
      "current_scenario": "Scénario actuel",
      "duplicate_title": "Dupliquer le scénario vers",
      "not_found": "Scénario introuvable",
      "view_insights": "Résultats",
      "suspended_badge": "Suspendu",
      "suspended_badge_tooltip": "Cette automatisation a été suspendue pour violation de nos conditions d'utilisation et ne peut plus être exécutée",
      "new_scenario_dialog": {
        "existing": {
          "title": ""
        }
      },
      "view_scenario": "Voir le scénario",
      "test_scenario": {
        "title": "Envoyez ce code en DM ou en commentaire pour tester le scénario",
        "or_select_contact": "ou choisissez un contact"
      },
      "search_no_results": "Aucun scénario trouvé",
      "generation_prompt": {
        "title": "Que voulez-vous automatiser ?",
        "placeholder": "Envoyer le lien de réservation à ceux qui écrivent RESA en DM",
        "example": "Essayez : Dire merci quand quelqu'un me mentionne dans sa story",
        "example_prompt": "Quand quelqu'un me mentionne dans sa story, le remercier et envoyer un code de réduction",
        "button": "Générer l'automatisation"
      },
      "classification": {
        "refuse": {
          "title": "Ce n'est pas possible",
          "alternatives_label": "Démarrez plutôt l'une de celles-ci",
          "back": "Écrire autre chose",
          "patterns": {
            "rate_limited": "Vous avez atteint la limite de générations IA pour le moment. Réessayez plus tard, ou créez cette automatisation vous-même.",
            "new_follower_unsupported": "Instagram ne nous signale jamais un nouvel abonné. Mais vous pouvez démarrer l'une de celles-ci à la place.",
            "bulk_outbound_unsupported": "Instagram n'autorise l'envoi qu'aux personnes qui vous ont écrit en premier. Mais vous pouvez démarrer l'une de celles-ci à la place.",
            "engagement_unsupported": "Instagram ne nous transmet pas les likes. Mais vous pouvez démarrer l'une de celles-ci à la place."
          },
          "campaign_badge": "Campagne"
        },
        "route": {
          "back": "Écrire autre chose",
          "targets": {
            "agent_trigger_rules": {
              "title": "Votre agent IA s'en occupe",
              "description": "Répondre à tous les DM est une règle de déclenchement de l'agent, pas un scénario.",
              "cta": "Ouvrir les réglages de l'agent"
            },
            "agent_handover": {
              "title": "Votre agent IA s'en occupe",
              "description": "Passer une conversation à un humain est une règle de transfert de l'agent.",
              "cta": "Ouvrir les règles de transfert"
            },
            "campaigns": {
              "title": "Les campagnes s'en occupent",
              "description": "Écrire à une liste de personnes d'un coup, c'est le rôle des campagnes.",
              "cta": "Ouvrir les campagnes"
            },
            "content": {
              "title": "La publication se fait dans Contenu",
              "description": "Créez et programmez vos posts et stories depuis la page Contenu. Les automatisations y réagissent une fois publiés.",
              "cta": "Ouvrir Contenu"
            }
          }
        },
        "decline": {
          "notice": "Ce n'est pas pris en charge, décrivez plutôt une automatisation Instagram."
        },
        "clarify": {
          "trigger_label": "Déclencheur",
          "outcome_label": "Ce qui doit se passer",
          "outcome_placeholder": "Demander l'e-mail puis envoyer un lien vers le site",
          "submit": "Continuer",
          "back": "Recommencer",
          "triggers": {
            "comment": "Quand quelqu'un commente « {{keyword}} » sous un post",
            "dm": "Quand quelqu'un vous écrit « {{keyword}} » en DM"
          },
          "url": {
            "share": {
              "question": "Ajouter cette automatisation partagée à votre compte ?",
              "cta": "L'ajouter à mon compte"
            },
            "own": {
              "question": "Ceci est l'une de vos automatisations.",
              "duplicate": "La dupliquer",
              "open": "L'ouvrir"
            },
            "destination": {
              "question": "Qu'est-ce qui doit envoyer ce lien ?",
              "placeholder": "Quand quelqu'un écrit GUIDE en DM"
            },
            "alternative": "Créer autre chose"
          }
        },
        "status": {
          "title": "Aucune automatisation n'a été créée",
          "prompt_label": "Votre demande",
          "edit_cta": "Modifier la demande"
        }
      },
      "mcp_preview": {
        "active": "Actif",
        "inactive": "Inactif",
        "steps_one": "{{count}} étape",
        "steps_other": "{{count}} étapes",
        "warnings_one": "{{count}} avertissement",
        "warnings_other": "{{count}} avertissements",
        "expand": "Agrandir",
        "open": "Ouvrir dans Inrō",
        "error": "Ce scénario ne peut pas être affiché ici.",
        "too_large": "Ce scénario est trop volumineux pour être affiché ici.",
        "outdated": "Reconnectez Inrō pour afficher ce scénario.",
        "campaign_status": {
          "draft": "Brouillon",
          "running": "En cours d'envoi",
          "completed": "Envoyée",
          "scheduled": "Programmée",
          "limited": "Limitée",
          "canceled": "Annulée",
          "disconnected": "Déconnectée"
        },
        "campaign_error": "Cette campagne ne peut pas être affichée ici.",
        "campaign_too_large": "Cette campagne est trop volumineuse pour être affichée ici.",
        "campaign_outdated": "Reconnectez Inrō pour afficher cette campagne.",
        "recipients": "Sera envoyée à",
        "contacts_one": "contact",
        "contacts_other": "contacts",
        "count_unavailable": "Nombre indisponible",
        "included": "Inclus",
        "excluded": "Exclus",
        "all_contacts": "Tous les contacts",
        "selected_contacts": "Contacts sélectionnés",
        "contact_filters": "Filtres de contacts",
        "folder": "Dossier",
        "segment": "Segment"
      }
    },
    "variables": {
      "contact": {
        "fields": {
          "email": "Email",
          "follower_count": "Nombre de followers",
          "id": "ID du contact",
          "name": "Nom",
          "phone": "Téléphone",
          "profile_picture": "URL de la photo de profil",
          "username": "Nom d'utilisateur"
        },
        "field_descriptions": {
          "id": "Identifiant unique de ce contact",
          "name": "Nom d'affichage du contact",
          "username": "Pseudo Instagram du contact",
          "email": "Adresse email du contact",
          "phone": "Numéro de téléphone du contact",
          "follower_count": "Nombre d'abonnés Instagram",
          "profile_picture": "Lien vers la photo de profil"
        },
        "title": "Informations du contact",
        "description": "Insérer les informations du contact dans vos messages et scénarios."
      },
      "organization": {
        "title": "Informations du compte",
        "description": "Insérez les informations de votre compte.",
        "fields": {
          "username": "Nom d'utilisateur",
          "name": "Nom",
          "inro_id": "ID Inrō"
        },
        "field_descriptions": {
          "username": "Votre pseudo Instagram",
          "name": "Nom d'affichage de votre compte",
          "inro_id": "Votre identifiant unique Inrō"
        }
      },
      "trigger": {
        "fields": {
          "comment": "Commentaire déclencheur",
          "date": "Date et heure actuels",
          "message": "Message déclencheur",
          "ref": "Code ref",
          "media_caption": "Légende du post",
          "caption_url": "URL de la légende du post",
          "caption_keyword": "Mot-clé correspondant dans la légende",
          "comment_keyword": "Mot-clé correspondant dans le commentaire",
          "story_caption": "Légende de la story",
          "story_text": "Texte extrait du visuel de la story"
        },
        "field_descriptions": {
          "message": "Le message qui a déclenché ce scénario",
          "comment": "Le commentaire qui a déclenché ce scénario",
          "date": "Date et heure d'exécution du scénario",
          "ref": "Code de parrainage transmis via le lien",
          "media_caption": "Légende du post qui a déclenché ce scénario",
          "caption_url": "URL extraite de la légende du post",
          "caption_keyword": "Le mot-clé trouvé dans la légende du post",
          "comment_keyword": "Le mot-clé trouvé dans le commentaire",
          "story_caption": "Texte de la légende de la story en réponse",
          "story_text": "Texte extrait du visuel de la story mentionnée"
        },
        "title": "Informations du scénario",
        "description": "Ces variables apparaîtront uniquement dans le contexte d'une automation."
      },
      "conversation": {
        "title": "Informations de la conversation",
        "description": "Ces variables sont liées à la conversation en cours avec le contact.",
        "fields": {
          "last_message": "Dernier message",
          "last_message_received": "Dernier message reçu",
          "last_message_sent": "Dernier message envoyé",
          "last_message_date": "Date du dernier message"
        },
        "field_descriptions": {
          "last_message": "Le message le plus récent dans la conversation",
          "last_message_received": "Le dernier message reçu du contact",
          "last_message_sent": "Le dernier message envoyé au contact",
          "last_message_date": "Date et heure du message le plus récent"
        }
      },
      "mention": {
        "title": "Informations de la mention",
        "description": "Ces variables apparaîtront uniquement si le scénario est déclenché par une mention.",
        "fields": {
          "text": "Texte de la mention",
          "media_caption": "Légende du post",
          "media_url": "URL du média",
          "media_permalink": "Lien permanent du post",
          "media_username": "Nom d'utilisateur de l'auteur"
        },
        "field_descriptions": {
          "text": "Le contenu textuel de la mention",
          "media_caption": "Légende du post où vous avez été mentionné",
          "media_url": "URL du média dans le post où vous avez été mentionné",
          "media_permalink": "Lien permanent vers le post où vous avez été mentionné",
          "media_username": "Nom d'utilisateur de l'auteur du post"
        }
      },
      "webhook": {
        "fields": {
          "body": "Corps du webhook",
          "url": "URL du webhook"
        },
        "field_descriptions": {
          "url": "URL qui a envoyé la requête webhook",
          "body": "Corps brut de la charge utile du webhook"
        },
        "title": "Informations du webhook",
        "description": "Ces variables apparaîtront uniquement is le scénario est déclenché par un webhook."
      },
      "learn_more": "En savoir plus sur les variables",
      "search_placeholder": "Rechercher des variables...",
      "no_results": "Aucune variable ne correspond à votre recherche.",
      "column_name": "Variable",
      "column_code": "Code",
      "column_description": "Description",
      "survey": {
        "description": "Ces variables apparaitront uniquement après qu'un sondage soit complété. Remplacer '0' par l'index de la question.",
        "fields": {
          "date": "Date de complétion",
          "option.title": "Titre de l'option choisie",
          "option.replies": "Nombre de fois que l'option a été choisie",
          "option.percentage": "Pourcentage ayant choisi cette option"
        },
        "field_descriptions": {
          "date": "Date à laquelle la réponse a été soumise",
          "option.title": "Nom de l'option sélectionnée par le contact",
          "option.replies": "Nombre total de fois que cette option a été choisie",
          "option.percentage": "Part des répondants ayant choisi cette option"
        },
        "title": "Complétion du sondage"
      },
      "questions_survey": {
        "description": "Ces variables apparaîtront uniquement après une réponse à un sondage.",
        "fields": {
          "date": "Date de réponse",
          "question_0.title": "Titre de la première question",
          "question_0.reply": "Réponse à la première question"
        },
        "field_descriptions": {
          "date": "Date à laquelle le sondage a été complété",
          "question_0.title": "Le texte de la première question",
          "question_0.reply": "La réponse donnée à la première question"
        },
        "title": "Réponse au sondage"
      },
      "shopify_order": {
        "title": "Commande Shopify",
        "description": "Ces variables sont disponibles lorsque le scénario est déclenché par une commande Shopify.",
        "fields": {
          "order_number": "Numéro de commande",
          "total_price": "Prix total",
          "subtotal_price": "Sous-total",
          "currency": "Devise",
          "financial_status": "Statut du paiement",
          "created_at": "Date de commande",
          "customer.first_name": "Prénom du client",
          "customer.last_name": "Nom du client",
          "customer.email": "Email du client"
        },
        "field_descriptions": {
          "order_number": "Numéro unique identifiant cette commande (ex. #1001)",
          "total_price": "Montant total facturé, taxes et livraison incluses",
          "subtotal_price": "Sous-total de la commande avant taxes et livraison",
          "currency": "Code de devise à trois lettres (ex. EUR)",
          "financial_status": "Statut du paiement de la commande (ex. payé, en attente)",
          "created_at": "Date et heure auxquelles la commande a été passée",
          "customer.first_name": "Prénom du client",
          "customer.last_name": "Nom du client",
          "customer.email": "Adresse email du client"
        }
      },
      "shopify_cart": {
        "title": "Panier abandonné Shopify",
        "description": "Ces variables sont disponibles lorsque le scénario est déclenché par un panier abandonné.",
        "fields": {
          "abandoned_checkout_url": "URL de récupération du panier",
          "total_price": "Total du panier",
          "subtotal_price": "Sous-total du panier",
          "currency": "Devise",
          "created_at": "Date de création du panier",
          "email": "Email du client"
        },
        "field_descriptions": {
          "abandoned_checkout_url": "URL unique permettant au client de récupérer son panier",
          "total_price": "Valeur totale du panier, taxes et livraison incluses",
          "subtotal_price": "Sous-total du panier avant taxes et livraison",
          "currency": "Code de devise à trois lettres (ex. EUR)",
          "created_at": "Date et heure de création du panier",
          "email": "Adresse email du client ayant abandonné le panier"
        }
      },
      "button": {
        "title": "Clic sur bouton de carte",
        "description": "Ces variables apparaîtront uniquement après un clic sur un bouton de carte. Correspond au dernier bouton cliqué.",
        "fields": {
          "label": "Libellé du bouton",
          "payload": "Payload du bouton",
          "card_title": "Titre de la carte",
          "card_text": "Texte de la carte"
        },
        "field_descriptions": {
          "label": "Le texte affiché sur le bouton cliqué",
          "payload": "Le payload postback du bouton cliqué",
          "card_title": "Le titre de la carte dont le bouton a été cliqué",
          "card_text": "Le sous-titre de la carte dont le bouton a été cliqué"
        }
      }
    },
    "scenario_insights": {
      "filter_by_date": "Filtrer par date"
    },
    "scenario_folders": {
      "new_folder": "Nouveau dossier",
      "breadcrumb_root": "Scénarios",
      "types": {
        "priority": "Dossier priorité",
        "normal": "Dossier normal"
      },
      "type_descriptions": {
        "priority": "Un seul scénario peut être déclenché à la fois.",
        "normal": "Tous les scénarios s'exécutent indépendamment."
      },
      "type_label": "Type de dossier",
      "name_label": "Nom du dossier",
      "name_placeholder": "Entrer le nom du dossier",
      "create_title": "Créer un dossier",
      "edit_title": "Modifier le dossier",
      "delete_title": "Supprimer \"{{name}}\"",
      "scenario_count": "{{count}} scénario",
      "scenario_count_one": "{{count}} scénario",
      "scenario_count_other": "{{count}} scénarios",
      "delete_prompt": "Ce dossier contient {{count}} scénario(s). Que doit-il leur arriver ?",
      "delete_ungroup": "Conserver les scénarios",
      "delete_ungroup_description": "Les scénarios seront retirés du dossier.",
      "delete_scenarios": "Supprimer les {{count}} scénarios du dossier",
      "delete_scenarios_description": "Tous les scénarios de ce dossier seront supprimés définitivement.",
      "delete_empty_prompt": "Confirmer la suppression de ce dossier ?",
      "drag_hint": "Déposer ici pour ajouter au dossier",
      "priority_set_by_order": "La priorité est définie par l'ordre de glisser-déposer dans la vue du dossier",
      "all_scenarios": "Tous les scénarios",
      "folder_empty": "Ce dossier est vide",
      "start_confirm": "Voulez-vous activer tous les scénarios de ce dossier ?",
      "pause_confirm": "Voulez-vous mettre en pause tous les scénarios de ce dossier ?",
      "duplicate_confirm": "Dupliquer ce dossier et ses {{count}} scénario(s) ?"
    }
  },
  "calendar": {
    "calendars": {
      "connect_button": "Connecter un compte Google",
      "connect_description": "Vous pouvez connecter un compte Google Agenda pour voir vos disponibilités et sauvegarder vos rendez-vous.",
      "connect_title": "Connecter ses agendas",
      "connect_tooltip": "Connectez votre Google Agenda",
      "make_primary_description": "Ceci est l'agenda où vos rendez-vous seront sauvegardés automatiquement. vous pouvez le modifier à tout moment.",
      "make_primary_title": "Agenda par défaut",
      "manage_description": "Afficher et cacher vos agendas et sélectionner l'agenda par défaut.",
      "manage_title": "Gestion des agendas"
    },
    "details": {
      "cancel_all_propositions": "Annuler les propositions",
      "confirm_slot": "Confirmer ce créneau",
      "edit_appointment": "Modifier le rendez-vous",
      "remove_payment": "Retirer le paiement",
      "remove_slot": "Retirer ce créneau",
      "sent_on": "Envoyé le {{date}}",
      "timezone_warning": "Ce rendez-vous a été créé dans un autre fuseau horaire. Les horaires ci-dessous sont pour : {{zone}}.",
      "title": "Détails du rendez-vous"
    },
    "duration": {
      "label": "Durée",
      "title": "Durée du créneau"
    },
    "empty_state": {
      "button": "Paramétrer les rendez-vous",
      "description": "Envoyez des propositions de rendez-vous ou paramétrer votre agenda pour démarrer.",
      "title": "Aucun rendez-vous !"
    },
    "help": {
      "text": "Vous pouvez envoyer des propositions de rendez-vous à vos contacts directement dans votre conversation. Choisissez des créneaux et attendez qu'ils confirment.",
      "title": "Comment utiliser le calendrier"
    },
    "message": {
      "add_to_calendar": "Ajouter à mon agenda",
      "appointment_already_pending_message": "Vous avez déjà envoyé une proposition de rendez-vous à ce contact. Souhaitez-vous l'annuler et la remplacer par celle-ci ?",
      "appointment_already_pending_no": "Non, la garder",
      "appointment_already_pending_title": "Proposition en attente",
      "appointment_already_pending_yes": "Oui, l'annuler",
      "awaiting": "Confirmation en attente",
      "calendar_invite_title": "RDV avec {{name}}",
      "cancel": "Annuler le rendez-vous",
      "cancel_confirmation": "Êtes-vous sûr de vouloir annuler ce rendez-vous ?",
      "cancelled": "Annulé",
      "cancelled_message": "Ce rendez-vous a été annulé.",
      "cannot_confirm": "Impossible de confirmer ce créneau.",
      "confirm_confirmation": "Confirmer ce créneau manuellement?",
      "confirm_date": "Confirmer le créneau",
      "confirm_information": "Confirmer les informations",
      "confirmed": "Confirmé",
      "confirmed_message": "Votre rendez-vous est confirmé !",
      "expired": "Expiré",
      "expired_message": "Le rendez-vous a expiré.",
      "go_to_payment": "Aller au paiement",
      "information_notice": "Merci de confirmer ou renseigner les informations ci-dessous pour confirmer votre rendez-vous.",
      "label": "{{ name }} a proposé les créneaux suivants. Choisissez celui qui vous convient le mieux.",
      "label_with_payment": "{{ name }} vous a envoyé plusieurs créneaux. Vous devrez payer {{ amount }} pour confirmer le rendez-vous.",
      "not_found": "Impossible de trouver ce rendez-vous, il a peut-être été annulé.",
      "payment_attempted": "Un paiement a été tenté mais n'a pas abouti. Sélectionner un créneau ci-dessous pour confirmer le rendez-vous sans paiement.",
      "payment_attempted_public": "Un paiement a été été tenté mais n'a pas abouti. Veuillez réessayer ou nous contacter.",
      "payment_needed": "Un paiement de {{ amount }} est requis pour confirmer le rendez-vous.",
      "remove_payment": "Retirer le paiement",
      "title": "Proposition de rendez-vous",
      "unavailable": "Le créneau que vous avez sélectionné n'est plus disponible. Veuillez en choisir un autre.",
      "view_details": "Voir le rendez-vous",
      "view_terms": "Voir les CGV"
    },
    "settings": {
      "google_calendar": {
        "add": "Ajouter un compte Google",
        "description": "Vous pouvez connecter un compte Google pour ajouter tous vos rendez-vous à votre agenda.",
        "refresh": "Rafraîchir les agendas",
        "remove": "Retirer le compte Google",
        "title": "Google Agenda"
      },
      "phone": {
        "description": "Demander un numéro de téléphone au moment de la réservation.",
        "title": "Numéro de téléphone"
      },
      "reminder": {
        "description": "Votre client recevra un message automatique pour lui rappeler son rendez-vous.",
        "disabled": "Désactivé",
        "four_days_before": "4 jours avant",
        "morning": "À 8h le jour-même",
        "title": "Rappel de rendez-vous",
        "yesterday": "24h avant"
      },
      "terms": {
        "description": "Demander à vos clients d'accepter vos conditions pour valider le rendez-vous.",
        "input": "Lien vers vos conditions",
        "title": "Demander d'accepter les conditions"
      },
      "time_zone": {
        "description": "Votre agenda et vos rendez-vous seront affichés dans ce fuseau horaire.",
        "title": "Fuseau horaire"
      },
      "title": "Paramètres de l'agenda"
    },
    "slots": {
      "confirm": {
        "add_payment": "Ajouter un paiement",
        "cancel_payment": "Retirer le paiement",
        "description": "Votre client pourra choisir parmi ces créneaux.",
        "later_notice": "Vous pouvez toujours envoyer un lien de paiement plus tard.",
        "no_payment": "Envoyer sans paiement",
        "payment_description": "Le rendez-vous sera confirmé une fois le paiement effectué.",
        "payment_title": "Demander un paiement",
        "send": "Envoyer la proposition",
        "title": "Confirmer les créneaux"
      },
      "select": {
        "confirm": "Envoyer les créneaux",
        "selected_one": "créneau sélectionné",
        "selected_other": "créneaux sélectionnés",
        "title": "Choisisser vos créneaux"
      }
    },
    "title": "Agenda"
  },
  "campaigns": {
    "contacts_count_one": "{{count}} contact",
    "contacts_count_other": "{{count}} contacts",
    "export_contacts": "Exporter les contacts",
    "count_one": "{{count}} campagne",
    "count_other": "{{count}} campagnes",
    "create_campaign": "Créer une campagne",
    "created_on": "Créée le {{date}}",
    "edit_campaign": "Modifier la campagne",
    "fields": {
      "folder": "Choisir un dossier",
      "messages": {
        "add_message": "Ajouter un message",
        "label": "Messages",
        "placeholder": "Entrez votre message"
      },
      "scenario": "Choisir un scénario",
      "segment": "Choisir un segment",
      "title": "Nom de la campagne"
    },
    "metrics": {
      "clicked": "Cliqué",
      "opened": "Ouvert",
      "pending": "En attente",
      "sent": "Envoyé",
      "completed": "Terminé",
      "running": "En cours",
      "failed": "Échec",
      "contacts": "Contacts",
      "added": "Ajoutés",
      "converted": "Conversions",
      "liked": "Likes",
      "read": "Lus",
      "removed": "Retirés",
      "replied": "Répondus",
      "seen": "Vus",
      "updated": "Modifié",
      "triggered": "Déclenché",
      "cancelled": "Annulé"
    },
    "new_campaign": "Nouvelle campagne",
    "save_as_draft": "Sauvegarder en brouillon",
    "send_campaign": "Envoyer la campagne",
    "send_campaign_confirm": "Voulez-vous envoyer cette campagne ?",
    "send_campaign_contact_one": "La campagne sera envoyée à {{count}} contact",
    "send_campaign_contact_other": "La campagne sera envoyée à {{count}} contacts",
    "send_campaign_unknown_count": "Le nombre de contacts n'a pas pu être estimé. La campagne sera envoyée à tous les contacts concernés.",
    "unsaved_changes": "Modifications non enregistrées",
    "warnings": {
      "body_save": "Vous pouvez l'enregistrer quand même, mais ces problèmes peuvent l'empêcher de fonctionner comme prévu.",
      "body_send": "Elle sera envoyée quand même, mais ces problèmes peuvent l'empêcher de fonctionner comme prévu.",
      "confirm_save": "Enregistrer quand même",
      "confirm_schedule": "Programmer quand même",
      "confirm_send": "Envoyer quand même",
      "title": "Cette campagne a encore des problèmes non résolus"
    },
    "sent_on": "Envoyée le {{date}}",
    "send_to": "Envoyer à...",
    "dont_send_to": "Ne pas envoyer à...",
    "simple_message": "✉️ Message simple",
    "status": {
      "completed": "Envoyée",
      "draft": "Brouillon",
      "sending": "Envoi en cours",
      "running": "En cours",
      "scheduled": "Programmée",
      "limited": "Limite atteinte",
      "disconnected": "Déconnecté",
      "canceled": "Annulé"
    },
    "title": "Campagnes",
    "no_campaigns": "Aucune campagne pour le moment",
    "create_first": "Créer votre première campagne",
    "view_campaign": "Voir la campagne",
    "view_results": "Voir les résultats",
    "quick_campaigns": {
      "optin_campaign": {
        "title": "Campagne Opt-in",
        "description": "Répondez par DM aux commentaires récents",
        "select_contacts": {
          "title": "Sélectionner les contacts",
          "description": "Choisissez quels commentaires cibler",
          "which_comments": "Quels commentaires voulez-vous cibler ?",
          "all_comments": "Tous les commentaires",
          "comment_keywords": "Commentaires avec des mots-clés",
          "select_posts": "Publications spécifiques",
          "exclude_active_contacts": "Exclure les contacts déjà actifs",
          "keywords_label": "Mots-clés",
          "chart_title": "Contacts correspondants par jour (7 derniers jours)",
          "matching_contacts": "Contacts correspondants",
          "seven_day_rule": "Seuls les contacts ayant commenté au cours des 7 derniers jours peuvent être ciblés",
          "exclude_active_contacts_description": "Les contacts actifs sont déjà dans vos messages et n'ont pas besoin d'accepter de nouveau."
        },
        "send_message": {
          "title": "Envoyer le message d'opt-in",
          "description": "Configurez le message et ce qui se passe ensuite",
          "modes": {
            "button": "Message avec bouton",
            "dm": "DM simple"
          },
          "content_label": "Message",
          "content_placeholder": "Écrivez votre message",
          "button_label": "Bouton",
          "button_placeholder": "Texte du bouton",
          "on_click": "Quand le bouton est cliqué",
          "on_yes": "Quand le contact répond oui",
          "on_no": "Quand le contact répond non",
          "reply_placeholder": "Écrivez une réponse (facultatif)",
          "add_to_folder": "Ajouter à un dossier",
          "added_to": "Ajouté à",
          "yes_reply_example": "Oui",
          "no_reply_example": "Non"
        },
        "review": {
          "title": "Vérifier et envoyer",
          "description": "Vérifiez votre campagne et envoyez-la",
          "contacts_count": "Contacts ayant commenté récemment :",
          "test_campaign": "Envoyer un test",
          "send_campaign": "Envoyer la campagne",
          "schedule_campaign": "Programmer la campagne"
        }
      }
    },
    "campaign_folders": {
      "new_folder": "Nouveau dossier",
      "name_label": "Nom du dossier",
      "name_placeholder": "Saisissez le nom du dossier",
      "create_title": "Créer un dossier",
      "edit_title": "Modifier le dossier",
      "delete_title": "Supprimer « {{name}} »",
      "campaign_count": "{{count}} campagne",
      "campaign_count_one": "{{count}} campagne",
      "campaign_count_other": "{{count}} campagnes",
      "delete_ungroup": "Conserver les campagnes du dossier",
      "delete_ungroup_description": "Les campagnes seront retirées du dossier.",
      "delete_campaigns": "Supprimer les {{count}} campagnes du dossier",
      "delete_campaigns_description": "Toutes les campagnes de ce dossier seront définitivement supprimées.",
      "delete_empty_prompt": "Voulez-vous vraiment supprimer ce dossier ?",
      "all_campaigns": "Toutes les campagnes",
      "folder_empty": "Ce dossier est vide",
      "remove_from_folder": "Retirer du dossier",
      "duplicate_confirm": "Dupliquer ce dossier et ses {{count}} campagne(s) ?"
    },
    "table": {
      "columns": {
        "name": "Nom",
        "status": "Statut",
        "created_at": "Créée",
        "sent_at": "Envoyée"
      }
    },
    "destinations": {
      "all_contacts": {
        "description": "Envoyer à tous vos contacts",
        "title": "Tous les contacts joignables"
      },
      "pick_contacts": {
        "title": "Sélectionner des contacts",
        "none_selected": "Sélectionnez au moins un dossier ou un segment."
      },
      "folders": {
        "description": "Tous les contacts dans un dossier",
        "title": "Dossiers",
        "count_one": "{{count}} dossier",
        "count_other": "{{count}} dossiers"
      },
      "segments": {
        "description": "Tous les contacts correspondant aux filtres du segment",
        "title": "Segments",
        "count_one": "{{count}} segment",
        "count_other": "{{count}} segments"
      },
      "contacts_count_capped_one": "{{count}}+ contact",
      "contacts_count_capped_other": "{{count}}+ contacts",
      "contacts_count_one": "{{count}} contact",
      "contacts_count_other": "{{count}} contacts",
      "label": "Envoyer à",
      "folder": {
        "description": "Tous les contacts dans un dossier",
        "label": "Dossier"
      },
      "segment": {
        "description": "Tous les contacts qui correspondent au segment",
        "label": "Segment"
      }
    },
    "delete_campaign_confirm": "Supprimer cette campagne ?",
    "executions": {
      "pending": "Campagnes en cours",
      "limited": "La campagne n'a pas été envoyée à ce contact car vous avez atteinte votre limite mensuelle."
    },
    "settings": {
      "interrupt_on_message": "Interrompre quand vous répondez manuellement",
      "is_template": "Sauvegarder comme template"
    },
    "cancel_schedule": "Annuler la programmation",
    "cancel_schedule_confirm": "Annuler la programmation ?",
    "edit_schedule": "Modifier la date",
    "scheduled_notice": "Cette campagne sera envoyée le **{{date}}**",
    "schedule_campaign": "Programmer la campagne",
    "scheduled_on": "Programmée le {{date}}",
    "select_campaign": "Sélectionner une campagne",
    "current_campaign": "Campagne actuelle",
    "inactive_warning": "Cette campagne est inactive",
    "contacts_count_capped_one": "{{count}}+ contact",
    "contacts_count_capped_other": "{{count}}+ contacts",
    "contacts_count_estimation": "Votre campagne sera envoyée à",
    "contacts_count_unavailable": "Le nombre de contacts n'a pas pu être estimé",
    "dont_exclude_folder": "Ne pas exclure de dossier",
    "exclude_contacts_time": "Exclure les contacts qui ont reçu une campagne dans les 72 heures",
    "exclude_folder": "Exclure un dossier",
    "excluding_one": "excl. {{count}} dossier",
    "excluding_other": "excl. {{count}} dossiers",
    "templates": {
      "title_label": "Nom de la campagne",
      "title_placeholder": "Entrez un titre",
      "new": "Créer une nouvelle campagne",
      "choose_template": "Choisir un modèle",
      "empty_campaign": "Campagne vide",
      "empty_campaign_description": "Créer votre campagne à partir de zéro",
      "create_campaign": "Créer la campagne"
    },
    "limit_reached_warning": "Votre campagne ne sera pas envoyée à tout le monde car vous avez atteinte votre limite mensuelle.",
    "limited_executions_one": "<0>{{ count }} contact</0> n'a pas reçu la campagne car vous avez atteint votre limite mensuelle",
    "limited_executions_other": "<0>{{ count }} contacts</0> n'ont pas reçu la campagne car vous avez atteint votre limite mensuelle",
    "resend_limited_executions": "Renvoyer à ces contacts",
    "disconnected_executions_one": "<0>{{ count }} contact</0> n'a pas reçu la campagne car votre compte Instagram était déconnecté.",
    "disconnected_executions_other": "<0>{{ count }} contacts</0> n'ont pas reçu la campagne car votre compte Instagram était déconnecté.",
    "resend_disconnected_executions": "Envoyer à ces contacts",
    "test_sent": "Votre campagne de test a été envoyée.",
    "test_prompt": {
      "title": "Tester votre campagne avant de l'envoyer ?",
      "confirm": "Envoyer un test d'abord",
      "later": "Annuler",
      "send_anyway": "Envoyer sans tester",
      "schedule_anyway": "Programmer quand même"
    },
    "send_test_confirm": "Envoyer une campagne de test à ce contact ?",
    "send_test": "Envoyer un test",
    "excluding": "sauf {{count}} folders",
    "cancel_campaign": "Annuler la campagne",
    "cancel_campaign_confirm": "Voulez-vous annuler la campagne ?",
    "save_changes": "Sauvegarder les changements",
    "duplicate_title": "Dupliquer la campagne vers",
    "search_campaigns": "Chercher dans les campagnes",
    "search_no_results": "Aucune campagne trouvée"
  },
  "shopify_link": {
    "message": {
      "button": "Voir le produit",
      "products_count": "+ {{count}} produits"
    },
    "modal": {
      "title": "Configurer le lien Shopify",
      "source": {
        "manual": "Choisir des produits",
        "collection": "Collection",
        "tag": "Tag",
        "query": "Recherche"
      },
      "search_collections": "Rechercher des collections",
      "no_collections": "Aucune collection trouvée",
      "products_count_one": "{{count}} produit",
      "products_count_other": "{{count}} produits",
      "tag_label": "Tag de produit",
      "tag_placeholder": "ex. new, sale, summer",
      "sort_key_label": "Trier les produits par",
      "sort_key": {
        "RELEVANCE": "Pertinence",
        "TITLE": "Titre",
        "PRICE": "Prix",
        "BEST_SELLING": "Meilleures ventes",
        "CREATED_AT": "Plus récents",
        "UPDATED_AT": "Récemment mis à jour"
      },
      "query_label": "Recherche",
      "query_placeholder": "ex. robes rouges, vestes en cuir",
      "link_type_label": "Destination du lien",
      "link_type": {
        "product": "Page du produit",
        "checkout": "Paiement direct"
      },
      "discount_label": "Appliquer un code de réduction",
      "discount_placeholder": "ex. SAVE10",
      "query_notice": "Cette recherche est utilisée pour trouver des produits dans votre boutique et les envoyer par DM.",
      "tag_notice": "Les produits avec ce tag seront envoyés en DM.",
      "discount_notice": "La promotion sera ajoutée automatiquement aux liens que vous envoyez par DM.",
      "max_products_label": "Nombre max de produits",
      "max_products_placeholder": "Par défaut : 10"
    },
    "node": {
      "link_type": {
        "product": "Lien vers la page du produit",
        "checkout": "Paiement direct"
      },
      "with_discount": "réduction {{code}}"
    }
  },
  "comments": {
    "comment_reply": {
      "placeholder": "Entrer votre commentaire...",
      "title": "Répondre par commentaire",
      "your_reply": "Votre réponse"
    },
    "private_reply": {
      "placeholder": "Entrer votre message...",
      "title": "Répondre par DM",
      "view": "Voir la réponse"
    },
    "sort_options": {
      "most_likes": "Le plus de likes",
      "most_replies": "Le plus de réponses",
      "newest": "Les plus récents",
      "oldest": "Les plus anciens"
    },
    "title": "Commentaires",
    "delete_confirm": "Supprimer votre commentaire ?",
    "trigger_automation": "Déclencher les automatisations",
    "trigger_automation_confirm": "Déclencher les automatisations sur ce commentaire ?",
    "trigger_automation_success": "Automatisations déclenchées"
  },
  "commerce": {
    "products": {
      "not_found": "Aucun produit trouvé.",
      "search": "Chercher un produit"
    }
  },
  "contacts": {
    "info_unavailable": {
      "personal_account": "Disponible uniquement pour les contacts avec un compte Professionnel ou Créateur",
      "no_message": "Non disponible tant que ce contact n'a pas envoyé de message."
    },
    "clear_selection": "Annuler la sélection",
    "filters": {
      "add_filter": "Ajouter un filtre",
      "categories": {
        "all": {
          "description": "Tous",
          "title": "Tous"
        },
        "any_engagement": {
          "description": "qui ont interagi avec vous",
          "title": "Tout type d'engagement"
        },
        "first_interaction": {
          "description": "dont la première interaction était",
          "title": "Première interaction"
        },
        "contact_created_at": {
          "description": "créé",
          "title": "Date de création du contact"
        },
        "appointment": {
          "description": "qui ont reçu un rendez-vous",
          "title": "Rendez-vous"
        },
        "campaign": {
          "description": "ciblés par une campagne",
          "title": "Campagne"
        },
        "clicked_conversion_link": {
          "description": "qui ont cliqué sur un lien suivi",
          "title": "Lien suivi"
        },
        "comment": {
          "description": "qui ont commenté sur un post",
          "title": "Commentaire"
        },
        "email": {
          "description": "dont l'email",
          "title": "Email"
        },
        "is_follower": {
          "description": "qui",
          "title": "Followers"
        },
        "is_followed": {
          "description": "que vous suivez",
          "title": "Suivi par vous"
        },
        "message": {
          "description": "qui ont envoyé un message",
          "title": "Message"
        },
        "name": {
          "description": "dont le nom",
          "title": "Nom"
        },
        "payment": {
          "description": "qui ont reçu un lien de paiement",
          "title": "Lien de paiement"
        },
        "phone": {
          "description": "dont le téléphone",
          "title": "Téléphone"
        },
        "referral_ad": {
          "description": "qui ont répondu à une publicité",
          "title": "Publicité"
        },
        "scenario": {
          "description": "qui ont déclenché un scénario",
          "title": "Scénario"
        },
        "story_mention": {
          "description": "qui vous ont mentionné en story",
          "title": "Mention en story"
        },
        "story_reply": {
          "description": "qui ont répondu à une story",
          "title": "Réponse à une story"
        },
        "username": {
          "description": "dont le nom d'utilisateur",
          "title": "Nom d'utilisateur"
        },
        "follower_count": {
          "description": "avec un nombre de followers",
          "title": "Nombre de followers"
        },
        "language": {
          "description": "avec comme langue principale",
          "title": "Langue"
        },
        "folder": {
          "description": "qui sont dans un dossier",
          "title": "Dossier",
          "in_a_folder": "qui sont dans le dossier",
          "not_in_folder": "qui ne sont pas dans le dossier",
          "not_in_a_folder": "qui ne sont dans aucun dossier"
        },
        "media_mention": {
          "description": "qui vous ont mentionné dans une publication",
          "title": "Mention en publication"
        },
        "contact_property": {
          "description": "qui remplisse la condition",
          "title": "Propriété du contact"
        },
        "status": {
          "description": "dont le statut est",
          "title": "Statut"
        },
        "survey": {
          "description": "qui ont complété un sondage",
          "title": "Sondage"
        }
      },
      "logic": {
        "and": "et",
        "or": "ou",
        "users_who": "Contacts"
      },
      "options": {
        "campaigns": {
          "any": "N'importe quelle campagne"
        },
        "scope": {
          "post": {
            "any": "N'importe quelle publication",
            "specific": "Une publication précise"
          },
          "story": {
            "any": "N'importe quelle story",
            "specific": "Une story précise"
          },
          "campaign": {
            "any": "N'importe quelle campagne",
            "specific": "Une campagne précise"
          },
          "scenario": {
            "any": "N'importe quel scénario",
            "specific": "Un scénario précis"
          },
          "link": {
            "any": "N'importe quel lien",
            "specific": "Un lien précis"
          }
        },
        "date_operators": {
          "is_equal": "le jour",
          "is_not_equal": "pas le jour",
          "is_before": "avant",
          "is_after": "après",
          "is_on_or_before": "jusqu'à",
          "is_on_or_after": "à partir de",
          "is_between": "entre",
          "is_present": "à tout moment",
          "is_not_present": "jamais"
        },
        "date_modes": {
          "exact_date": "date précise",
          "today": "aujourd'hui",
          "yesterday": "hier",
          "days_ago": "jours en arrière"
        },
        "date_summary": {
          "exact_date": {
            "is_equal": "le {{date}}",
            "is_not_equal": "pas le {{date}}",
            "is_before": "avant le {{date}}",
            "is_after": "après le {{date}}",
            "is_on_or_before": "jusqu'au {{date}}",
            "is_on_or_after": "à partir du {{date}}"
          },
          "today": {
            "is_equal": "aujourd'hui",
            "is_not_equal": "pas aujourd'hui",
            "is_before": "avant aujourd'hui",
            "is_after": "après aujourd'hui",
            "is_on_or_before": "jusqu'à aujourd'hui",
            "is_on_or_after": "à partir d'aujourd'hui"
          },
          "yesterday": {
            "is_equal": "hier",
            "is_not_equal": "pas hier",
            "is_before": "avant hier",
            "is_after": "après hier",
            "is_on_or_before": "jusqu'à hier",
            "is_on_or_after": "à partir d'hier"
          },
          "days_ago": {
            "is_equal_one": "il y a {{count}} jour",
            "is_equal_other": "il y a {{count}} jours",
            "is_not_equal_one": "pas il y a {{count}} jour",
            "is_not_equal_other": "pas il y a {{count}} jours",
            "is_before_one": "il y a plus de {{count}} jour",
            "is_before_other": "il y a plus de {{count}} jours",
            "is_after_one": "il y a moins de {{count}} jour",
            "is_after_other": "il y a moins de {{count}} jours",
            "is_on_or_before_one": "il y a {{count}} jour ou plus",
            "is_on_or_before_other": "il y a {{count}} jours ou plus",
            "is_on_or_after_one": "il y a {{count}} jour ou moins",
            "is_on_or_after_other": "il y a {{count}} jours ou moins"
          },
          "between": "entre le {{from}} et le {{to}}"
        },
        "message": {
          "containing": "contenant",
          "any_text": "n'importe quel texte"
        },
        "is_follower": {
          "is_false": "ne vous suivent pas",
          "is_true": "vous suivent"
        },
        "is_followed": {
          "is_false": "vous ne suivez pas",
          "is_true": "vous suivez"
        },
        "operators": {
          "contains": "contient",
          "does_not_contain": "ne contient pas",
          "is_not_present": "n'est pas rempli",
          "is_present": "est rempli",
          "is_above": "est supérieur à",
          "is_below": "est inférieur à",
          "is_between": "est compris entre",
          "between_and": "et",
          "is_equal": "est égal à",
          "is_false": "est faux",
          "is_true": "est vrai",
          "is_not_equal": "n'est pas égal à",
          "is_before": "est avant",
          "is_after": "est après",
          "placeholder": "Choisir une condition"
        },
        "scenarios": {
          "any": "N'importe quel scénario"
        },
        "survey": {
          "received_and_completed": "Reçu et complété",
          "received_not_completed": "Reçu mais non complété",
          "never_received": "Jamais reçu"
        }
      },
      "remove_filter": "Retirer le filtre",
      "remove_filters": "Retirer tous les filtres",
      "scenarios": {
        "any_scenario": "N'importe quel scénario"
      },
      "title": "Filtres",
      "generate_prompt_placeholder": "Décrivez vos critères de filtre",
      "generate_button": "Générer les filtres avec l'IA",
      "contacts_count_one": "1 contact correspond",
      "contacts_count_other": "{{count}} contacts correspondent",
      "contacts_count_capped_one": "{{count}}+ contact correspond",
      "contacts_count_capped_other": "{{count}}+ contacts correspondent",
      "any": "Tout type d'engagement",
      "comment": "A commenté sur un post",
      "message": "A envoyé un DM",
      "referral_ad": "A répondu à une publicité",
      "scenario": "A déclenché un scénario",
      "story_mention": "Vous a mentionné en story",
      "story_reply": "A répondu à une story",
      "no_filters": "Aucun filtre",
      "edit_filters": "Modifier les filtres",
      "add_filters": "Ajouter des filtres"
    },
    "no_contacts": "Aucun contact trouvé",
    "contacts_count_one": "1 contact",
    "contacts_count_other": "{{count}} contacts",
    "contacts_count_capped_one": "{{count}}+ contact",
    "contacts_count_capped_other": "{{count}}+ contacts",
    "segments": {
      "create_segment": "Créer un segment",
      "delete_segment": "Supprimer le segment",
      "delete_segment_confirm": "Supprimer le segment {{segment}} ?",
      "rename_segment": "Renommer le segment",
      "duplicate_segment": "Dupliquer le segment",
      "copy_title": "{{title}} (copie)",
      "title": "Segments",
      "edit_segment": "Modifier le segment",
      "view_contacts": "Voir les contacts dans le segment"
    },
    "title": "Contacts",
    "all_contacts": "Tous les contacts",
    "search_contacts": "Rechercher un contact",
    "load_failed": "Impossible de charger les contacts.",
    "columns": {
      "bio": "Bio",
      "email": "Email",
      "folders": "Dossiers",
      "follower": "Follower",
      "follower_count": "# followers",
      "language": "Langue",
      "last_message": "Dernier message",
      "name": "Nom",
      "phone": "Téléphone",
      "username": "Pseudo",
      "weekly_growth": "Croissance hebdo",
      "status": "Statut",
      "last_interaction": "Dernière intéraction"
    },
    "view_conversation": "Voir la conversation",
    "edit": "Modifier le contact",
    "no_language": "Aucune langue détectée",
    "save": "Sauvegarder le contact",
    "delete_contact": "Supprimer le contact",
    "delete_contact_confirm": "Supprimer ce contact et toutes ses conversations ?",
    "delete_contact_notice": "Cette action est irréversible. L'historique des automatisations et campagnes est conservé, sans le contact.",
    "properties": {
      "delete_confirm": "Supprimer ce champ ?",
      "delete_property": "Supprimer le champ",
      "edit_property": "Modifier le champ",
      "new_property": "Nouveau champ",
      "no_property_selected": "Aucun champ sélectionné",
      "select_property": "Choisir un champ",
      "auto_detect_label": "Détecter automatiquement",
      "auto_detect_paused": "Plus de crédits IA. La détection est en pause.",
      "built_in": "Intégré",
      "built_in_note": "Champ intégré. Son titre et son type ne peuvent pas changer.",
      "agent_badge": "Agent IA",
      "agent_active_hint": "L'agent s'en sert pour répondre aux questions de vos contacts.",
      "auto_detect_cost": "Utilise 1 crédit IA par détection qui trouve une valeur.",
      "backfill_confirm": "Détecter",
      "backfill_later": "Pas maintenant",
      "backfill_running": "Détection…",
      "backfill_progress": "{{done}} sur {{total}}",
      "backfill_found_one": "{{count}} valeur trouvée",
      "backfill_found_other": "{{count}} valeurs trouvées",
      "backfill_found_none": "Terminé. Aucune valeur trouvée.",
      "backfill_stopped": "Arrêtée à {{done}} sur {{total}}.",
      "backfill_stopped_credits": "Arrêtée à {{done}} sur {{total}} : plus de crédits IA.",
      "see_credits": "Voir les crédits",
      "empty": "Les champs gardent ce que vos contacts vous disent, comme un budget ou des centres d'intérêt.",
      "no_value": "Aucune valeur",
      "detected_automatically": "Détecté automatiquement",
      "more_values": "+{{count}}",
      "auto_detect_description": "Remplit les valeurs vides à partir du profil et des conversations de chaque contact.",
      "auto_detect_badge": "Détection auto",
      "backfill_button": "Détecter pour les contacts existants",
      "backfill_prompt_other": "Détecter {{property}} pour {{count}} contacts existants ?",
      "backfill_prompt_one": "Détecter {{property}} pour {{count}} contact existant ?",
      "backfill_none": "Aucun contact existant à analyser.",
      "title": "Propriétés des contacts",
      "title_label": "Nom de la propriété",
      "title_placeholder": "Date de naissance, pays, etc.",
      "type_date": "Date",
      "type_label": "Type de propriété",
      "type_number": "Nombre",
      "type_text": "Texte",
      "type_email": "Email",
      "type_phone": "Téléphone",
      "type_url": "URL",
      "type_boolean": "Booléen",
      "type_list": "Liste",
      "type_single_choice": "Choix unique",
      "type_multiple_choice": "Choix multiple",
      "choices_label": "Options",
      "choices_placeholder": "Ajouter une option...",
      "slug_label": "Slug de variable",
      "slug_placeholder": "ex. date_naissance, pays, etc.",
      "slug_hint": "Utilisez ce slug dans les variables d'automatisation : {{ contact.slug }}",
      "add_choice_button": "Ajouter une option"
    },
    "export": "Exporter les contacts",
    "tabs": {
      "automation": "Automatisation",
      "campaigns": "Campagnes",
      "comments": "Commentaires",
      "conversation": "Conversation",
      "mentions": "Mentions",
      "notes": "Notes",
      "properties": "Propriétés",
      "history": "Historique"
    },
    "drawer": {
      "contacts_count_one": "1 contact",
      "contacts_count_other": "{{count}} contacts",
      "contacts_count_capped_one": "{{count}}+ contact",
      "contacts_count_capped_other": "{{count}}+ contacts",
      "export_contacts": "Exporter les contacts",
      "page": "Page {{page}} sur {{total}}",
      "search_contacts": "Chercher dans les contacts",
      "view_contacts": "Voir les contacts",
      "no_contacts": "Aucun contact trouvé"
    },
    "status": {
      "active": {
        "description": "Le contact peut recevoir des messages.",
        "label": "Actif"
      },
      "commented": {
        "description": "A commenté sur un de vos posts et peut recevoir un DM pendant les 7 jours suivant.",
        "label": "Commenté"
      },
      "deleted": {
        "description": "Compte Instagram supprimé",
        "label": "Supprimé"
      },
      "inactive": {
        "description": "Ne peut pas recevoir vos messages. Le contact s'activera s'ils vous envoient un message.",
        "label": "Inactif"
      },
      "optout": {
        "description": "A refusé de recevoir vos messages",
        "label": "Désinscrit"
      },
      "pending": {
        "description": "Statut en cours d'évaluation",
        "label": "En attente"
      },
      "requested": {
        "description": "A reçu votre demande de message mais ne l'a pas encore acceptée",
        "label": "Demande envoyée"
      },
      "edit_active": "Ce contact peut recevoir des messages",
      "edit_optout": "Retirer le contact des envois de messages",
      "edit_spam": "Ajouter le contact aux spams",
      "edit_status": "Modifier le statut",
      "live_commented": {
        "description": "Le contact a commenté sur une vidéo live. Vous pouvez lui envoyer un DM dans les 24 heures suivantes.",
        "label": "Commentaire Live"
      },
      "spam": {
        "description": "Vous avez ajouté le contact aux spams.",
        "label": "Spam"
      },
      "remove_optout": "Désinscrire le contact de la liste de diffusion",
      "remove_spam": "Retirer le contact de la liste de spam"
    },
    "notes": {
      "write_notes": "Écrivez vos notes..."
    },
    "history": {
      "no_history": "Pas d'historique de contact"
    }
  },
  "content": {
    "medias": {
      "ad_badge": "Pub",
      "media_id": "ID du post",
      "pick_media": "Choisir un post",
      "comments_one": "1 commentaire",
      "comments_other": "{{count}} commentaires",
      "last_synced": "Mise à jour: {{date}}",
      "likes_one": "1 like",
      "likes_other": "{{count}} likes",
      "no_comments": "Pas encore de commentaires",
      "published": "Publié : {{date}}",
      "refresh": "Rafraîchir le contenu",
      "title": "Posts & reels",
      "view_on_instagram": "Voir sur Instagram",
      "tabs": {
        "comments": "Commentaires",
        "automation": "Automatisation",
        "insights": "Statistiques",
        "ai_agent": "Agent IA"
      },
      "insights": {
        "reach": "Couverture",
        "views": "Vues",
        "likes": "J'aime",
        "comments": "Commentaires",
        "saved": "Enregistrements",
        "shares": "Partages",
        "total_interactions": "Interactions totales",
        "profile_visits": "Visites du profil",
        "profile_activity": "Actions sur le profil",
        "follows": "Nouveaux abonnés",
        "ig_reels_avg_watch_time": "Temps de visionnage moyen",
        "ig_reels_video_view_total_time": "Temps de visionnage total",
        "seconds": "{{value}} s",
        "refreshing": "Récupération des dernières statistiques depuis Instagram…",
        "unavailable": "Instagram ne fournit pas de statistiques pour cette publication.",
        "empty": "Pas encore de statistiques pour cette publication."
      },
      "automations_one": "1 automatisation",
      "automations_other": "{{count}} automatisations",
      "create_media": "Créer un post",
      "status": {
        "all": "Tous les posts",
        "posted": "Publiés",
        "scheduled": "Programmés",
        "draft": "Brouillons",
        "pending": "En cours"
      },
      "cannot_publish": {
        "title": "Publication non disponible",
        "description": "Il nous manque les autorisations API pour publier du contenu sur votre compte Instagram.",
        "reconnect": "Reautoriser l'accès"
      },
      "filters": {
        "status": {
          "all": "Tous les posts",
          "posted": "Publiés",
          "scheduled": "Programmés"
        }
      },
      "publish_media_types": {
        "image": "Image",
        "reels": "Reel"
      },
      "draft": {
        "publish": "Publier le post",
        "save_draft": "Sauvegarder",
        "publish_confirm": "Publier ce post sur Instagram ?",
        "tag_users": {
          "title": "Identifier des personnes",
          "image_hint": "Cliquer sur l'image pour identifier quelqu'un",
          "new_tag": "Ajouter quelqu'un",
          "search_user": "Rechercher une personne"
        }
      },
      "select_media": "Sélectionner un média",
      "select_media_one": "Sélectionner 1 média",
      "select_media_other": "Sélectionner {{count}} médias",
      "upload_media": "Téléverser un média",
      "load_error": "Erreur de chargement",
      "automation": {
        "grid_unavailable": "Les automatisations de commentaires ne sont pas disponibles pour les publications d'une grille. Ajoutez-en une sur chaque publication une fois publiée."
      },
      "publishing": {
        "steps": {
          "select_media": "Sélectionner un média",
          "set_caption": "Légende et tags",
          "automation": "Automatisation des commentaires",
          "options": "Options",
          "review": "Vérification"
        },
        "cover": {
          "label": "Modifier la couverture",
          "pick_frame": "Choisir dans la vidéo",
          "drop": "Déposez pour l'utiliser comme couverture",
          "upload_error": "Impossible d'importer ce fichier. Utilisez une image JPEG ou PNG.",
          "remove": "Retirer la couverture",
          "frame_title": "Choisir une image de la vidéo",
          "frame_label": "Image",
          "use_frame": "Utiliser cette image",
          "ai": {
            "open": "Modifier avec l'IA",
            "title": "Modifier l'image avec l'IA",
            "prompt_label": "Que faut-il changer ?",
            "prompt_placeholder": "Ajoutez du texte sur cette image",
            "generate": "Générer",
            "regenerate": "Générer à nouveau",
            "cost": "Utilise {{number}} crédits IA",
            "generating": "Génération en cours… cela peut prendre jusqu'à une minute.",
            "use": "Utiliser comme couverture",
            "original": "Image d'origine",
            "version": "Version {{number}}",
            "get_credits": "Obtenir des crédits",
            "errors": {
              "ai_credits_exhausted": "Vous n'avez plus de crédits IA.",
              "rate_limited": "Vous avez atteint la limite du jour pour les couvertures IA. Réessayez demain.",
              "moderation_blocked": "Cette demande a été refusée. Essayez de la reformuler.",
              "frame_unavailable": "Impossible de lire cette image. Choisissez-en une autre.",
              "failed": "La couverture n'a pas pu être générée. Réessayez."
            }
          },
          "upload_image": "Ajouter une image"
        },
        "tag_users": {
          "search_user_notice": "Entrer l'identifiant du compte sans le @",
          "search_placeholder": "e.g. inro.social",
          "no_results": "Aucun utilisateur trouvé"
        },
        "audio_name": {
          "label": "Renommer votre audio"
        },
        "collaborators": {
          "empty_title": ""
        },
        "ai_disclosure": {
          "label": "Contenu généré par IA",
          "description": "Activez cette option si l'image ou la vidéo a été générée avec l'IA.",
          "notice": "Instagram impose ce label sur les contenus IA photoréalistes. Il doit être défini **avant la publication** : une fois la publication en ligne, le label peut seulement être retiré, jamais ajouté."
        },
        "review": {
          "cancel_schedule": "Annuler la programmation",
          "delete_draft": "Supprimer le brouillon",
          "delete_draft_confirm": "Supprimer ce brouillon ?"
        },
        "media_types": {
          "image": "Image",
          "reels": "Reel",
          "carousel": "Carrousel",
          "grid": "Grille"
        },
        "grid": {
          "preview": "Aperçu de la grille du profil",
          "layout": "Disposition",
          "posts": "{{number}} publications",
          "sublabel": "Recadrée pour s'adapter à la grille. Les publications sont mises en ligne une par une, à environ 20 secondes d'intervalle."
        },
        "carousel": {
          "label": "Images du carrousel",
          "sublabel": "Entre {{min}} et {{max}} images ou vidéos. Glissez-déposez pour les réordonner — la première est celle qui apparaît dans le fil.",
          "add_items": "Choisir les images",
          "edit_items": "Modifier les images",
          "too_few_title": "Ajoutez une image de plus",
          "too_few_description": "Instagram demande au moins {{min}} images pour un carrousel.",
          "slide_position": "Image {{position}} sur {{total}}. Utilisez les flèches gauche et droite pour la déplacer."
        },
        "paid_partnership": {
          "label": "Partenariat rémunéré",
          "description": "Affiche la mention « Partenariat rémunéré », obligatoire quand une marque paie pour cette publication.",
          "sponsors": "Identifiez les marques avec lesquelles vous avez travaillé ({{max}} maximum).",
          "add_sponsor": "Ajouter une marque partenaire",
          "picker_title": "Identifier une marque partenaire",
          "notice": "La mention est ajoutée à la publication et **ne peut pas être ajoutée après coup**. La marque doit aussi vous autoriser à l'identifier dans ses paramètres de contenu de marque.",
          "preview": "Partenariat rémunéré",
          "preview_with": "Partenariat rémunéré avec {{sponsor}}",
          "unresolved_sponsor": "**{{username}}** ne peut pas être crédité : aucun compte Business ou Créateur public n'a été trouvé. Instagram n'autorise que les comptes professionnels comme marques partenaires."
        },
        "trial_reel": {
          "label": "Reel d'essai",
          "description": "Montre le reel aux personnes qui ne vous suivent pas d'abord, pour le tester avant qu'il atteigne votre audience.",
          "graduation_label": "Quand doit-il atteindre vos abonnés ?",
          "strategies": {
            "manual": {
              "label": "Quand je le décide",
              "description": "Le reel reste un essai jusqu'à ce que vous le partagiez depuis l'application Instagram."
            },
            "performance": {
              "label": "S'il fonctionne bien",
              "description": "Instagram le partage automatiquement avec vos abonnés s'il plaît aux personnes qui ne vous suivent pas."
            }
          },
          "notice": "Un reel d'essai ne peut plus redevenir un reel normal une fois publié."
        },
        "agent_context": {
          "label": "Information additionnelle pour l'Agent IA",
          "notice": "L'Agent utilisera ces informations en répondant aux commentaires sur ce post.",
          "placeholder": "Information utile sur le sujet du post : prix, localisation, disponibilité, etc."
        },
        "reel_ui": {
          "follow": "Suivre",
          "with_one": "{{username}} et {{other}}",
          "with_others": "{{username}} et {{count}} autres",
          "hide": "Masquer l'interface Instagram",
          "show": "Afficher l'interface Instagram"
        },
        "autosave": {
          "saving": "Enregistrement…",
          "failed": "Échec de l'enregistrement"
        }
      },
      "stories": {
        "title": "Nouvelle story",
        "description": "Modifiez votre story jusqu'à ce que vous soyez prêt à la publier sur Instagram.",
        "media": {
          "label": "Média",
          "sublabel": "Importez une image ou une vidéo pour votre story."
        }
      }
    },
    "stories": {
      "pick_story": "Choisir une story",
      "story_id": "ID de la story",
      "title": "Stories",
      "story_expired": "Story expirée",
      "replies_count_other": "{{count}} réponses",
      "replies_count_one": "{{count}} réponse",
      "replies": {
        "sort_options": {
          "oldest": "Les plus anciennes",
          "newest": "Les plus récentes"
        },
        "view_conversation": "Voir la conversation",
        "no_replies": "Aucune réponse"
      },
      "insights": {
        "taps_forward": "Tap en avant",
        "taps_back": "Taps en arrière",
        "replies": "Réponses",
        "reach": "Portée",
        "impressions": "Impressions",
        "exits": "Sorties"
      }
    },
    "title": "Contenu Instagram",
    "images": {
      "select_image": "Sélectionner une image",
      "select_images": "Sélectionner des images",
      "select_images_one": "Sélectionner 1 image",
      "select_images_other": "Sélectionner {{count}} images",
      "upload_image": "Téléverser une image"
    },
    "videos": {
      "select_video": "Sélectionner une vidéo",
      "select_videos": "Sélectionner des vidéos",
      "select_videos_one": "Sélectionner 1 vidéo",
      "select_videos_other": "Sélectionner {{count}} vidéos",
      "upload_video": "Téléverser une vidéo"
    }
  },
  "conversion_links": {
    "select": "Choisir un lien",
    "count_one": "{{count}} lien",
    "count_other": "{{count}} liens",
    "create": "Créer un lien",
    "delete_confirm": "Supprimer ce lien ? Toute la donnée de conversion sera perdue.",
    "delete_image": "Supprimer l'image",
    "fields": {
      "add_image": "Ajouter une image",
      "button_title": "Bouton",
      "change_image": "Modifier l'image",
      "subtitle": "Sous-titre",
      "title": "Titre",
      "url": "https://superlien.fr"
    },
    "metrics": {
      "clicked": "Cliqué",
      "sent": "Envoyé"
    },
    "no_conversion_links": "Aucun lien trouvé",
    "params": {
      "add": "Ajouter un paramètre",
      "add_utm": "Ajouter le suivi UTM",
      "key": "Nom",
      "value": "Valeur"
    },
    "preview": {
      "missing": "Lien de conversion inexistant",
      "title": "Prévisualiser le message"
    },
    "title": "Liens de conversion",
    "close_confirm": "Voulez-vous fermer sans sauvegarder ?",
    "search": "Chercher dans les liens",
    "table": {
      "campaigns_count_one": "1 campagne",
      "campaigns_count_other": "{{count}} campagnes",
      "columns": {
        "created_on": "Créé le",
        "last_sent": "Envoyé le",
        "metrics": "Résultats",
        "title": "Titre",
        "used_in": "Utilisé dans"
      },
      "scenarios_count_one": "1 scénario",
      "scenarios_count_other": "{{count}} scénarios"
    }
  },
  "dashboard": {
    "appsumo_deal": {
      "title": "Accès à vie sur AppSumo",
      "description": "Payez une fois, automatisez Instagram pour toujours. Disponible jusqu'au 18 décembre.",
      "cta": "Profiter de l'offre",
      "note": "Non applicable aux comptes Pro."
    },
    "appsumo_review": {
      "title": "Laissez un avis, gagnez plus",
      "description": "+{{slots}} compte, +{{contacts}} contacts et +{{ai_credits}} crédits IA par mois.",
      "cta": "Laisser un avis"
    },
    "appsumo_upgrade": {
      "title": "Besoin de plus de place ?",
      "description": "Passez au palier supérieur sur AppSumo pour plus de comptes et des quotas plus larges."
    },
    "lifetime_ai_credits": {
      "title": "Votre offre a été améliorée !",
      "description_one": "Votre offre à vie inclut désormais {{formattedCount}} crédit IA par mois.",
      "description_other": "Votre offre à vie inclut désormais {{formattedCount}} crédits IA par mois.",
      "description_generic": "Votre offre à vie inclut désormais des crédits IA mensuels.",
      "cta": "Voir mon offre"
    },
    "lifetime_cap": {
      "badge": {
        "warning": "Bientôt épuisé",
        "full": "Quota atteint"
      },
      "count": "{{used}} sur {{max}}",
      "cta": "Voir votre utilisation",
      "contacts": {
        "warning_title": "Vous avez utilisé 80 % des contacts du mois",
        "full_title": "Vous avez utilisé tous les contacts du mois",
        "hard": "Partagé entre tous les comptes de votre code. Les nouveaux contacts ne sont plus activés jusqu'au renouvellement — passez à la facturation automatique pour continuer.",
        "auto_billing": "Partagé entre tous les comptes de votre code. Les contacts supplémentaires sont facturés en fin de mois."
      },
      "ai_credits": {
        "warning_title": "Vous avez utilisé 80 % des crédits IA du mois",
        "full_title": "Vous avez utilisé tous les crédits IA du mois",
        "hard": "Partagé entre tous les comptes de votre code. Les étapes IA sont ignorées jusqu'au renouvellement — passez à la facturation automatique ou à votre propre clé OpenAI pour qu'elles continuent.",
        "auto_billing": "Partagé entre tous les comptes de votre code. Les crédits supplémentaires sont facturés en fin de mois."
      }
    },
    "title": "Tableau de bord",
    "metrics": "Performances",
    "active_contacts": "Contacts disponibles",
    "engaged_contacts": "Contacts engagés",
    "replied_share": "dont {{rate}}% auxquels vous avez répondu",
    "activated_contacts": "Contacts activés",
    "conversions": "Conversions",
    "tooltips": {
      "active_contacts": "Les contacts qui peuvent recevoir vos messages. Ils vous ont écrit ou ont répondu à votre demande de message.",
      "engaged_contacts": "Les contacts qui vous ont mentionné en story, envoyé un DM, répondu à une story ou commenté sur un post",
      "activated_contacts": "Contacts ciblés par un scénario, une campagne, l'agent IA ou l'API, par exemple par l'envoi d'un DM.",
      "conversions": "Les contacts qui ont cliqué sur un lien de conversion ou répondu à un sondage"
    },
    "scenarios": {
      "title": "Scénarios actifs",
      "name": "Nom",
      "executions": "Exécutions",
      "conversions": "Conversions",
      "last_executed": "Dernière exécution {{date}}",
      "view_all": "Voir tous les scénarios",
      "empty": "Vous n'avez pas encore de scénarios actifs.",
      "empty_cta": "Créer un scénario"
    },
    "campaigns": {
      "title": "Campagnes récentes",
      "name": "Nom",
      "sent": "Envois",
      "opened": "Ouvertures",
      "conversions": "Conversions",
      "sent_at": "Envoyée le {{date}}",
      "view_all": "Voir toutes les campagnes",
      "empty": "Vous n'avez pas encore de campagnes.",
      "empty_cta": "Créer une campagne"
    },
    "create_automation": {
      "title": "Commencez à automatiser votre Instagram",
      "description": "Créez un scénario d'automatisation pour engager vos contacts et développer votre compte",
      "cta": "Créer une automatisation"
    },
    "join_discord": {
      "title": "Rejoignez notre communauté Discord",
      "description": "Obtenez de l'aide, partagez vos automatisations et apprenez des autres membres.",
      "cta": "Rejoindre Discord"
    },
    "referral_link": {
      "title": "Parrainez un ami",
      "description": "Envoyez votre lien de parrainage et touchez des commissions pendant 3 mois !",
      "cta": "Partager le lien"
    },
    "setup_agent": {
      "title": "Activez votre agent IA",
      "description": "Entraînez l'agent à gérer vos conversations automatiquement et gagnez du temps.",
      "cta": "Configurer l'agent"
    },
    "onboarding": {
      "title": "Démarrez avec Inro",
      "description": "Complétez ces étapes pour commencer à automatiser votre Instagram",
      "create_folder": "Créer un dossier pour vos contacts",
      "create_automation": "Créer votre première automatisation",
      "setup_agent": "Configurer votre agent IA",
      "talk_instagram": "Parlez-nous sur Instagram",
      "follow_inro": "Suivez-nous sur Instagram"
    },
    "setup_mcp": {
      "title": "Vous utilisez Claude ou ChatGPT ?",
      "description": "Connectez notre serveur MCP pour gérer Instagram depuis vos assistants IA !",
      "cta": "Connecter un assistant"
    },
    "instagram_notifications": {
      "title": "Ne manquez aucune notification !",
      "description": "Écrivez-nous pour que nous puissions vous envoyer des informations importantes et des alertes",
      "cta": "Recevoir les notifications par DM"
    },
    "instagram_restriction": {
      "title": {
        "sending_blocked": "Instagram a suspendu vos messages",
        "links_blocked": "Instagram a suspendu les messages avec lien",
        "rate_limited": "Instagram ralentit vos messages"
      },
      "since": "Depuis le {{date}}",
      "resume": {
        "all": "Les automatisations et les messages reprennent d'eux-mêmes dès la levée.",
        "links": "Les messages avec lien reprennent d'eux-mêmes dès la levée."
      },
      "learn_more": "En savoir plus",
      "error_message": "Message d'erreur Instagram"
    },
    "disconnected_scenarios": {
      "title": "Automatisations en pause",
      "description_one": "<0>{{ count }} automatisation</0> n'a pas pu être exécutée pendant que votre compte Instagram était déconnecté.",
      "description_other": "<0>{{ count }} automatisations</0> n'ont pas pu être exécutées pendant que votre compte Instagram était déconnecté.",
      "cta": "Voir les automatisations",
      "modal_title": "Automatisations en pause",
      "modal_description": "Ces automatisations n'ont pas pu être exécutées pendant que votre compte Instagram était déconnecté.",
      "paused_count_one": "{{count}} en pause",
      "paused_count_other": "{{count}} en pause",
      "all_done": "Toutes les exécutions en pause ont été traitées"
    },
    "icebreakers": {
      "title": "Vos ice breakers ne mènent nulle part",
      "description": "Une automatisation peut répondre, classer le contact ou poser des questions.",
      "empty": {
        "title": "Configurez vos ice breakers",
        "description": "Les ice breakers apparaissent au premier message de vos contacts et traitent les demandes fréquentes.",
        "cta": "Configurer les ice breakers"
      }
    },
    "upgrade_to_pro": {
      "title": "Ce que Pro ajoute",
      "details": "Voir les tarifs",
      "benefits": {
        "automations": "Automatisations et campagnes illimitées",
        "ai": "Un Agent IA qui répond dans votre ton",
        "triggers": "Tous les déclencheurs et actions",
        "integrations": "Shopify, Calendly, API, MCP"
      },
      "limit": {
        "badge": "Limite atteinte",
        "activations": {
          "count": "{{used}} / {{max}} contacts",
          "title": "Limite de contacts activés atteinte",
          "description": "Vous avez atteint votre maximum de contacts activés ce mois-ci. Passez en illimité avec Pro."
        },
        "scenarios": {
          "count": "{{used}} / {{max}} scénarios",
          "title": "Limite d'automatisations actives atteinte",
          "description": "Vous avez atteint la limite de scénarios actifs. Passez en illimité avec Pro."
        },
        "campaigns": {
          "count": "{{used}} / {{max}} campagnes",
          "title": "Vous avez envoyé toutes vos campagnes",
          "description": "Vous pourrez en envoyer d'autres le mois prochain. Passez en illimité avec Pro."
        }
      }
    }
  },
  "inbox": {
    "actions": {
      "actions": "Actions",
      "conversations_selected_one": "Une conversation sélectionnée",
      "conversations_selected_other": "{{count}} conversations sélectionnées",
      "like_last_message": "❤️ Liker le dernier message",
      "like_last_message_confirm_one": "Vous allez liker le dernier message de la conversation",
      "like_last_message_confirm_other": "Vous allez liker le dernier message de {{count}} conversations",
      "liking_one": "Like en cours...",
      "liking_other": "Like en cours ({{count}} conversations)…",
      "mark_as": "Marquer…",
      "mark_as_read": "Marquer comme lu",
      "mark_as_read_confirm_one": "Vous allez marquer cette conversation comme lue",
      "mark_as_read_confirm_other": "Vous allez marquer {{count}} conversations comme lues",
      "mark_as_replied": "Marquer comme répondu",
      "mark_as_replied_confirm_one": "Vous allez marquer cette conversation comme répondue",
      "mark_as_replied_confirm_other": "Vous allez marquer {{count}} conversations comme répondues",
      "mark_as_unread": "Marquer comme non lu",
      "move_to": "Déplacer vers",
      "move_to_spam": "Déplacer dans les spams",
      "move_to_spam_confirm_one": "Vous allez déplacer cette conversation dans les spams",
      "move_to_spam_confirm_other": "Vous allez déplacer {{count}} conversations dans les spams",
      "reply": "Répondre",
      "send_confirm_one": "Envoyer le message ?",
      "send_confirm_other": "Envoyer le message à {{count}} conversations ?",
      "send_message": "Envoyer un message",
      "send_message_emoji": "✉️ Envoyer un message",
      "sending_one": "Envoi en cours…",
      "sending_other": "Envoi en cours ({{count}} conversations)…",
      "sending_title_one": "Vous allez envoyer ce message à la conversation sélectionnée",
      "sending_title_other": "Vous allez envoyer ce message à {{count}} conversations"
    },
    "all_loaded": "Plus rien à charger !",
    "caught_up": "Tous les messages ont été traités",
    "clear": "Déselectionner",
    "conversation": {
      "automation_history": "Historique d'automatisation",
      "automated": {
        "sent_by_automation": "Message envoyé par automatisation",
        "sent_by_scenario": "Message envoyé par automatisation **{{scenario}}**",
        "sent_by_campaign": "Message envoyé par campagne **{{campaign}}**",
        "sent_by_agent": "Message envoyé par **Agent IA**",
        "sent_by_api": "Message envoyé via **API**"
      },
      "add_to_folder": "Ajouter à un dossier",
      "agent_handled_info": {
        "title": "Géré par l'agent IA",
        "description": "Cette conversation est actuellement gérée par votre agent IA.",
        "remove_agent": "Retirer l'agent de la conversation",
        "remove_agent_confirm": "Voulez-vous retirer l'agent IA de cette conversation ?"
      },
      "human_handled_info": {
        "title": "Vous gérez cette conversation",
        "description": "Votre agent IA est en pause ici car un membre de l'équipe a répondu manuellement. Il recommencera à répondre automatiquement, ou vous pouvez lui rendre la main maintenant.",
        "resume_agent": "Rendre la main à l'agent IA"
      },
      "handler_status": {
        "handled_by_agent": "Géré par l'agent IA",
        "handled_by_runnable": "Géré par l'automatisation",
        "handled_by_human": "Géré par un membre de l'équipe",
        "human_requested": "Humain demandé"
      },
      "compose": "Votre message…",
      "copy": "Copier",
      "invalid_file_type": "Ce type de fichier n'est pas supporté",
      "like": "Like",
      "loading_messages": "Chargement des messages...",
      "mark": "Marquer",
      "mark_as": "Marquer",
      "marked_as_replied": "Vous avez marqué cette conversation comme répondue",
      "max_file_size": {
        "image": "Impossible d'envoyer une image de plus de 8MB.",
        "video": "Impossible d'envoyer une vidéo de plus de 25MB.",
        "audio": "Impossible d'envoyer un audio de plus de 25MB."
      },
      "me": "Moi",
      "message_group_tooltip": "Les messages envoyés à quelques instants d'intervalle sont regroupés pour les automatisations.",
      "move": "Déplacer",
      "move_to_folder": "Déplacer vers le dossier",
      "move_to_spam": "Déplacer dans les spams",
      "move_to_spam_confirm": "Déplacer {{object}} dans les spams ?",
      "notes": "Notes",
      "remove_from_spam": "Retirer des spams",
      "remove_from_spam_confirm": "Retirer la conversation des spams ?",
      "replying_to": "En réponse au commentaire",
      "request_payment": "Demander un paiement",
      "run_scenario": "Lancer un scénario",
      "save_message": "Sauvegarder le message",
      "schedule_appointment": "Planifier un RDV",
      "schedule_message": "Programmer un message",
      "seen": "Lu",
      "send": "Envoyer",
      "send_failed": "Message non envoyé",
      "send_shopify_link": "Lien Shopify",
      "spam": "Spam",
      "unlike": "Supprimer le like",
      "unsave_message": "Ne pas sauvegarder",
      "unsupported_message": "Impossible d'afficher le message",
      "unsupported_message_view": "Le voir sur Instagram",
      "change_folder": "Modifier le(s) dossier(s)",
      "not_found": "Conversation introuvable",
      "remove_from_folder": "Retirer du dossier",
      "trigger_automation": "Déclencher les automatisations",
      "trigger_automation_confirm": "Voulez-vous déclencher les automations sur ce message ? Seuls les scénarios avec un déclencheur correspondant seront exécutés.",
      "trigger_automation_regroup": "Déclencher les automatisations (regrouper)",
      "go_to_instagram": "Aller sur Instagram pour envoyer un DM au contact inactif",
      "thread_ownership": {
        "description": "Une autre application a demandé un contrôle exclusif sur cette conversation.",
        "description_date": "Une autre application a demandé un contrôle exclusif sur cette conversation jusqu'au **{{date}}**.",
        "description_estimated_date": "Une autre application a demandé un contrôle exclusif sur cette conversation. Elle devrait être libérée aux alentours du **{{date}}**.",
        "title": "Conversation bloquée"
      },
      "icebreaker_clicked": "Clic sur un ice breaker"
    },
    "details": {
      "client_details": "Détails du client",
      "email": "Email",
      "email_address": "Addresse email",
      "email_placeholder": "exemple@email.fr",
      "empty_notes": "Prenez des notes sur ce contact…",
      "engagement": "Statistiques d'engagement",
      "engagement_appointments_one": "{{ count }} rendez-vous",
      "engagement_appointments_other": "{{ count }} rendez-vous",
      "engagement_date": "Depuis que vous utilisez Inrō, {{date}}",
      "engagement_dm_one": "{{ count }} DM reçu",
      "engagement_dm_other": "{{ count }} DM reçus",
      "engagement_follow": "@{{ name }} vous suit",
      "engagement_last_appointment": "Le plus récent : {{ date }}",
      "engagement_no_follow": "@{{ name }} ne vous suit pas",
      "engagement_payments_one": "{{ count }} paiement reçu",
      "engagement_payments_other": "{{ count }} paiements reçus",
      "engagement_story_one": "A réagi à {{ count }} story",
      "engagement_story_other": "A réagi à {{ count }} stories",
      "information": "Informations personnelles",
      "media": "Photos et vidéos",
      "media_empty": "Aucun media n'a été trouvé dans cette conversation",
      "name": "Nom",
      "no_saved_messages": "Vous n'avez pas encore sauvegardé de message dans cette conversation.",
      "notes": "Notes",
      "phone": "Téléphone",
      "phone_number": "Numéro de téléphone",
      "phone_placeholder": "+XX X XX XX XX XX",
      "real_name": "Nom",
      "real_name_placeholder": "Nom du contact",
      "saved_messages": "Message sauvegardés",
      "unsave_message": "Voulez-vous retirer ce message des messages sauvegardés ?"
    },
    "empty": "Aucun message",
    "filters": {
      "filter_by": "Filtrer par",
      "followers": "Uniquement mes followers",
      "handled_by_agent": "Actuellement géré par les agents",
      "human_requested": "Humain demandé",
      "mentions": "Mentions en story sans réponse",
      "messages": "Ils ont répondu en dernier",
      "most_engaged": "Les plus engagés",
      "no_folder": "Sans dossier",
      "not_handled_by_automation": "Non géré par une automatisation",
      "payment_pending": "Paiement en attente",
      "pending": "Payment ou rendez-vous en attente",
      "replied_message": "Vous avez répondu en dernier",
      "shopify_customers": "Clients Shopify",
      "show_all": "Voir tout",
      "story_replies": "Réponses à une story",
      "unconfirmed_appointment": "Rendez-vous non confirmé",
      "unread": "Messages non lus",
      "unread_empty": "Félicitations, vous avez lu tous vos messages.",
      "unreplied_reactions": "Réactions aux stories sans réponse",
      "upcoming_appointment": "Rendez-vous à venir",
      "campaign_running": "Actuellement géré par une campagne",
      "scenario_running": "Actuellement géré par un scénario"
    },
    "folders": {
      "activate_notifications": "Activer les notifications",
      "all": "Tout",
      "all_folders": "Tous les dossiers",
      "create": "Nouveau dossier",
      "create_new": "Créer un nouveau dossier",
      "create_tooltip": "Créez votre premier dossier",
      "delete": "Supprimer le dossier",
      "delete_confirm": "Supprimer le dossier {{folder}} ?",
      "delete_confirm_notice": "Pas d'inquiétude, vos conversations ne seront pas supprimées.",
      "edit": "Modifier le dossier",
      "folder_exists": "Ce dossier existe déjà",
      "manage": "Gérer les dossiers",
      "manage_notifications": "Gérer les notifications",
      "manage_notifications_empty": "Créez des dossiers pour organiser vos conversations et régler fréquence des notifications pour chaque dossier : en temps réel, quotidien ou hebdomadaire.",
      "move_to_one": "Déplacer la conversation vers le dossier",
      "move_to_other": "Déplacer {{count}} conversations vers le dossier",
      "notifications_daily": "🗞️ Récap quotidien",
      "notifications_description": "Saviez-vous que vous pouvez gérer vos notifications pour chaque dossier ?",
      "notifications_none": "Pas de notifications",
      "notifications_real_time": "⚡ En temps réel",
      "notifications_weekly": "📬 Récap hebdomadaire",
      "pick": "Choisir un dossier",
      "placeholder": "Clients, guests, amis...",
      "name": "Nom du dossier",
      "intro": "Regroupez vos contacts pour filtrer votre inbox, cibler vos campagnes et déclencher des automatisations.",
      "suggestions": {
        "leads": "Prospects",
        "customers": "Clients",
        "collaborations": "Collaborations",
        "vip": "VIP",
        "orders": "Commandes"
      },
      "remove_from": "Retirer de {{folder}}",
      "title_one": "{{count}} dossier",
      "title_other": "{{count}} dossiers",
      "add_to_folder": "Ajouter au dossier",
      "remove_from_folder": "Retirer du dossier",
      "save_order": "Sauvegarder l'ordre des dossiers"
    },
    "inbox_empty": "Soit votre messagerie Instagram est vide, soit nous n'avons pas fini de synchroniser vos messages. Revenez un peu plus tard !",
    "no_messages": "Il n'y a aucune conversation dans ce dossier.\nSwipez sur une conversation pour la déplacer.",
    "pending_messages_text": "Nous envoyons vos messages un par un pour protéger votre compte Instagram.",
    "pending_messages_title_one": "{{count}} message restant",
    "pending_messages_title_other": "{{count}} messages restant",
    "permissions": {
      "allow_access": "Autoriser l'accès à vos messages",
      "allow_access_text": "Vous devez autoriser l'accès dans vos Paramètres Instagram.",
      "authorisation_missing": "Autorisation manquante",
      "authorisation_missing_text": "Nous avons perdu l'accès à votre messagerie. Veuillez vous réauthentifier.",
      "authorise": "Connecter votre compte",
      "connecting": "Connexion en cours...",
      "facebook_error_text": "Nous avons rencontré un problème lors de la connexion à votre compte Instagram. Nous avons été notifié et travaillons à résoudre le problème. Veuillez réessayer plus tard ou résoudre l'erreur ci-dessous.",
      "facebook_error_title": "Erreur de connexion",
      "instagram_success_text": "Pendant qu'on synchronise vos DMs, créez votre premier dossier et rangez vos conversations !",
      "instagram_success_title": "✨ Inbox Instagram connectée ! ✨",
      "many_pages": {
        "text": "Il semblerait que vous avez sélectionné plusieurs page Facebook. Merci de choisir celle que souhaitez connecter.",
        "title": "Plusieurs pages Facebook sélectionnées"
      },
      "no_instagram": {
        "text": "Pour connecter votre messagerie, vous devez avoir un compte Instagram Business relié à la page Facebook sélectionnée.",
        "title": "Pas de compte Instagram"
      },
      "no_page": {
        "text": "Pour connecter votre messagerie, vous devez avoir une page Facebook reliée à votre compte Instagram Business.",
        "title": "Page Facebook manquante"
      },
      "reauthorise": "Redonner l'accès",
      "retry": "Retenter la connexion",
      "settings_changed": "J'ai modifié mes paramètres",
      "show_me_how": "Où trouver ce paramètre ?",
      "why_facebook": "Pourquoi ai-je besoin de Facebook ?",
      "wrong_login_method": {
        "title": "Mauvaise méthode de connexion",
        "description": "Ce compte est lié via {{method}}. Reconnectez-vous avec la même méthode."
      },
      "instagram_already_connected": {
        "description": "Le compte Instagram **{{username}}** est déjà connecté à un autre compte. Veuillez connecter un autre compte ou contactez le support.",
        "title": "Compte Instagram déjà connecté",
        "description_current": "**{{username}}** est le compte Instagram que vous utilisez déjà.",
        "description_member": "Vous avez déjà connecté **{{username}}**.",
        "switch_cta": "Changer pour {{username}}",
        "recover_text": "Si cet autre compte est le vôtre, nous pouvons envoyer un lien de connexion à toutes les personnes qui en font partie.",
        "recover_cta": "Récupérer mon compte",
        "error": "L'envoi de l'email a échoué. Réessayez ou contactez le support."
      },
      "account_not_found": {
        "text": "Le compte Instagram est introuvable. Vérifiez que vous avez autorisé la bonne page Facebook et compte Instagram.",
        "title": "Compte Instagram introuvable"
      }
    },
    "promo_codes": {
      "notice": "Code **{{code}}** actif jusqu'au **{{date}}**"
    },
    "recent_searches": "Recherches récentes",
    "search_empty": "Aucun résultat",
    "search_empty_text": "Tapez pour chercher dans vos conversations",
    "segments": {
      "ambassadors": "Ambassadeurs",
      "potential_clients": "Clients potentiels"
    },
    "select": "Sélectionner",
    "select_all": "Sélectionner tout",
    "select_max": "Tout sélectionner",
    "selected": "selectionné",
    "selection_limit": "Vous ne pouvez pas sélectionner plus de {{count}} conversations à la fois.",
    "settings": {
      "export_cta": "Télécharger au format Excel",
      "export_subtitle": "Uniquement les contacts qui ont rempli leurs informations personnelles pour un paiement ou un rendez-vous.",
      "export_title": "Exporter les informatons des contacts",
      "folder_notifications": "Notifications par dossier",
      "manage_folders": "Gérer les dossiers",
      "mark_all_read": "Marquer tout comme lu",
      "spam_messages": "Dossier spam",
      "sync_inbox": "Synchroniser les messages",
      "title": "Paramètres"
    },
    "sync_in_progress": "Synchronisation en cours",
    "sync_in_progress_text": "Nous synchronisons vos conversations et vos contacts.",
    "timeoff": {
      "activate": "Activer",
      "calendar_title": "Choisissez le dernier jour",
      "description": "Cette réponse sera envoyée automatiquement la première fois qu'une personne vous contacte pendant la période sélectionnée.",
      "keep_active": "Indéfiniment",
      "last_day": "Dernier jour: {{day}}",
      "notice": "Réponse automatique activée",
      "notice_until": "Réponse automatique activée jusqu'au {{date}}",
      "placeholder": "Votre message…",
      "save": "Sauvegarder",
      "set_end_date": "Définir le dernier jour",
      "title": "Réponse automatique"
    },
    "title": "Messages",
    "audio_messages": {
      "modal": {
        "title": "Envoyez un message audio",
        "upload_file": "Choisissez un fichier audio",
        "record_audio": "ou enregistrez votre message"
      }
    },
    "message_error": "Erreur d'envoi du message",
    "search_messages": "Chercher dans les messages",
    "message_pending": "Message en attente d'envoi"
  },
  "email_preferences": {
    "title": "Préférences email",
    "subtitle": "Choisissez les emails que **{{email}}** reçoit.",
    "saved": "Préférences enregistrées",
    "save_failed": "Nous n'avons pas pu enregistrer. Veuillez réessayer.",
    "unsubscribe_all": "Se désabonner de tout",
    "arrived_from": "Vous êtes arrivé ici depuis un email *{{category}}*.",
    "transactional_notice": "Vous continuerez à recevoir les emails que nous devons vous envoyer : factures, problèmes de paiement, réinitialisations de mot de passe, exports demandés et alertes de sécurité sur votre compte.",
    "categories": {
      "account_alerts": {
        "label": "Alertes du compte",
        "description": "Déconnexion de votre compte Instagram, automatisations mises en pause ou suspendues, et autres problèmes qui empêchent votre compte de fonctionner."
      },
      "product_news": {
        "label": "Nouveautés et actualités",
        "description": "Nouvelles fonctionnalités, mises à jour du produit et quelques conseils pour tirer le meilleur de votre compte."
      },
      "weekly_reports": {
        "label": "Rapport hebdomadaire",
        "description": "Un résumé hebdomadaire de vos conversations, de vos automatisations et de vos résultats."
      },
      "campaign_reports": {
        "label": "Rapports de campagnes et de tâches",
        "description": "Les résultats de chaque campagne et tâche en arrière-plan, comme une détection de propriété, une fois terminée."
      }
    }
  },
  "languages": {
    "aa": "Afar",
    "ab": "Abkhazian",
    "ae": "Avestan",
    "af": "Afrikaans",
    "ak": "Akan",
    "am": "Amharic",
    "an": "Aragonese",
    "ar": "Arabe",
    "as": "Assamese",
    "av": "Avaric",
    "ay": "Aymara",
    "az": "Azerbaijani",
    "ba": "Bashkir",
    "be": "Belarusian",
    "bg": "Bulgarian",
    "bh": "Bihari languages",
    "bi": "Bislama",
    "bm": "Bambara",
    "bn": "Bengali",
    "bo": "Tibetan",
    "br": "Breton",
    "bs": "Bosnian",
    "ca": "Catalan",
    "ce": "Chechen",
    "ch": "Chamorro",
    "co": "Corsican",
    "cr": "Cree",
    "cs": "Czech",
    "cu": "Church Slavic",
    "cv": "Chuvash",
    "cy": "Welsh",
    "da": "Danish",
    "de": "Allemand",
    "dv": "Maldivian",
    "dz": "Dzongkha",
    "ee": "Ewe",
    "el": "Grec",
    "en": "Anglais",
    "eo": "Esperanto",
    "es": "Espagnol",
    "et": "Estonien",
    "eu": "Basque",
    "fa": "Persian",
    "ff": "Fulah",
    "fi": "Finnish",
    "fj": "Fijian",
    "fo": "Faroese",
    "fr": "Français",
    "fy": "Western Frisian",
    "ga": "Irish",
    "gd": "Gaelic",
    "gl": "Galician",
    "gn": "Guarani",
    "gu": "Gujarati",
    "gv": "Manx",
    "ha": "Hausa",
    "he": "Hebrew",
    "hi": "Hindi",
    "ho": "Hiri Motu",
    "hr": "Croatian",
    "ht": "Haitian",
    "hu": "Hongrois",
    "hy": "Armenien",
    "hz": "Herero",
    "ia": "Interlingua",
    "id": "Indonesian",
    "ie": "Interlingue",
    "ig": "Igbo",
    "ii": "Sichuan Yi",
    "ik": "Inupiaq",
    "io": "Ido",
    "is": "Icelandic",
    "it": "Italien",
    "iu": "Inuktitut",
    "ja": "Japonais",
    "jv": "Javanese",
    "ka": "Georgian",
    "kg": "Kongo",
    "ki": "Kikuyu",
    "kj": "Kuanyama",
    "kk": "Kazakh",
    "kl": "Kalaallisut",
    "km": "Central Khmer",
    "kn": "Kannada",
    "ko": "Korean",
    "kr": "Kanuri",
    "ks": "Kashmiri",
    "ku": "Kurdish",
    "kv": "Komi",
    "kw": "Cornish",
    "ky": "Kirghiz",
    "la": "Latin",
    "lb": "Luxembourgeois",
    "lg": "Ganda",
    "li": "Limburgan",
    "ln": "Lingala",
    "lo": "Lao",
    "lt": "Lithuanian",
    "lu": "Luba-Katanga",
    "lv": "Latvian",
    "mg": "Malagasy",
    "mh": "Marshallese",
    "mi": "Maori",
    "mk": "Macedonian",
    "ml": "Malayalam",
    "mn": "Mongolian",
    "mr": "Marathi",
    "ms": "Malay",
    "mt": "Maltese",
    "my": "Burmese",
    "na": "Nauru",
    "nb": "Norwegian",
    "nd": "North Ndebele",
    "ne": "Nepali",
    "ng": "Ndonga",
    "nl": "Dutch",
    "nn": "Norwegian",
    "no": "Norwegian",
    "nr": "South Ndebele",
    "nv": "Navajo",
    "ny": "Chichewa",
    "oc": "Occitan",
    "oj": "Ojibwa",
    "om": "Oromo",
    "or": "Oriya",
    "os": "Ossetic",
    "pa": "Panjabi",
    "pi": "Pali",
    "pl": "Polish",
    "ps": "Pushto",
    "pt": "Portuguese",
    "qu": "Quechua",
    "rm": "Romansh",
    "rn": "Rundi",
    "ro": "Romanian",
    "ru": "Russian",
    "rw": "Kinyarwanda",
    "sa": "Sanskrit",
    "sc": "Sardinian",
    "sd": "Sindhi",
    "se": "Northern Sami",
    "sg": "Sango",
    "si": "Sinhala",
    "sk": "Slovak",
    "sl": "Slovene",
    "sm": "Samoan",
    "sn": "Shona",
    "so": "Somali",
    "sq": "Albanian",
    "sr": "Serbian",
    "ss": "Swati",
    "st": "Sotho, Southern",
    "su": "Sundanese",
    "sv": "Swedish",
    "sw": "Swahili",
    "ta": "Tamil",
    "te": "Telugu",
    "tg": "Tajik",
    "th": "Thai",
    "ti": "Tigrinya",
    "tk": "Turkmen",
    "tl": "Tagalog",
    "tn": "Tswana",
    "to": "Tonga",
    "tr": "Turkish",
    "ts": "Tsonga",
    "tt": "Tatar",
    "tw": "Twi",
    "ty": "Tahitian",
    "ug": "Uighur",
    "uk": "Ukrainien",
    "ur": "Urdu",
    "uz": "Uzbek",
    "ve": "Venda",
    "vi": "Vietnamese",
    "vo": "Volapük",
    "wa": "Walloon",
    "wo": "Wolof",
    "xh": "Xhosa",
    "yi": "Yiddish",
    "yo": "Yoruba",
    "za": "Zhuang",
    "zh": "Chinois",
    "zu": "Zulu"
  },
  "landing_page": {
    "sign_up_tab": "Inscription",
    "sign_in_tab": "Connexion"
  },
  "locale": "fr",
  "mentions": {
    "reply": {
      "placeholder": "Entrer votre commentaire...",
      "title": "Répondre par commentaire",
      "your_reply": "Votre réponse"
    },
    "title": "Mentions"
  },
  "navigation": {
    "dashboard": "Tableau de bord",
    "automation": "Automatisation",
    "calendar": "Agenda",
    "campaigns": "Campagnes",
    "contacts": "Contacts",
    "folders": "Dossiers",
    "inbox": "Messages",
    "intents": "Intentions",
    "payments": "Paiements",
    "profile": "Profil",
    "segments": "Segments",
    "signout": "Déconnexion",
    "conversion_links": "Liens de conversion",
    "scenarios": "Scénarios",
    "agent": "Assistant IA",
    "surveys": "Sondages",
    "content": "Contenu IG",
    "stories": "Stories",
    "request_access": "Demander l'accès",
    "medias": "Posts & reels",
    "beta": "Beta",
    "menu": "Menu",
    "help": "Obtenir de l'aide"
  },
  "notifications": {
    "activate": "Activer",
    "alert_title": "Activer les notifications",
    "business_description": "Notifications pour les paiements et rendez-vous",
    "business_title": "Professionnel",
    "folders": {
      "alert_text": "Vous pouvez activer les notifications pour ce dossier spécifiquement",
      "name": "Gérer les notifications par dossier"
    },
    "folders_description": "Notifications pour vos dossiers.",
    "folders_title": "Dossier",
    "inbox_description": "Notifications pour les messages.",
    "inbox_title": "Messagerie",
    "later": "Plus tard",
    "messages": {
      "alert_text": "Recevez des notifications pour vos DMs selon vos préférences",
      "all": {
        "description": "Allez, tous les likes, messages, réactions, etc.",
        "label": "Tous les messages"
      },
      "disabled": {
        "cta": "Je ne veux pas de notifications",
        "description": "Désactiver toutes les notifications de messages.",
        "label": "Pas de notifications"
      },
      "first": {
        "description": "Les personnes qui vous envoient un message pour la première fois.",
        "label": "Premiers messages uniquement"
      },
      "less": {
        "description": "Tout sauf les likes, réactions et mentions en story.",
        "label": "Moins de messages"
      },
      "preferences": "Choisissez vos préférences de notifications",
      "tagline": "Réduisez les distractions"
    },
    "permissions_missing_action": "Ouvrir les Réglages",
    "permissions_missing_text": "Vous devez autoriser Inrō à vous envoyer des notifications",
    "permissions_missing_title": "Permissions manquantes",
    "preview_label": "Aperçu de la notification",
    "preview_time": "2m",
    "title": "Notifications",
    "weekly": {
      "alert_text": "Recevez une notification une fois par semaine avec les statistiques de votre inbox",
      "name": "Statistiques de la semaine",
      "preview_text": "Vous avez reçu 240 messages, 120 réactions à des stories et répondu à 130 messages. 80 messages en attente.",
      "preview_title": "130 messages traités"
    }
  },
  "automation_logs": {
    "title": "Automatisations",
    "search": "Rechercher par contact",
    "empty": "Aucune automatisation exécutée pour le moment",
    "deleted": "Supprimé",
    "types": {
      "scenario_execution": "Scénario",
      "campaign_execution": "Campagne"
    },
    "filters": {
      "all_types": "Tous les types",
      "all_statuses": "Tous les statuts"
    },
    "table": {
      "columns": {
        "execution_type": "Type",
        "runnable": "Nom",
        "contact": "Contact",
        "status": "Statut",
        "created_at": "Date"
      }
    }
  },
  "onboarding": {
    "about_you": {
      "app_website": "App ou site internet",
      "beauty": "Beauté & cosmétiques",
      "brand": "Marque ecommerce",
      "company_size": "Taille de l'entreprise",
      "content_creator": "Créateur de contenu",
      "description": "Aidez-nous à améliorer Inrō en nous donnant plus d'information sur vous et votre entreprise. Cela nous aidera à prioriser les fonctionnalités en développment.",
      "fashion": "Mode & luxe",
      "food": "Alimentation",
      "industry_placeholder": "Choisir une industrie",
      "music": "Musique & divertissement",
      "other": "Autre",
      "small_business": "Petite entreprise",
      "tech": "Technologie",
      "title": "Dites-nous en plus sur vous",
      "website": "Site de l'entreprise",
      "your_industry": "Votre industrie",
      "your_profile": "Votre profile",
      "article": "Je l'ai lu dans un article",
      "hear_about": "Comment avez-vous entendu parler de Inrō ?",
      "instagram": "Un post ou une publicité sur Instagram",
      "other_source": "Autre",
      "product_hunt": "Sur Product Hunt",
      "search": "Via un moteur de recherche",
      "word_of_mouth": "Quelqu'un m'en a parlé",
      "hear_about_placeholder": "Choisir une option",
      "linkedin": "Un contenu ou une publicité LinkedIn",
      "youtube": "Une vidéo ou publicité YouTube"
    },
    "connect_instagram": {
      "connect_facebook_cta": "S'authentifier avec Facebook",
      "connect_instagram_cta": "S'authentifier avec Instagram",
      "connect_facebook_check": "Je confirme que j'ai une **page Facebook** liée à mon compte Instagram",
      "connect_text": "Pour connecter vos messages, vous avez besoin d'un **compte Instagram Pro ou Créateur** et une **page Facebook** liée à ce compte.",
      "connect_title": "Connectez vos comptes",
      "help": {
        "link": "Comment lier ma page Facebook",
        "switch": "Comment passer en Pro ?",
        "title": "Vidéos pour vous aider"
      },
      "description": "Pour connecter vos messages, vous avez besoin d'un compte Instagram Pro ou Créateur et d'une page Facebook liée.",
      "title": "Connectez votre compte Instagram \net automatisez vos DMs",
      "disclaimer": "Inrō est un <0>Fournisseur de technologie</0> vérifié par Meta. Nous sommes engagés à protéger vos données et respectons les <1>Conditions générales de la Plateforme Développeur Meta</1>.",
      "show_me_how": "Comment connecter mon compte ?",
      "facebook_page_text": "Votre compte Instagram doit être lié à une **page Facebook**.",
      "username_button": "Chercher le compte",
      "username_error": "Il n'y a aucun compte Pro ou Créateur avec ce nom d'utilisateur.",
      "username_error_button": "Comment passer mon compte en Professionnel",
      "username_label": "Quel est votre nom d'utilisateur sur Instagram ?",
      "username_placeholder": "super_compte_insta",
      "public_connect": {
        "title": "Connectez votre compte Instagram",
        "description": "Vous avez été invité à connecter le compte Instagram suivant à Inrō.",
        "cta": "Connecter Instagram",
        "reconnect_title": "⚠️ Reconnectez votre compte Instagram",
        "reconnect_description": "Nous avons perdu la connexion avec votre compte, merci de le reconnecter pour continuer à utiliser Inrō.",
        "reconnect_cta": "Reconnecter Instagram",
        "success_title": "🎉 Compte Instagram connecté",
        "success_description": "Le compte Instagram suivant a bien été connecté à Inrō.",
        "template_disclaimer": "Cette automatisation sera activée sur votre compte"
      }
    },
    "select_plan": {
      "description": "Choisissez votre plan et commencez à automatiser votre compte Instagram.",
      "discount_applied": "Votre code de réduction <0>{{code}}</0> sera appliqué automatiquement à la validation.",
      "enterprise_plan": {
        "ai_agent": "Accès anticipé à l'assistant IA",
        "automation_limit": "Automatisations illimitées",
        "contacts_limit": "Contacts activés illimités",
        "cta": "Nous contacter",
        "description": "Débloquez le plein potentiel de Inrō pour votre entreprise.",
        "pay_monthly": "Paiement mensuel ou annuel",
        "payments": "Paiements par DMs",
        "price": "Discutons !",
        "save_yearly": "Économisez 10% en payant à l'année",
        "title": "Entreprise"
      },
      "free_plan": {
        "automation_limit": "3 automatisations actives",
        "contacts_limit": "100 contacts actifs par mois",
        "credit_card": "Pas de carte bancaire",
        "description": "Gérez vos audiences avec des fonctionnalités simples.",
        "price": "0€",
        "title": "Gratuit",
        "no_mcp_server": "Serveur MCP et API non inclus",
        "cta": "Choisir le plan gratuit"
      },
      "pro_plan": {
        "automation_limit": "Automatisations illimitées",
        "contacts_limit": "500+ contacts actifs par mois",
        "cta": "Démarrer mon essai gratuit",
        "description": "Testez toutes les fonctionnalités pendant {{count}} jours gratuitement avant de vous abonner.",
        "per_month": "12,99€ / mois après {{count}} jours",
        "price": "Essai gratuit",
        "title": "Professionnel",
        "ai_features": "Fonctionnalités Agent IA",
        "mcp_server": "Accès au serveur MCP et à l'API",
        "cancel_anytime": "Annulez à tout moment",
        "price_scales": "Prix selon l'usage",
        "description_no_trial": "Accédez à toutes les fonctionnalités Pro dès aujourd'hui.",
        "price_no_trial": "Professionnel",
        "cta_no_trial": "S'abonner au plan pro",
        "per_month_no_trial": "12,99€ / mois",
        "link": "Voir le plan mensuel"
      },
      "title": "Bravo, tout est ok !",
      "annual_plan": {
        "mcp_server": "Accès au serveur MCP et à l'API",
        "automation_limit": "Automatisations illimitées",
        "contacts_limit": "10k contacts actifs par mois",
        "cta": "Choisir le plan annuel",
        "description": "Pour les marques qui veulent passer à l'échelle.",
        "every_month": "Tous les mois",
        "pay_annually": "Paiement annuel",
        "title": "Annuel",
        "transfer_method": "Virement disponible",
        "link": "Économisez avec le plan annuel"
      },
      "description_no_trial": "Abonnez-vous et profitez de toutes les fonctionnalités Pro."
    },
    "goals": {
      "ads_performance": "Améliorez les performances de vos publicités",
      "description": "Aidez-nous à vous recommander la meilleure façon d'utiliser Inrō !",
      "goals_label": "Quel est votre objectif principal ?",
      "integrate_instagram": "Intégrer Instagram avec votre application",
      "send_campaigns": "Envoyer des campagns de DMs sur Instagram",
      "title": "Comment comptez-vous utiliser Inrō ?",
      "automate_ai": "Automatiser vos DMs avec l'IA"
    },
    "navigation": {
      "about_you": {
        "description": "Dites-nous en plus sur vous",
        "time": "1 min",
        "title": "À propos de vous"
      },
      "connect_instagram": {
        "description": "Reliez vos messages",
        "time": "2 min",
        "title": "Connecter Instagram"
      },
      "select_plan": {
        "description": "Bravo, tout est ok!",
        "time": "1 min",
        "title": "Démarrer l'essai gratuit"
      },
      "goal": {
        "description": "Comment utiliser Inrō ?",
        "time": "1 min",
        "title": "Votre objectif"
      },
      "title": "Avant de commencer"
    },
    "checklist": {
      "create_folder": "Créer un dossier",
      "create_scenario": "Créer un scénario automatique",
      "dm_inro": "Nous écrire sur Instagram",
      "move_to_folder": "Ranger un contact dans un dossier",
      "send_campaign": "Envoyer votre première campagne",
      "subtitle": "Suivez ces étapes pour démarrer.",
      "title": "Bienvenue à bord !",
      "trigger_scenario": "Déclencher votre scénario"
    }
  },
  "payments": {
    "account": {
      "details": {},
      "stripe": {}
    },
    "actions": {
      "cancel_one": "Annuler le paiement",
      "cancel_other": "Annuler les paiements",
      "edit_one": "Modifier le paiement",
      "edit_other": "Modifier les paiements",
      "loading": "Mise à jour des paiements...",
      "mark_as_paid": "Marquer comme payé",
      "payments_selected_one": "Un paiement sélectionné",
      "payments_selected_other": "{{ count }} paiement sélectionnés",
      "refund": "Rembourser le paiement",
      "revert_to_pending": "Repasser en attente",
      "set_up": "Paramétrer les paiements",
      "title": "Lien de paiement",
      "view_details": "Voir le détail du paiement",
      "archive_confirm": "Les paiements archivés",
      "archive_one": "Archiver le paiement",
      "archive_other": "Archiver les paiements",
      "refresh": "Rafraîchir le statut"
    },
    "balance": {
      "available_now": "Disponible",
      "available_soon": "En cours",
      "awaiting": "En attente du paiement",
      "dashboard": "Voir le compte Stripe",
      "estimated_date": "Est.",
      "setup": "Configurer le compte bancaire",
      "setup_notice": "Vous pourrez retrouver votre solde disponible ici après avoir reçu des paiements.",
      "title": "Montant disponible",
      "transfer": "Virer vers un compte bancaire",
      "transfer_info": "Les virement sont effectués automatiquement tous les 1-2 jours ouvrés.",
      "transfers": "Historique des virements"
    },
    "details": {
      "amount_received": "Montant reçu",
      "amount_requested": "Montant demandé",
      "approximate_notice": "Montant approximatif, les frais exacts dépendent du mode de paiement utilisé par le client final",
      "goToConversation": "Voir la conversation",
      "payment_processing_fees": "Frais de paiement",
      "service_fees": "Frais de service",
      "status": "Statut du paiement",
      "title": "Détails du paiement"
    },
    "image": {
      "amount": "Montant",
      "service_fees": "Frais de service",
      "subtitle": "@{{name}} a envoyé un lien de paiement",
      "title": "Paiement requis",
      "total_amount": "Montant total"
    },
    "labels": {
      "attempted": "Tentative de paiement",
      "awaiting": "En attente",
      "cancelled": "Paiement annulé",
      "error": "Erreur de paiement",
      "failed": "Échec de paiement",
      "manual": "Marqué comme payé",
      "paid": "Paiement confirmé",
      "pending": "En attente du paiement",
      "refunded": "Remboursé",
      "sent": "Lien de paiement envoyé",
      "any": "Tous les paiements"
    },
    "modal": {
      "description": "Objet du paiement",
      "description_placeholder": "ex. Acompte pour votre commande",
      "send": "Envoyer le lien",
      "service_fees": "{{total}} après frais",
      "set_up_cta": "Configurer le compte",
      "set_up_notice": "Vous devez configurer votre compte avant de recevoir des paiements.",
      "title": "Générer votre lien de paiement"
    },
    "no_contact": "Pas de contact",
    "no_filtered_payments": "Aucun paiement trouvé",
    "no_filtered_payments_description": "Nous n'avons pas trouvé de paiements liés à votre recherche.",
    "no_payments": "Pas de paiement",
    "no_payments_cta": "Configurer les paiements",
    "no_payments_description": "Envoyer des liens de paiement à vos clients et recevez vos paiements directement dans votre compte.",
    "page": {
      "accept_terms": "<0>J'accepte les </0><1>conditions générales</1>.",
      "can_close": "Vous pouvez fermer cette fenêtre.",
      "confirm": "Confirmer le paiment",
      "download_invoice": "Télécharger la facture",
      "in_progress": "Paiement en cours...",
      "invoice_address": "Adresse de facturation",
      "invoice_company": "Nom de l'entreprise",
      "invoice_extra": "Autres informations (TVA, etc.)",
      "invoice_form_title": "Détails de la facture",
      "payment_failed": "Erreur de paiement, veuillez réessayer.",
      "request_invoice": "Obtenir une facture",
      "stripe_notice": "Paiement sécurisé par Stripe",
      "thank_you": "Merci pour votre paiement."
    },
    "paid": "{{amount}} payé",
    "paid_on": "Payé le {{date}}",
    "settings": {
      "details": {
        "address": "Adresse",
        "address_details": "Infos additionnelles",
        "address_details_placeholder": "Étage, bâtiment, etc.",
        "city": "Ville",
        "company_name": "Entreprise",
        "country": "Pays",
        "description": "Enregistrez vos informations personnelles ou professionnelles",
        "dob": "Date de naissance",
        "first_name": "Prénom",
        "invalid_phone": "Numéro de téléphone incorrect",
        "last_name": "Nom",
        "locked": "Vous ne pouvez plus modifier vos informations une votre compte Stripe créé. Contactez-nous pour les modifier.",
        "phone": "Numéro de téléphone",
        "postal_code": "Code postal",
        "title": "Informations du compte",
        "type_company": "Entreprise",
        "type_individual": "Individu"
      },
      "general": {
        "added": "Ajouté au total",
        "country_description": "Sélectionnez votre pays et la devise dans laquelles vous souhaitez recevoir vos paiements.",
        "country_not_supported": "Ce pays n'est pas encore disponible.",
        "country_title": "Pays & devise",
        "currency": "Devise",
        "currency_placeholder": "Choissez une devise",
        "description": "Paramètres de pays et devise",
        "included": "Inclus dans le total",
        "locked": "Vous ne pouvez pas modifier votre pays une fois votre compte Stripe créé. Contactez-nous pour le modifier.",
        "payment_card_background": "Arrière-plan des paiements",
        "payment_card_background_info": "Personnaliser votre arrière-plan de paiement selon votre identité visuelle.",
        "service_fees": "Frais de service",
        "service_fees_added": "Les {{fee}}% de frais sont ajoutés au montant demandé : vous demandez {{send}}, votre client paie {{pay}}, vous recevez {{receive}} .",
        "service_fees_included": "Les {{fee}}% de frais sont inclus dans le montant demandé : vous demandez {{send}}, votre client paie {{pay}}, vous recevez {{receive}}.",
        "title": "Paramètres généraux",
        "upload": "Chargez votre propre arrière-plan",
        "validation_error": "Choisissez un pays et une devise"
      },
      "notice": {
        "cta": "Comment faire",
        "text": "Envoyez des liens de paiement à vos clients.",
        "video_text": "Envoyez un lien de paiement directement par DM."
      },
      "stripe": {
        "description": "Configurez votre compte Stripe en 2 minutes",
        "title": "Configurer un compte Stripe"
      },
      "terms": {
        "description": "Demander à vos clients d'accepter vos conditions pour payer.",
        "input": "Lien vers vos conditions",
        "title": "Demander d'accepter les conditions"
      },
      "title": "Paramètres de paiement"
    },
    "filters": {
      "status": {
        "all": "Tous les paiements",
        "awaiting": "En attente",
        "paid": "Payé",
        "manual": "Marqué comme payé",
        "cancelled": "Annulé"
      }
    },
    "show_all": "Voir tous les paiements",
    "table": {
      "columns": {
        "contact": "Contact",
        "amount": "Montant",
        "status": "Statut",
        "created_at": "Date"
      }
    },
    "title": "Paiements",
    "tabs": {
      "active": "Actifs",
      "archived": "Archivés"
    }
  },
  "platform_logs": {
    "title": "Journaux de la plateforme"
  },
  "profile": {
    "account": "Compte",
    "account_holder": "Titulaire",
    "account_updated": "Votre compte a été mis à jour",
    "balance": "Montant disponible",
    "bank_details": "Compte bancaire",
    "business": "Commercial",
    "cancel_delete": "Annuler la suppression du compte",
    "connected_accounts": "Comptes associés",
    "contact_us": "Nous contacter",
    "create_organization": "Créer un nouveau compte",
    "delete_action": "Supprimer mon compte",
    "delete_confirm": "Toutes vos données seront supprimées et vous ne pourrez plus vous connecter. Vos conversations ne seront pas affectés dans Instagram.",
    "delete_confirmation": "Votre compte sera supprimé dans 24h. Vous pouvez annuler à tout moment.",
    "delete_organization": "Supprimer le compte",
    "delete_organization_confirm": "Êtes-vous sûr de vouloir supprimer ce compte ? Toutes ses données seront supprimées. Cette action est irréversible.",
    "download_payments": "Télécharger au format Excel",
    "integrations": "Intégrations",
    "api": "API & MCP",
    "instagram_account": {
      "confirm_disconnect": "Toutes les conversations et contacts Instagram seront supprimés de Inrō. Cette action est irréversible. Êtes-vous sûrs ?",
      "connect": "Connecter un compte Instagram",
      "connected_with_account": "Connecté avec le compte",
      "metrics_report": {
        "title": "Rapport de métriques Instagram",
        "generate": "Générer le rapport",
        "download": "Télécharger le rapport",
        "regenerate": "Régénérer le rapport",
        "generated_on": "Généré le {{date}}",
        "generating": "Génération en cours. Nous vous l'enverrons par e-mail quand il sera prêt."
      },
      "unlink": {
        "button": "Déconnecter le compte Instagram",
        "title": "Déconnecter @{{username}} ?",
        "warning": "Les données ci-dessous seront supprimées définitivement et vous reviendrez à l'onboarding. Cette action est irréversible.",
        "counts": {
          "contacts": "Contacts",
          "conversations": "Conversations",
          "messages": "Messages",
          "comments": "Commentaires",
          "mentions": "Mentions",
          "medias": "Publications",
          "stories": "Stories",
          "executions": "Historique des automatisations"
        },
        "kept": "Vos automatisations, campagnes et dossiers sont conservés.",
        "type_username": "Saisissez **{{username}}** pour confirmer",
        "confirm": "Déconnecter et supprimer les données"
      },
      "view_details": "Voir les détails",
      "connection_issue": "Problème de connexion Instagram",
      "reconnect_hint": "Reconnectez-vous pour corriger les problèmes de permissions ou de synchronisation. Utilisez le même compte.",
      "details": {
        "status": "Statut",
        "connected_since": "Connecté depuis"
      },
      "followers": "Followers",
      "following": "Following",
      "subtitle": "Connecter un compte Instagarm pour gérer et envoyer les messages.",
      "title": "Compte Instagram",
      "missing_permissions": {
        "description": "Il nous manque des autorisations sur votre compte Instagram. Certaines fonctionnalités risquent de ne pas fonctionner.",
        "fix": "Corriger les problèmes",
        "instagram_basic": "Profil Basique - Accès à votre compte et vos posts récents",
        "instagram_manage_comments": "Commentaires - Répondre aux commentaires sur votre contenu",
        "instagram_manage_messages": "Messages Direct - Envoyer des DMs à vos contacts",
        "pages_manage_metadata": "Messages Directs - Synchroniser vos DMs en temps réel",
        "pages_read_engagement": "Réponses de story - Détecter les réponses à vos stories",
        "pages_show_list": "Pages - Lister vos pages connectées",
        "public_profile": "Profile Public - Accès aux informations publiques de votre compte",
        "reconnect": "Redonner accès au compte",
        "short_description": "Certaines fonctionnalités risquent de ne pas fonctionner.",
        "title": "Permissions manquantes",
        "instagram_manage_insights": "Stories - Statistiques sur vos stories récentes",
        "instagram_business_manage_messages": "Messages privés - Envoyer des DMs à vos contacts",
        "instagram_business_manage_insights": "Statistiques - Statistiques sur vos posts et stories"
      },
      "authorization_error": {
        "description": "Il y a un problème avec votre compte Instagram.",
        "title": "Erreur d'authorisation",
        "view_issue": "Voir l'erreur"
      },
      "reconnect_account": "Reconnecter le compte",
      "reconnect_modal": {
        "title": "Reconnecter votre compte",
        "description": "Assurez-vous de vous connecter avec le même compte.",
        "facebook_user": "Utilisateur Facebook",
        "facebook_page": "Page Facebook",
        "instagram_account": "Compte Instagram"
      },
      "reconnect_error": {
        "title": "Échec de la reconnexion",
        "invalid_account": "Vous vous êtes connecté avec un autre compte Instagram. Rien n'a changé. Réessayez avec @{{username}}.",
        "account_not_found": "Aucun compte Instagram trouvé pour cette connexion. Rien n'a changé. Réessayez avec la page Facebook liée à @{{username}}.",
        "no_page": "Aucune page Facebook n'a été sélectionnée. Rien n'a changé. Réessayez en sélectionnant la page liée à @{{username}}.",
        "multiple_pages": "Plusieurs pages Facebook ont été sélectionnées. Rien n'a changé. Réessayez avec uniquement la page liée à @{{username}}.",
        "already_connected": "Ce compte Instagram est déjà connecté ailleurs. Rien n'a changé.",
        "wrong_login_method": "Ce compte a été connecté avec une autre méthode. Rien n'a changé. Utilisez la même méthode qu'avant.",
        "default": "Impossible de reconnecter votre compte. Rien n'a changé. Réessayez."
      },
      "status": {
        "connected": "Connecté",
        "disconnected": "Déconnecté",
        "error": "Erreur de connexion",
        "restricted": "Restreint",
        "limited": "Limité",
        "never_connected": "Non connecté",
        "not_connected": "Non connecté",
        "connection_error": "Erreur de connexion"
      },
      "connect_new_account": "Connecter un autre compte"
    },
    "contact_support": "Contacter le support",
    "leave_organization": "Quitter le compte",
    "leave_organization_confirm": "Êtes-vous sûr de vouloir quitter ce compte ? Vous perdrez accès à toutes ses données.",
    "log_out": "Déconnexion",
    "manage_subscription": "Gérer l'abonnement",
    "organization_name": "Nom du compte",
    "team_members": {
      "add_user": "Ajouter un utilisateur",
      "add_user_dialog": "Voulez-vous inviter une personne à vous rejoindre ?",
      "owner": "Propriétaire",
      "make_owner": "Définir comme propriétaire",
      "make_owner_confirm": "Définir cet utilisateur comme propriétaire ? Vous deviendrez un membre standard.",
      "remove_user": "Retirer l'utilisateur",
      "remove_user_confirm": "Retirer cet utilisateur ?",
      "title": "Membres du compte"
    },
    "payment_settings": "Paramètres de paiement",
    "payments": "Paiements",
    "payments_history": "Historique des paiements",
    "personal_account": "Mon compte",
    "platform_logs": "Historique d'activité",
    "privacy_policy": "Politique de confidentialité",
    "share": "Partager à vos amis",
    "switch_organization": "Changer de compte",
    "title": "Profil",
    "connect_new_account": "Connecter un compte",
    "switcher": {
      "title": "Changer de compte"
    },
    "privacy": {
      "title": "Paramètres de confidentialité",
      "subtitle": "Choisissez les données facultatives que nous collectons.",
      "refresh_title": "Actualiser la page",
      "refresh_message": "La page doit être actualisée pour appliquer ce changement.",
      "refresh_confirm": "Actualiser"
    }
  },
  "organization_suspended": {
    "title": "Compte suspendu",
    "message_before": "Ce compte a été suspendu pour non-respect de nos ",
    "message_after": ". Votre compte Instagram a été déconnecté et vos automatisations ne peuvent plus s'exécuter.",
    "terms_of_service": "conditions d'utilisation",
    "contact_support_before": "Si vous pensez qu'il s'agit d'une erreur, contactez ",
    "contact_support_email": "support@inroapp.com",
    "contact_support_after": " pour faire appel de cette décision.",
    "switch_organization": "Changer de compte",
    "log_out": "Déconnexion"
  },
  "promo_codes": {
    "activate": "Activer un code promo",
    "activated_codes": "Codes activés",
    "active_until": "Actif jusqu'au {{date}}",
    "custom_fee": "{{fee}}% de frais de service",
    "error": "Code invalide",
    "expired_on": "Expiré le {{date}}",
    "label": "Entrez le code",
    "starts_on": "Débute le {{date}}",
    "success": "Code activé",
    "title": "Codes promo"
  },
  "shared": {
    "load_failed": "Impossible de charger ce contenu. Réessayez.",
    "load_timeout": "Le chargement prend trop de temps. Réessayez.",
    "rerun_executions": {
      "title_limited": "Lancer les exécutions en attente",
      "title_disconnected": "Lancer les exécutions en pause",
      "description_limited": "Ces exécutions ont été mises en pause car vous avez atteint votre limite mensuelle d'activations de contacts. Choisissez lesquelles lancer — les autres seront annulées.",
      "description_disconnected": "Ces exécutions ont été mises en pause pendant que votre compte Instagram était déconnecté. Choisissez lesquelles lancer — les autres seront annulées.",
      "windows": {
        "all": "Tout l'historique",
        "week": "Les 7 derniers jours",
        "day": "Les dernières 24 heures"
      },
      "executions_count_one": "{{count}} exécution",
      "executions_count_other": "{{count}} exécutions",
      "run_button_one": "Lancer {{count}} exécution",
      "run_button_other": "Lancer {{count}} exécutions",
      "recap_run_one": "<0>{{count}} exécution</0> va être lancée ({{window}})",
      "recap_run_other": "<0>{{count}} exécutions</0> vont être lancées ({{window}})",
      "recap_cancel_one": "<0>{{count}} exécution plus ancienne</0> va être annulée",
      "recap_cancel_other": "<0>{{count}} exécutions plus anciennes</0> vont être annulées",
      "recap_warning": "Les exécutions annulées sont définitivement perdues, mais l'avertissement disparaîtra.",
      "cancel_all_limited": "Annuler toutes les exécutions limitées",
      "cancel_all_confirm_limited": "Annuler toutes les exécutions limitées ? Elles ne pourront pas être récupérées.",
      "confirm_button": "Lancer {{run}} et annuler {{cancel}}"
    },
    "tasks_in_progress": "{{count}} tâches en cours",
    "active": "Actif",
    "all_day": "Toute la journée",
    "appt": "RDV",
    "cancel": "Annuler",
    "back": "Retour",
    "clear": "Effacer",
    "clicked": "Cliqué",
    "close": "Fermer",
    "coming_soon": "Bientôt disponible",
    "coming_soon_text": "Cette fonctionnalité est en cours de développement et sera bientôt disponible. Nous vous informerons dès qu'elle est prête !",
    "completed": "Terminé",
    "confirm": "Confirmer",
    "connected": "Connecté",
    "continue": "Continuer",
    "copied": "Le texte a été copié !",
    "country_placeholder": "Choisissez un pays",
    "create": "Créer",
    "current_step": "Étape {{step}} sur {{total}}",
    "steps": "Étapes",
    "default": "Par défaut",
    "delete": "Supprimer",
    "delete_confirm": "Confirmer la suppression ?",
    "details": "Détails",
    "disabled": "Désactivé",
    "discard_changes": "Ne pas sauvegarder",
    "disconnect": "Déconnecter",
    "do_it_later": "Je le ferai plus tard",
    "filter_by": "Filtrer par",
    "filters_count_one": "1 filtre",
    "filters_count_other": "{{count}} filtres",
    "get_started": "Commencer",
    "in_progress": "En cours",
    "lets_go": "C'est parti !",
    "make_default": "Définir par défaut",
    "next": "Suivant",
    "no": "Non",
    "not_clicked": "Non cliqué",
    "not_connected": "Non connecté",
    "not_found_text": "Cette page n'existe pas ou a été déplacée.",
    "not_found_title": "Page introuvable",
    "not_started": "À faire",
    "ok": "Ok",
    "optional": "Optionnel",
    "other": "Autre",
    "password": "Mot de passe",
    "password_confirmation": "Confirmez le mot de passe",
    "password_confirmation_placeholder": "Entrez votre mot de passe de nouveau",
    "password_placeholder": "Entrez votre nouveau mot de passe",
    "password_too_short": "Votre mot de passe doit faire au moins 6 caractères",
    "passwords_dont_match": "Les mots de passe ne sont pas identiques",
    "remove": "Retirer",
    "replied": "Répondu",
    "reply": "Répondre",
    "request_review_action": "Laisser un avis",
    "request_review_text": "Si oui, n'hésitez pas à laisser un avis ou à noter l'application !",
    "request_review_title": "🫶 Vous appréciez Inrō ?",
    "required": "Obligatoire",
    "retry": "Réessayer",
    "save": "Sauvegarder",
    "search": "Recherche",
    "select": "Sélectionner",
    "select_option": "Choisir une option",
    "selected_one": "{{count}} sélectionné",
    "selected_other": "{{count}} sélectionnés",
    "send": "Envoyer",
    "settings": "Paramètres",
    "show_less": "Voir moins",
    "show_more": "Voir plus",
    "skip": "Passer à la suite",
    "total": "Total",
    "type_here": "Écrivez ici",
    "understood": "J'ai compris !",
    "unsaved_changes": "Vous avez des modifications non sauvegardées. Voulez-vous les abandonner ?",
    "use_setting": "Utiliser ce paramètre",
    "view": "Voir",
    "warning": "Attention",
    "yes": "Oui",
    "cancel_changes": "Annuler les changements",
    "duplicate": "Dupliquer",
    "edit": "Modifier",
    "errors": {
      "contact_us": "Contactez-nous si l'erreur persiste.",
      "description": "Pas d'inquiétude, nous avons été notifié et travaillons à la résoudre.",
      "refresh": "Rafraîchir la page",
      "title": "😬 Une erreur est survenue..."
    },
    "view_documentation": "Voir la documentation",
    "all": "Tout",
    "datepicker": {
      "separator": "à"
    },
    "last_saved": "Sauvegardé le {{date}}",
    "last_updated": "Mis à jour le {{date}}",
    "template": "Modèle",
    "test": "Test",
    "results": "Résultats",
    "hide": "Cacher",
    "unhide": "Ne pas cacher",
    "previous": "Précédent",
    "icon": "Icône",
    "expired": "Expiré",
    "excluding": "Sauf",
    "not_answered": "Non répondu",
    "date": "Date",
    "debug_mode_on": "Mode debug activé",
    "debug_mode_off": "Mode debug désactivé",
    "preview": "Aperçu",
    "caption": "Caption",
    "converted": "Converti",
    "media": "Média",
    "media_link": "Lien du média",
    "media_type": "Type de média",
    "view_media": "Voir le média",
    "pro": "Pro",
    "history": "Historique",
    "more_actions": "Plus d'actions",
    "insights": "Statistiques",
    "free": "Gratuit",
    "ai": "IA",
    "copy": "Copier",
    "reconnect": "Reconnecter",
    "same_organization": "Même compte",
    "add": "Ajouter",
    "add_emoji": "Ajouter un emoji",
    "learn_more": "En savoir plus",
    "else": "Sinon",
    "read_article": "Lire l'article",
    "wait": "Attendre",
    "from": "À partir de",
    "new": "Nouveau",
    "edit_folder": "Modifier le dossier",
    "delete_folder": "Supprimer le dossier",
    "create_folder": "Créer le dossier",
    "duplicate_folder": "Dupliquer le dossier",
    "keep_editing": "Continuer à modifier",
    "save_changes_question": "Enregistrer vos modifications ?",
    "unsaved_stay_draft": "Sinon, elles restent en brouillon.",
    "save_and_close": "Enregistrer et fermer",
    "close_keep_draft": "Fermer, garder le brouillon",
    "error_loading": "Une erreur est survenue lors du chargement.",
    "error_saving": "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer.",
    "selected": "Sélectionné",
    "inactive": "Inactif",
    "optout": "Désabonnement",
    "open": "Ouvrir",
    "mute": "Couper le son",
    "unmute": "Activer le son"
  },
  "time": {
    "earlier": "Précédents",
    "hours": "heures",
    "min": "min",
    "minutes": "minutes",
    "now": "À l'instant",
    "this_month": "Ce mois-ci",
    "this_week": "Cette semaine",
    "today": "Aujourd'hui",
    "tomorrow": "Demain",
    "weekdays": ["L", "M", "M", "J", "V", "S", "D"],
    "yesterday": "Hier",
    "days": "jours",
    "seconds": "secondes",
    "weeks": "semaines",
    "time": "Heure"
  },
  "surveys": {
    "count_one": "1 sondage",
    "count_other": "{{count}} sondages",
    "create": "Créer un sondage",
    "create_first": "Créer votre premier sondage",
    "no_surveys": "Aucun sondage pour le moment",
    "search_surveys": "Rechercher des sondages",
    "select_survey": "Sélectionner un sondage",
    "current_survey": "Sondage actuel",
    "delete_confirm": "Supprimer ce sondage ? Toutes ses données seront supprimées.",
    "edit_survey": "Modifier le sondage",
    "table": {
      "columns": {
        "title": "Titre",
        "survey_type": "Type",
        "sent": "Envoyés",
        "completed": "Complétés",
        "created_at": "Créé"
      }
    },
    "metrics": {
      "replied": "Réponses",
      "sent": "Envois",
      "completed": "Rempli",
      "completion_rate": "Taux de complétion"
    },
    "new_survey": "Créer un nouveau sondage",
    "options": {
      "option_placeholder": ["Bleu", "Rouge", "Vert"],
      "reply_placeholder": "Merci pour votre réponse.",
      "add_option": "Ajouter une option",
      "add_to_folder": "Ajouter au dossier",
      "and_reply": "puis répondre"
    },
    "subtitle_placeholder": "Sous-titre du sondage",
    "title": "Sondages",
    "title_placeholder": "Titre du sondage",
    "limit_replies": "Une seule réponse par contact",
    "replies_count_one": "1 réponse",
    "replies_count_other": "{{count}} réponses",
    "button_label_placeholder": "Texte du bouton",
    "default_button_label": "Bouton",
    "add_image": "Ajouter une image",
    "change_image": "Changer l'image",
    "preview": {
      "form": "Formulaire",
      "results": "Résultats",
      "template": "Message"
    },
    "questions": {
      "add_question": "Ajouter une questions",
      "count_one": "1 question",
      "count_other": "{{count}} questions",
      "edit_replies": "Modifier les options",
      "field_types": {
        "date": "Date",
        "email": "Email",
        "number": "Nombre",
        "phone": "Téléphone",
        "text": "Texte",
        "textarea": "Texte long",
        "multiple_choice": "Choix multiple",
        "url": "URL"
      },
      "save_to_property": "Sauvegarde la réponse en propriété du contact",
      "submit": "Confirmer",
      "title_placeholder": "Comment vous appelez-vous ?",
      "message": {
        "button": "Intitulé du bouton",
        "form_title": "Personnaliser le message",
        "preview": "Vos contacts verront ce message dans Instagram",
        "subtitle": "Sous-titre du message",
        "title": "Titre du message"
      },
      "multiple_choice": {
        "accept_multiple": "Accepter plusieurs réponses",
        "add_option": "Ajouter une option"
      },
      "no_questions": "Votre formulaire est vide. Ajoutez des questions pour démarrer !",
      "question_number": "Question #{{number}}",
      "results": {
        "completed_at": "Rempli le",
        "export": "Exporter les résultats"
      },
      "tabs": {
        "form": "Questionnaire",
        "integrations": "Intégrations",
        "message": "Message",
        "results": "Résultats"
      },
      "success_message": "Merci pour votre réponse !"
    },
    "survey_types": {
      "questions": {
        "description": "Posez plusieurs questions avec différents types de réponses",
        "preview": {
          "questions": ["Quel est votre nom ?", "Quel est votre email ?"],
          "subtitle": "Répondez à quelques questions",
          "title": "S'inscrire en ligne"
        },
        "title": "Plusieurs questions"
      },
      "single_choice": {
        "title": "Une seule question",
        "description": "Posez une seule question à choix multiple",
        "preview": {
          "options": ["Bleu", "Rouge", "Vert"],
          "subtitle": "Choisissez une des options suivantes",
          "title": "Quelle est votre couleur préférée ?"
        }
      },
      "title": "Choisir un type de sondage"
    },
    "run_test": "Tester le sondage",
    "run_test_confirm": "Envoyer le sondage à ce contact ?"
  },
  "login": {
    "description": "Vous avez déjà un compte? Connectez-vous pour accéder à vos audiences, campagnes et automatisations.",
    "email_label": "Email",
    "email_title": "ou connectez-vous avec votre email",
    "email_placeholder": "e.g. linda.lee@sprawl.com",
    "facebook": "Se connecter avec Facebook",
    "forgot_password": "Email ou mot de passe oublié ?",
    "google": "Se connecter avec Google",
    "log_in": "Se connecter",
    "no_account": "Pas de compte ?",
    "password_label": "Mot de passe",
    "sign_up_today": "Créer un compte",
    "tagline": "Bonjour \n et bienvenue !"
  },
  "redemption": {
    "unlimited": "Illimité",
    "allowances": {
      "accounts_one": "{{value}} compte Instagram",
      "accounts_other": "{{value}} comptes Instagram",
      "contacts": "{{value}} contacts par mois",
      "ai_credits": "{{value}} crédits IA par mois"
    }
  },
  "signup": {
    "already_account": "Vous avez déjà un compte ?",
    "company_label": "Entreprise",
    "company_placeholder": "e.g. Sprawl Inc.",
    "create_your_account": "Créer le compte",
    "description": "Pas encore de compte ? Créez-en un pour automatiser vos DMs !",
    "email_label": "Email",
    "email_placeholder": "e.g. linda.lee@sprawl.com",
    "email_title": "ou créer un compte avec votre email",
    "facebook": "S'inscrire avec Facebook",
    "google": "S'inscrire avec Google",
    "log_in": "Se connecter",
    "name_description": "Ce sera le nom de votre compte",
    "name_label": "Nom",
    "name_placeholder": "e.g. Linda Lee",
    "password_description": "6 caractères minimum",
    "password_label": "Mot de passe",
    "tagline": "Rejoignez-nous \ndès aujourd'hui !",
    "appsumo_banner": {
      "title": "Accès à vie sur AppSumo",
      "ends_in": "Temps restant sur l'offre AppSumo",
      "cta": "Profiter de l'offre",
      "units": {
        "days": "j",
        "hours": "h",
        "minutes": "min",
        "seconds": "s"
      }
    },
    "accept_terms": "En créant en compte, vous acceptez les <0>conditions d'utilisations</0> et la <1>politique de confidentialité</1>.",
    "special_offer": {
      "description": "Créez votre compte aujourd'hui et utilisez toutes nos fonctionnalités pro gratuitement pendant 14 jours. Pas besoin d'entrer de carte bancaire.",
      "offer": "14 jours gratuits",
      "title": "Offre spéciale"
    },
    "instagram_label": "Compte Instagram",
    "instagram_placeholder": "e.g. @sprawlinc",
    "redeem_code": "Utiliser une clé",
    "redeem_code_invalid": "Ce lien ou cette clé est invalide ou a déjà été utilisé."
  },
  "subscription": {
    "usage_history": {
      "title": "Historique d'utilisation",
      "current": "En cours",
      "activations_one": "{{formatted}} contact",
      "activations_many": "{{formatted}} contacts",
      "activations_other": "{{formatted}} contacts",
      "show_more": "Voir plus",
      "show_less": "Voir moins"
    },
    "usage_limits": {
      "title": "Appliquer une limite mensuelle",
      "max_contact_activations": "Max de contacts activés par mois",
      "max_contact_activations_description": "Les automatisations et campagnes se mettent en pause une fois la limite atteinte. Laissez vide pour ne pas en fixer.",
      "no_limit": "Aucune limite",
      "save": "Enregistrer",
      "saved": "Limite d'utilisation enregistrée"
    },
    "lifetime": {
      "subtitle": "Offre à vie",
      "renews_on": "Les quotas se renouvellent le {{date}}",
      "slots": "{{used}} comptes sur {{total}}",
      "slots_unlimited_one": "{{count}} compte",
      "slots_unlimited_other": "{{count}} comptes",
      "upgrade_tier": "Passer au niveau supérieur",
      "manage_caps": "Gérer vos quotas",
      "rail_title": "Vous êtes sur {{tier}}",
      "rail_description": "Votre offre n'expire pas. Vous avez atteint un quota mensuel — levez-le sur la page de facturation, ou changez de niveau là où vous avez acheté l'offre.",
      "caps_title": "Que se passe-t-il quand vous atteignez un quota",
      "caps_subtitle": "Les quotas sont partagés entre tous les comptes de votre code, et se renouvellent chaque mois.",
      "breakdown_title": "Utilisation par compte",
      "this_account": "Ce compte",
      "switch_to_account": "Basculer sur ce compte",
      "connection": {
        "disconnected": "Déconnecté",
        "login_error": "Reconnexion nécessaire"
      },
      "openai_key_label": "Votre clé API OpenAI",
      "openai_key_sublabel": "Utilisée pour tous les comptes de votre code, une fois les crédits du mois épuisés.",
      "update_error_title": "Enregistrement impossible",
      "update_error_description": "Vos paramètres de facturation n'ont pas été modifiés. Veuillez réessayer.",
      "add_accounts_title": "Ajouter vos autres comptes",
      "add_accounts_subtitle": "Les comptes que vous possédez et qui ne font pas encore partie de ce deal. En ajouter un le met sur le même plan et les mêmes quotas partagés — son historique de facturation reste où il est.",
      "add_accounts_full": "Votre deal couvre {{total}} comptes et ils sont tous utilisés. Libérez une place, ou passez à un palier supérieur là où vous avez acheté le deal.",
      "add_account": "Ajouter à mon deal",
      "add_account_error_title": "Impossible d'ajouter ce compte",
      "add_account_error_description": "Rien n'a été modifié. Réessayez, ou écrivez à support@inroapp.com.",
      "remove_account": "Retirer de mon deal",
      "remove_account_confirm": "Retirer {{name}} de votre deal ? Il repasse sur un plan gratuit. Ce qu'il a utilisé ce mois-ci continue de compter dans vos quotas.",
      "remove_account_error_title": "Impossible de retirer ce compte",
      "remove_account_error_description": "Rien n'a été modifié. Réessayez, ou écrivez à support@inroapp.com.",
      "cap_modes": {
        "hard": "S'arrêter au quota",
        "hard_contacts": "Les nouveaux contacts ne sont plus activés jusqu'au renouvellement. Rien n'est facturé.",
        "hard_credits": "Les étapes IA sont ignorées jusqu'au renouvellement. Rien n'est facturé.",
        "auto_billing": "Continuer et me facturer",
        "auto_billing_contacts": "Les contacts supplémentaires sont facturés en fin de mois.",
        "auto_billing_contacts_priced": "Les contacts supplémentaires sont facturés {{price}} l'unité en fin de mois.",
        "auto_billing_credits": "Les crédits supplémentaires sont facturés en fin de mois.",
        "auto_billing_credits_priced": "Les crédits supplémentaires sont facturés {{price}} l'unité en fin de mois.",
        "byok": "Utiliser ma propre clé OpenAI",
        "byok_description": "Une fois les crédits du mois épuisés, les étapes IA utilisent votre clé et nous ne facturons rien."
      },
      "tiers": {
        "appsumo_1": "Offre à vie — Niveau 1",
        "appsumo_2": "Offre à vie — Niveau 2",
        "appsumo_3": "Offre à vie — Niveau 3",
        "appsumo_4": "Offre à vie — Niveau 4",
        "appsumo_5": "Offre à vie — Niveau 5",
        "lifetime_1": "Offre à vie — Starter",
        "lifetime_2": "Offre à vie — Growth",
        "lifetime_3": "Offre à vie — Scale"
      },
      "card_required": "Une carte vous sera demandée avant l'activation.",
      "card_on_file": "Facturé sur la carte enregistrée.",
      "invoices_title": "Factures de dépassement",
      "invoice_line": "{{units}} contacts, {{credits}} crédits",
      "invoice_status": {
        "invoiced": "En attente de paiement",
        "paid": "Payée"
      },
      "auto_billing_confirm": "Au-delà de votre quota, chaque {{unit}} supplémentaire est facturé {{price}} en fin de mois. Activer ?",
      "units": {
        "contacts": "contact",
        "credits": "crédit"
      },
      "running_title": "Ce mois-ci",
      "running_line": "{{units}} contacts et {{credits}} crédits supplémentaires",
      "running_subtitle": "Pas encore facturé",
      "switch_account": "Changer de compte"
    },
    "ai_credits": {
      "title": "Crédits IA",
      "remaining_one": "{{count}} crédit restant",
      "remaining_other": "{{count}} crédits restants",
      "renews_on": "Renouvellement le {{date}}",
      "exhausted_title": "Vous n'avez plus de crédits IA",
      "exhausted_description": "Les étapes IA sont ignorées jusqu'au renouvellement. Activez la facturation automatique ou votre propre clé OpenAI pour qu'elles continuent.",
      "overage_one": "{{count}} crédit supplémentaire facturé ce mois-ci",
      "overage_other": "{{count}} crédits supplémentaires facturés ce mois-ci",
      "byok_active": "Fonctionne avec votre propre clé OpenAI"
    },
    "activated_contacts": "Contacts activés",
    "cancelled": "Résilié",
    "days_left_one": "1 jour restant",
    "days_left_other": "{{count}} jours restant",
    "free_plan": "Gratuit",
    "free_trial": "Essai gratuit",
    "manage_plan": "Gérer l'abonnement",
    "customer": "Compte de facturation",
    "payment_error": {
      "cta": "Gérer le paiement",
      "description": "Il y a eu une erreur avec votre dernier paiement. Réessayez ou contactez-nous.",
      "title": "Erreur de paiement",
      "unpaid_invoice_title": "Facture impayée",
      "unpaid_invoice_description": "Votre paiement de {{amount}} a échoué. Réglez cette facture pour rétablir les fonctionnalités.",
      "pay_invoice": "Payer {{amount}}",
      "unpaid_invoices_title": "Factures impayées",
      "unpaid_invoices_description": "Vous avez {{count}} factures impayées pour un total de {{amount}}. Réglez-les pour rétablir les fonctionnalités.",
      "pay_invoices": "Payer les factures",
      "managed_title": "Problème de paiement sur l'abonnement qui couvre ce compte",
      "managed_description": "Le partenaire qui gère ce compte a une facture impayée. Votre abonnement sera suspendu si elle n'est pas réglée.",
      "managed_cta": "Aller au tableau de bord partenaire"
    },
    "pro_plan": "Professionnel",
    "renews_on": "Renouvellement le {{date}}",
    "ends_on": "Se termine le {{date}}",
    "resets_on": "Utilisation remise à zéro le {{date}}",
    "upgrade_to_pro": "Passer en Professionnel",
    "upgrade_to_pro_confirm": "Mettre fin à votre essai gratuit maintenant et passer au forfait Pro ?",
    "start_free_trial": "Démarrer l'essai gratuit",
    "redeem_code": {
      "button": "Utiliser la clé",
      "error_description": "Cette clé est invalide, déjà utilisée ou ne peut pas être appliquée à ce compte.",
      "error_title": "Clé invalide",
      "have_code": "Utiliser une clé",
      "placeholder": "Entrez votre clé",
      "success_description": "Votre abonnement est maintenant actif.",
      "success_title": "Clé utilisée",
      "title": "Utiliser une clé"
    },
    "pro_notice": {
      "title": "Abonnement Professionnel requis",
      "description": "Cette fonctionnalité est disponible uniquement avec l'abonnement Professionnel. Passez à l'offre supérieure pour la débloquer.",
      "cta": "Passer en Professionnel"
    },
    "redeem_codes": {
      "title": "Clés utilisées"
    },
    "managed_by": "Géré par {{name}}",
    "managed_description": "Votre abonnement est inclus dans l'abonnement de votre partenaire.",
    "open_partner_dashboard": "Ouvrir le tableau de bord partenaire",
    "pro_upgrade": {
      "contacts_are_free": "Vos contacts sont stockés gratuitement sur tous les plans. Vous ne payez que ceux que vous activez.",
      "ledger": {
        "heading": "Ce qui change",
        "free_column": "Gratuit",
        "pro_column": "Pro",
        "not_included": "Non inclus",
        "scenarios": {
          "label": "Automatisations actives en même temps",
          "free": "3",
          "pro": "Sans limite"
        },
        "campaigns": {
          "label": "Campagnes que vous pouvez envoyer",
          "free": "3",
          "pro": "Sans limite"
        },
        "triggers": {
          "label": "Déclencheurs et actions",
          "free": "Les bases",
          "pro": "Tous"
        },
        "ai": {
          "label": "Agent IA qui répond dans votre ton",
          "pro": "Inclus"
        },
        "integrations": {
          "label": "Shopify, Calendly, webhooks, API, MCP",
          "pro": "Inclus"
        },
        "activations": {
          "label": "Contacts automatisés chaque mois",
          "free": "100",
          "pro": "Sans limite"
        },
        "members": {
          "label": "Personnes qui peuvent se connecter",
          "free": "1",
          "pro": "10"
        }
      },
      "rail": {
        "price": "12,99 €",
        "price_period": "/ mois",
        "price_note": "500 contacts automatisés par mois. Le prix suit votre usage.",
        "trial_cta_one": "Essai gratuit de 1 jour",
        "trial_cta_other": "Essai gratuit de {{count}} jours",
        "reassurance": "Annulez à tout moment.",
        "timeline_today_label": "Aujourd'hui",
        "timeline_today": "Toutes les fonctionnalités Pro débloquées. Votre carte n'est pas débitée.",
        "timeline_end_label_one": "Jour 1",
        "timeline_end_label_other": "Jour {{count}}",
        "timeline_end": "La facturation démarre. Annulez à tout moment avant.",
        "managed_title": "Ce compte est sur l'abonnement de {{name}}",
        "managed_description": "Demandez-leur de passer en Pro — le changement se fait sur leur tableau de bord, pas ici.",
        "invoice_title": "Réglez d'abord votre facture",
        "invoice_description": "Pro revient dès que le paiement passe."
      },
      "feature": {
        "default": {
          "title": "Vous êtes sur le plan gratuit",
          "description": "Automatisations et campagnes illimitées, tous les déclencheurs et actions, l'Agent IA et les intégrations."
        },
        "trigger": {
          "title": "Toutes les façons de vous joindre",
          "description": "Pro se déclenche sur les commentaires, sur les webhooks de votre site et sur les formulaires de votre landing page."
        },
        "action": {
          "title": "Plus que l'envoi d'un message",
          "description": "Testez deux versions d'un flow, appelez votre propre API, réservez un créneau Calendly ou passez la conversation à votre Agent IA."
        },
        "ai": {
          "title": "Un agent qui répond à vos DMs",
          "description": "Il apprend vos produits, écrit dans votre ton, et vous rend la conversation dès qu'il le faut."
        },
        "scenarios": {
          "title": "Autant d'automatisations qu'il vous en faut",
          "description": "Vous avez atteint votre limite de scénarios actifs. Passez en illimité avec Pro."
        },
        "campaigns": {
          "title": "Autant de campagnes qu'il vous en faut",
          "description": "Envoyez des campagnes DM plus ciblées et plus fréquentes, sans limite."
        },
        "activations": {
          "title": "Plus de plafond mensuel de contacts",
          "description": "Une fois la limite du plan gratuit atteinte, les nouveaux contacts attendent le 1er pour entrer dans vos automatisations."
        },
        "schedule_campaigns": {
          "title": "Envoyez à l'heure que vous choisissez",
          "description": "Le plan gratuit envoie tout de suite ; Pro envoie quand votre audience ouvre vraiment ses DMs."
        },
        "integrations": {
          "title": "Connectez le reste de vos outils",
          "description": "Commandes Shopify, réservations Calendly, conversions Meta, vos propres webhooks, plus l'API et le serveur MCP."
        },
        "custom_domain": {
          "title": "Vos liens sur votre propre domaine",
          "description": "Chaque lien que vous envoyez porte votre nom, et vos emails partent de votre adresse."
        },
        "members": {
          "title": "Jusqu'à 10 personnes sur le compte",
          "description": "Donnez accès à la boîte de réception sans donner votre mot de passe."
        },
        "api": {
          "title": "L'API et le serveur MCP",
          "description": "Construisez sur vos propres DMs, ou branchez un client IA directement sur vos contacts, vos automatisations et vos campagnes."
        },
        "payments": {
          "title": "Encaissez directement dans le DM",
          "description": "Envoyez un lien de paiement dans la conversation et encaissez sur place, sans page de paiement."
        },
        "folders": {
          "title": "Autant de dossiers qu'il vous en faut",
          "description": "Rangez contacts, automatisations et campagnes comme vous travaillez ; le plan gratuit s'arrête à dix."
        }
      }
    },
    "activated_contacts_suffix": ""
  },
  "integrations": {
    "stripe": {
      "title": "Compte Stripe",
      "subtitle": "Connectez un compte Stripe pour envoyer des liens de paiement à vos contacts.",
      "public_key": "Clé API publiable",
      "private_key": "Clé API restreinte",
      "private_key_saved": "Clé enregistrée — collez-en une nouvelle pour la remplacer",
      "get_api_key": "Comment obtenir vos clés API ?",
      "invalid_key": "Stripe a refusé cette clé. Collez-la à nouveau en entier.",
      "missing_permissions": "Les paiements échoueront avec cette clé. Ajoutez ces autorisations dans Stripe :",
      "permissions": {
        "payment_intents_write": "PaymentIntents : Écriture",
        "charges_read": "Charges : Lecture",
        "payment_methods_read": "PaymentMethods : Lecture",
        "refunds_write": "Refunds : Écriture",
        "balance_transactions_read": "Balance transaction sources : Lecture"
      }
    },
    "calendly": {
      "connect": "Connecter un compte Calendly",
      "external_label": "Voir le compte",
      "free_plan": "Ce compte Calendly est gratuit. Certaines fonctionnalités ne fonctionnent qu'avec un compte payant.",
      "subtitle": "Connecter un compte Calendly pour envoyer des liens de prise de rendez-vous.",
      "title": "Compte Calendly"
    },
    "confirm_disconnect": "Voulez-vous déconnecter ce compte ?",
    "make": {
      "connect": "Connecter un compte Make",
      "connected_on": "Connecté le {{date}}",
      "subtitle": "Connectez-vous à plus de 8000 services grâce à Make.",
      "title": "Make"
    },
    "private_api": {
      "subtitle": "Utilisez notre API privée pour connecter vos propres apps ou services.",
      "title": "API privée",
      "token": "Jeton d'API",
      "view_documentation": "Voir la documentation",
      "regenerate": "Régénérer",
      "regenerate_confirm_title": "Régénérer le jeton d'API ?",
      "regenerate_confirm_message": "Votre jeton actuel cessera de fonctionner immédiatement. Les apps ou services qui l'utilisent devront être mis à jour avec le nouveau jeton.",
      "regenerated": "Jeton d'API régénéré !"
    },
    "mcp_server": {
      "title": "Serveur MCP",
      "subtitle": "Connectez vos agents à notre serveur MCP pour leur donner accès aux fonctionnalités Instagram.",
      "notice": "Authentifiez-vous via OAuth ou utilisez votre jeton d'API privé",
      "pro_only": "Disponible avec le plan Pro.",
      "steps_title": "Comment se connecter",
      "step_1": "Copiez l'URL du serveur MCP ci-dessus.",
      "step_2": "Dans votre agent, ajoutez un nouveau connecteur et collez l'URL.",
      "step_3": "Authentifiez-vous auprès d'Inrō lorsque cela vous est demandé pour donner l'accès à votre agent.",
      "documentation": "Voir la documentation complète",
      "agents": {
        "claude": "Claude",
        "chatgpt": "ChatGPT",
        "other": "Autres agents"
      },
      "claude": {
        "cta": "Ouvrir l'annuaire Claude",
        "step_1": "Connectez-vous à Claude et ouvrez l'annuaire des connecteurs.",
        "step_2": "Trouvez le connecteur Inrō et ajoutez-le à votre compte.",
        "step_3": "Authentifiez-vous auprès d'Inrō et autorisez l'accès à Claude."
      }
    },
    "openai": {
      "title": "Clé API OpenAI",
      "subtitle": "Utilisez une clé API OpenAI personnalisée pour toutes les fonctionnalités IA de votre compte.",
      "key_set": "Une clé API personnalisée est configurée.",
      "placeholder": "sk-...",
      "save": "Enregistrer la clé",
      "saved": "Clé API enregistrée",
      "remove": "Supprimer la clé",
      "removed": "Clé API supprimée",
      "model_label": "Modèle",
      "model_fast": "Rapide (GPT-6 Luna)",
      "model_balanced": "Équilibré (GPT-6.1 Terra)",
      "model_smart": "Intelligent (GPT-6.1 Sol)",
      "reasoning_label": "Raisonnement",
      "reasoning_low": "Faible",
      "reasoning_medium": "Moyen",
      "reasoning_high": "Élevé",
      "default": "Par défaut : {{value}}",
      "settings_saved": "Paramètres enregistrés",
      "high_reasoning_warning": "Un raisonnement élevé ralentit les réponses et consomme davantage de crédit OpenAI."
    },
    "shopify": {
      "connect": "Connecter un compte Shopify",
      "external_label": "Voir la boutique",
      "get_token": "Comment obtenir votre jeton d'API?",
      "save": "Sauvegarder",
      "or": "ou",
      "oauth_connect": "Connecter la boutique Shopify",
      "subtitle": "Connecter une boutique Shopify pour envoyer des liens d'achat",
      "title": "Compte Shopify",
      "token": "Jeton d'API personnalisé",
      "install": {
        "title": "Connectez votre boutique Shopify",
        "description": "Finalisez la configuration dans un nouvel onglet, puis revenez ici une fois terminé.",
        "cta": "Ouvrir la configuration",
        "already_done": "Déjà terminé ?",
        "refresh": "Rafraîchir cette page"
      },
      "choose_organization": {
        "title": "Choisir un compte",
        "subtitle": "Sélectionnez le compte Instagram à connecter avec {{shop}}",
        "connect": "Connecter"
      },
      "missing_scopes": "Certains accès API doivent encore être activés.",
      "inject_script": "Installer le script",
      "script_missing": "Le script de tracking n'est pas installé."
    },
    "meta_conversions_api": {
      "connect": "Connecter Meta Conversions API",
      "subtitle": "Connectez-vous à Meta Conversions API pour envoyer des événements de conversion.",
      "title": "Meta Conversions API",
      "connected": "Connecté",
      "not_connected": "Non connecté",
      "expires_at": "Jeton expire le: {{date}}",
      "expired": "Votre jeton d'accès a expiré. Veuillez vous reconnecter.",
      "expiring_soon": "Votre jeton d'accès expirera bientôt. Veuillez le rafraîchir."
    },
    "high_level": {
      "title": "HighLevel CRM",
      "subtitle": "Connectez HighLevel CRM pour créer ou mettre à jour des contacts automatiquement.",
      "api_key": "Clé API",
      "location_id": "ID de localisation",
      "save": "Enregistrer",
      "connected": "Connecté",
      "not_connected": "HighLevel n'est pas connecté",
      "invalid_api_key": "Clé API invalide",
      "location_not_found": "ID de localisation introuvable",
      "invalid_credentials": "Clé API ou ID de localisation invalide"
    }
  },
  "request_access": {
    "ai_agent": "L'assistant IA peut répondre aux questions fréquentes à partir de la donnée que vous lui fournissez. Cette fonctionnalité est en beta et accessible à certains utilisateurs seulement.",
    "ai_rewrite": "Votre réponse peut être reformulée automatiquement par notre IA. Cette fonctionnalité est en beta et accessible à certains utilisateurs seulement.",
    "button": "Demander un accès",
    "requested": "Accès demandé, nous vous tenons au courant.",
    "title": "Fonctionnalité en Beta"
  },
  "automation_folder_exclusion": {
    "title": "Exclure des contacts",
    "description": "Les contacts correspondant à ces filtres seront exclus de toutes les automatisations."
  },
  "icebreakers": {
    "title": "Gérer les ice breakers",
    "description": "Les ice breakers apparaissent dans Instagram la première fois qu'on vous contacte.",
    "module_description": "Les ice breakers apparaissent dans Instagram la première fois qu'on vous contacte.",
    "learn_more": "En savoir plus sur les ice breakers",
    "new_icebreaker_placeholder": "Entrer votre ice breaker",
    "new_icebreaker_label": "Nouvel ice breaker",
    "suggested_intents": "Questions fréquentes que vous recevez",
    "question_label": "Question de l'ice breaker",
    "delete": "Supprimer cet ice breaker",
    "delete_confirm": "Supprimer cet ice breaker ?",
    "delete_automated_warning_one": "Une automatisation s'y déclenche. La supprimer laisse ce scénario sans déclencheur.",
    "delete_automated_warning_other": "{{count}} automatisations s'y déclenchent. Le supprimer les laisse sans déclencheur.",
    "no_icebreakers": "Aucun ice breaker. Ajoutez-en un, il apparaît aussitôt sur votre profil.",
    "add_automation": "Ajouter une automatisation",
    "matched_on_title": "Reconnue par le texte",
    "matched_on_title_tooltip": "Cette automatisation reconnaît le texte, pas l'ice breaker lui-même. Reformuler la question l'empêche de se déclencher.",
    "preview": {
      "tap_to_send": "Touchez pour envoyer une question suggérée par {{username}}.",
      "nothing_suggested": "Aucune question suggérée — la conversation démarre vide."
    },
    "limit_reached": "Vous avez atteint la limit de 4 ice breakers",
    "health": {
      "empty": "Aucun ice breaker pour l’instant.",
      "dead_one": "1 ice breaker sans réponse.",
      "dead_other": "{{count}} ice breakers sans réponse.",
      "all_answered": "Tous les ice breakers ont une réponse"
    },
    "row": {
      "nothing_answers": "Rien ne répond à cet ice breaker",
      "agent_answers": "Votre agent y répond"
    },
    "recipes": {
      "title": "Ajouter une automatisation à l'icebreaker",
      "message": {
        "title": "Répondre par un message",
        "description": "Répondez immédiatement, avec vos mots.",
        "reply": "Merci pour ta question"
      },
      "folder": {
        "title": "Le classer dans un dossier",
        "description": "N’envoie rien. Vous répondez toujours à la main, mais le contact est trié et joignable plus tard.",
        "reply": "Ajouté au dossier"
      },
      "questions": {
        "title": "Poser quelques questions",
        "description": "Qualifiez le contact avant de passer du temps sur la réponse.",
        "reply": "Que cherchez-vous ?",
        "quick_reply_1": "Option A",
        "quick_reply_2": "Option B"
      }
    }
  },
  "opt_out": {
    "activate_prompt": "Activer la détection d'opt-out ?",
    "ai_detection": "Détection par IA",
    "ai_detection_description": "L'Assistant IA détectera automatiquement les messages d'opt-out.",
    "confirmation_message": "Envoyer un message de confirmation",
    "confirmation_message_placeholder": "Entrer votre message",
    "deactivate_prompt": "Désactiver la détection d'opt-out ?",
    "description": "Détecte automatiquement les demandes de désinscription",
    "keywords": "Détection par mots-clé",
    "menu_message": "Élément du menu persistent",
    "menu_message_placeholder": "Entrez votre texte",
    "new_keyword": "Nouveau mot-clé",
    "title": "Détection de l'opt-out"
  },
  "persistent_menu": {
    "title": "Gérer le menu persistant",
    "description": "Vos contacts l'ouvrent depuis ☰ dans la conversation, par-dessus vos échanges.",
    "module_description": "Un menu que vos contacts ouvrent depuis ☰ dans votre conversation Instagram.",
    "learn_more": "En savoir plus sur le menu persistant",
    "new_item_placeholder": "Entrer votre élément de menu",
    "new_item_label": "Nouvel élément de menu",
    "add_new_item": "Ajouter un élément de menu",
    "add_item": "Ajouter au menu",
    "when_click": "Au clic",
    "send_dm": "Envoyer un message",
    "open_link": "Ouvrir un lien",
    "label_label": "Libellé de l'élément",
    "url_label": "URL du lien",
    "open_url": "Ouvrir ce lien",
    "sends_message": "Vous envoie un message",
    "opts_out": "Désabonne le contact de vos messages",
    "delete": "Retirer cet élément du menu",
    "delete_confirm": "Retirer cet élément du menu ?",
    "empty": "Menu vide. Ajoutez un élément et ☰ l'affiche aussitôt.",
    "limit_reached": "Menu complet — Instagram affiche 5 éléments au maximum",
    "optout_tooltip": "Cet élément appartient au réglage de désabonnement. Renommez-le ou retirez-le depuis ce réglage.",
    "preview": {
      "business_chat": "Chat professionnel",
      "tap_to_send": "Touchez pour envoyer",
      "empty": "Menu vide — ☰ n'affiche que les options d'Instagram."
    }
  },
  "welcome_modal": {
    "body": "Regardez une courte vidéo, explorez par vous-même ou contactez-nous.",
    "chat": "Nous contacter",
    "explore": "Je veux explorer par moi-même",
    "title": "Enchantée ! Besoin d'aide ?",
    "watch_video": "Voir la vidéo d'intro",
    "ltd": {
      "title": "Bienvenue en illimité !",
      "pitch": "Tout ce qui suit est à vous définitivement, et les quotas mensuels se renouvellent chaque mois. Connectez un compte et lancez vos automatisations.",
      "unlimited": "Illimité",
      "agency": "Votre palier inclut le tableau de bord partenaire et la marque blanche — gérez tous les comptes clients au même endroit.",
      "allowances": {
        "slots": "Comptes",
        "contacts": "Contacts / mois",
        "ai_credits": "Crédits IA / mois"
      },
      "tiers": {
        "appsumo_1": "Un compte Instagram, le constructeur d'automatisations complet et un agent IA qui répond à vos DMs. Commencez par un flux commentaire vers DM : c'est celui qui se rentabilise le plus vite.",
        "appsumo_2": "Deux comptes Instagram, les intégrations et votre propre clé OpenAI si vous préférez l'utiliser. De quoi automatiser une deuxième marque.",
        "appsumo_3": "Quatre comptes Instagram, les campagnes programmées et toute la bibliothèque d'intégrations. De quoi gérer sérieusement une marque et ses projets annexes.",
        "appsumo_4": "Huit comptes Instagram, le tableau de bord partenaire et la marque blanche. Conçu pour gérer des clients, pas seulement vos propres comptes.",
        "appsumo_5": "Vingt comptes Instagram et les quotas mutualisés les plus élevés que nous vendons, avec le tableau de bord partenaire et la marque blanche. Tout, pour gérer des clients à grande échelle.",
        "lifetime_1": "Votre deal à vie d'origine, désormais avec des crédits IA mensuels inclus. Tout ce que vous aviez, plus un agent IA qui répond à vos DMs.",
        "lifetime_2": "Votre deal à vie d'origine, désormais avec des crédits IA mensuels et votre propre clé OpenAI si vous le souhaitez. Deux comptes Instagram partageant un même quota.",
        "lifetime_3": "Votre deal à vie d'origine, désormais avec des crédits IA mensuels inclus. Cinq comptes Instagram partageant un même quota."
      },
      "open_partner": "Ouvrir le tableau de bord partenaire",
      "review": "Envie de plus ? Laissez un avis"
    }
  },
  "milestone_modal": {
    "title": {
      "agent_replies": "Félicitations ! Votre agent IA a répondu à {{number}} messages",
      "automation_runs": "Félicitations ! Vos automatisations ont tourné {{number}} fois",
      "link_clicks": "Félicitations ! Vos liens ont été cliqués {{number}} fois",
      "campaign_recipients": "Félicitations ! Vos campagnes ont touché {{number}} contacts",
      "contact_properties_email": "Félicitations ! Vous avez collecté {{number}} e-mails",
      "contact_properties_phone": "Félicitations ! Vous avez collecté {{number}} numéros de téléphone",
      "contact_properties_custom": "Félicitations ! Vous avez collecté « {{property}} » pour {{number}} contacts",
      "review": "Profitez de plus avec votre offre"
    },
    "body": "Si ça vous fait gagner du temps, un avis de 2 minutes aide d'autres entreprises à nous trouver.",
    "benefit_body": "Un avis sur AppSumo ajoute ceci à votre offre, pour toujours :",
    "benefit": {
      "slots_one": "+{{count}} compte Instagram",
      "slots_other": "+{{count}} comptes Instagram",
      "contacts": "+{{number}} contacts / mois",
      "ai_credits": "+{{number}} crédits IA / mois"
    },
    "review": {
      "g2": "Laisser un avis sur G2",
      "appsumo": "Laisser un avis sur AppSumo"
    },
    "later": "Plus tard",
    "feedback": "Un problème ? Dites-le-nous",
    "close": "Fermer"
  },
  "billing": {
    "enable_feature": {
      "button": "Activer maintenant",
      "description": "Vous devez être abonné pour activer cette fonctionnalité.",
      "title": "Fonctionnalité inactive"
    },
    "title": "Facturation"
  },
  "errors": {
    "default": "Une erreur est survenu. Réessayer plus tard."
  },
  "consent": {
    "step_title": "Vos choix de confidentialité",
    "accept_all": "Tout accepter",
    "continue": "Continuer",
    "privacy_policy": "[Politique de confidentialité](https://www.inro.social/legal/privacy-policy)",
    "necessary_title": "Strictement nécessaires",
    "necessary_description": "Indispensables au fonctionnement de l'application : connexion, sécurité et chat de support.",
    "analytics_title": "Analyses d'usage",
    "analytics_description": "Nous aide à comprendre comment vous utilisez l'application pour l'améliorer : navigation, clics, erreurs, etc.",
    "marketing_title": "Mesure publicitaire",
    "marketing_description": "Informe nos partenaires publicitaires lorsque vous vous inscrivez ou vous abonnez, pour mesurer l'efficacité de nos campagnes.",
    "save": "Sauvegarder"
  },
  "switcher": {
    "your_organizations": "Comptes",
    "partner_organizations": "Comptes partenaires",
    "shared_billing_one": "Facturés ensemble",
    "shared_billing_other": "Facturés ensemble · {{count}} comptes",
    "partners": "Partenaires",
    "current": "Actuel",
    "create": {
      "billing_label": "Où le facturer ?",
      "submit": "Créer le compte",
      "join": {
        "lifetime": "Ajouter à mon {{tier}}",
        "lifetime_slots": "Couvert par le même deal, avec les mêmes quotas mensuels partagés. {{used}} comptes sur {{total}} utilisés.",
        "lifetime_description": "Couvert par le même deal, avec les mêmes quotas mensuels partagés.",
        "partner": "Ajouter à {{name}}",
        "partner_description": "Géré et facturé par {{name}}, et listé dans son tableau de bord à côté de votre autre compte.",
        "billing_account": "Ajouter à mon compte de facturation",
        "billing_account_description_one": "Même carte et mêmes factures que {{name}}. Chaque compte garde son propre plan.",
        "billing_account_description_other": "Même carte et mêmes factures que les {{count}} comptes déjà dessus. Chaque compte garde son propre plan."
      },
      "separate": "Le facturer séparément",
      "separate_description": "Sa propre carte, ses propres factures et son propre plan. Rien n'est partagé avec le compte où vous êtes.",
      "refusals": {
        "slot_limit": "Votre deal couvre {{limit}} comptes et ils sont tous utilisés.",
        "no_payment_method": "Ce partenaire n'a pas de moyen de paiement enregistré : rien ne peut lui être facturé pour l'instant.",
        "no_subscription": "Ce partenaire n'a pas de plan actif sur lequel ajouter un compte."
      }
    }
  },
  "partners": {
    "nav": {
      "dashboard": "Tableau de bord",
      "links": "Liens partenaires",
      "team": "Équipe",
      "billing": "Facturation",
      "settings": "Paramètres",
      "partner_account": "Compte partenaire",
      "back_to_main_app": "Retour vers Inrō",
      "api": "API & MCP"
    },
    "payment_method": {
      "title": "Aucun moyen de paiement",
      "description": "Ajoutez un moyen de paiement pour créer des comptes et des liens gérés. Les comptes existants continuent de fonctionner.",
      "add": "Ajouter un moyen de paiement"
    },
    "dashboard": {
      "title": "Tableau de bord partenaire",
      "placeholder": "Métriques du tableau de bord à venir.",
      "contacts_activated": "Contacts activés",
      "conversions": "Conversions",
      "create_organization": "Créer un compte",
      "create": "Créer",
      "new_org_placeholder": "Nom du compte",
      "switch_to": "Ouvrir",
      "reconnect": "Reconnecter",
      "period": "Période",
      "periods": {
        "last_7_days": "7 derniers jours",
        "last_30_days": "30 derniers jours",
        "last_3_months": "3 derniers mois"
      },
      "help": {
        "contacts_activated": "Contacts ayant reçu un DM d'un scénario ou d'une campagne sur la période sélectionnée.",
        "conversions": "Contacts ayant cliqué sur un lien de conversion ou répondu à un sondage sur la période sélectionnée.",
        "new_contacts": "Contacts ajoutés sur l'ensemble de vos comptes sur la période sélectionnée."
      },
      "connect": "Connecter",
      "connection": {
        "status": {
          "connected": "Connecté",
          "limited": "Limité",
          "error": "Erreur",
          "disconnected": "Déconnecté",
          "restricted": "Restreint",
          "never_connected": "Non connecté"
        },
        "detail": {
          "limited": "Des permissions manquent.",
          "error": "Instagram signale un problème.",
          "disconnected": "Les automatisations sont en pause.",
          "restricted": "Instagram restreint les envois."
        },
        "reason": {
          "expired": "Session expirée",
          "invalidated": "Session révoquée",
          "deauthorized": "Accès à l'app retiré",
          "locked": "Bloqué par Meta",
          "malformed": "Session invalide"
        }
      },
      "new_contacts": "Nouveaux contacts",
      "metrics": {
        "followers": "Abonnés",
        "contacts": "Contacts",
        "automations": "Automatisations"
      }
    },
    "settings": {
      "title": "Paramètres partenaire",
      "subtitle": "Gérez votre identité et votre image partenaire.",
      "name": "Nom du partenaire",
      "email": "Email de contact",
      "logo": "Logo",
      "upload_logo": "Téléverser un nouveau logo",
      "remove_logo": "Supprimer",
      "remove_logo_confirm": "Supprimer le logo partenaire ? Les pages d'inscription et d'onboarding ouvertes depuis vos liens afficheront à nouveau le logo Inrō.",
      "logo_hint": "PNG, JPG ou SVG. Les images carrées s'affichent mieux.",
      "logo_description": "Remplace le logo Inrō sur les pages d'inscription et d'onboarding ouvertes depuis vos liens partenaires, et identifie votre espace dans le sélecteur de compte.",
      "name_description": "Affiché dans le sélecteur de compte, et utilisé pour construire le code de votre lien de parrainage et ses paramètres de suivi de campagne.",
      "email_description": "L'adresse à laquelle nous vous contactons au sujet de votre compte partenaire, et l'email de facturation du client Stripe sur lequel les comptes que vous créez sont facturés. Elle n'est pas visible par les comptes que vous parrainez.",
      "saved": "Paramètres enregistrés"
    },
    "api_access": {
      "title": "API & MCP",
      "subtitle": "Un seul jeton pour tous les comptes de votre espace.",
      "token": "Jeton API partenaire",
      "token_notice": "Toute personne disposant de ce jeton peut lire et modifier tous les comptes de votre espace. Traitez-le comme un mot de passe.",
      "regenerate": "Régénérer",
      "regenerated": "Nouveau jeton généré",
      "regenerate_confirm_title": "Régénérer le jeton API partenaire ?",
      "regenerate_confirm_message": "Le jeton actuel cesse de fonctionner immédiatement. Toute intégration ou tout connecteur MCP qui l'utilise devra recevoir le nouveau.",
      "mcp_title": "Connecter un client MCP",
      "mcp_step_url": "Ajoutez un connecteur personnalisé avec cette URL :",
      "mcp_step_auth": "Réglez l'authentification sur « None ».",
      "mcp_step_auth_why": "Le client proposera OAuth, car il en détecte un sur ce domaine. Ne l'utilisez pas : cette connexion autorise un seul compte Instagram, pas tout votre espace.",
      "mcp_step_header": "Ajoutez un en-tête de requête avec ce nom et cette valeur, et cochez « Required » :",
      "api_title": "API REST",
      "api_headers": "Envoyez votre jeton dans « Authorization: Bearer … ». Ajoutez « X-Inro-Organization » avec l'id d'un compte ou son nom d'utilisateur Instagram pour indiquer le compte concerné.",
      "documentation": "Voir la documentation de l'API"
    },
    "placeholder": {
      "coming_soon": "Bientôt disponible."
    },
    "team": {
      "title": "Équipe",
      "subtitle": "Gérez qui peut accéder à l'espace partenaire {{name}}.",
      "invite_label": "Inviter un membre",
      "invite_placeholder": "collegue@exemple.com",
      "invite_action": "Envoyer l'invitation",
      "invite_hint": "Les utilisateurs Inrō existants sont ajoutés immédiatement. Les nouveaux utilisateurs reçoivent un email pour définir un mot de passe.",
      "invite_sent": "Invitation envoyée",
      "already_member": "Cet utilisateur est déjà membre.",
      "last_member": "Vous ne pouvez pas supprimer le dernier membre de l'espace.",
      "remove": "Retirer le membre",
      "remove_confirm": "Retirer {{email}} de cet espace partenaire ?"
    },
    "links": {
      "title": "Liens partenaires",
      "subtitle": "Gérez vos liens d'inscription et d'onboarding.",
      "create": "Nouveau lien",
      "type": "Type de lien",
      "types": {
        "referral": "Parrainage",
        "managed": "Géré"
      },
      "discount_code": "Code de réduction",
      "trial_days": "Jours d'essai",
      "save": "Enregistrer",
      "copied": "Lien copié dans le presse-papier",
      "organizations": "Comptes",
      "paid": "Payantes",
      "edit": "Modifier le lien",
      "remove": "Supprimer le lien",
      "remove_confirm": "Supprimer le lien « {{code}} » ?",
      "empty": "Aucun lien pour le moment.",
      "new_title": "Nouveau lien partenaire",
      "edit_title": "Modifier le lien partenaire",
      "modal_description": "Choisissez comment les nouveaux comptes arrivent sur Inrō et ce qu'ils obtiennent à l'inscription.",
      "type_descriptions": {
        "referral": "Envoie vers la page d'inscription Inrō. La personne crée son compte et les revenus d'affiliation vous sont attribués.",
        "managed": "Envoie directement l'utilisateur vers la connexion Instagram pour autoriser l'accès à son compte."
      },
      "type_locked": "Le type d'un lien ne peut pas être modifié après sa création. Créez un nouveau lien pour utiliser l'autre type.",
      "url": "Lien à partager",
      "url_description": "Toute personne ouvrant cette URL est attribuée à votre compte partenaire.",
      "discount_code_description": "Code promotionnel Stripe appliqué automatiquement au paiement pour les comptes inscrits via ce lien. Laissez vide pour aucune réduction.",
      "discount_code_placeholder": "PARTENAIRE20",
      "trial_days_description": "Jours d'essai offerts aux comptes inscrits via ce lien (0 à {{max}}).",
      "trial_days_count": "{{count}} jours",
      "default_template": "Modèle d'automatisation",
      "default_template_description": "Scénario dupliqué dans chaque compte créé par ce lien, et activé dès qu'Instagram est connecté. Choisissez parmi les scénarios de vos comptes.",
      "no_default_template": "Aucun modèle",
      "loading_scenarios": "Chargement des scénarios…",
      "untitled_scenario": "Scénario sans titre",
      "scenarios_error": "Impossible de charger les scénarios.",
      "hide_template_disclaimer": "Masquer la mention du modèle",
      "hide_template_disclaimer_description": "La page de connexion Instagram indique à l'utilisateur quel modèle d'automatisation est installé pour lui. Activez cette option pour masquer cette mention.",
      "managed_billing_notice": "Les comptes créés par un lien géré sont sur votre abonnement partenaire dès le départ — sans essai ni code promo.",
      "organizations_title": "Comptes issus de ce lien",
      "organizations_description": "Toutes les inscriptions via {{code}}. Ces comptes se facturent eux-mêmes et ne sont pas gérés par vous.",
      "organizations_empty": "Personne ne s'est encore inscrit via ce lien.",
      "organization_paid": "Payant",
      "organization_free": "Gratuit",
      "table": {
        "link": "Lien",
        "type": "Type",
        "organizations": "Comptes",
        "paid": "Payantes",
        "discount_code": "Réduction",
        "trial_days": "Essai",
        "created_at": "Créé le"
      }
    },
    "billing": {
      "title": "Facturation",
      "subtitle": "Un seul abonnement pour {{name}} et tous les comptes que vous gérez.",
      "plan": "Abonnement partenaire",
      "renews_on": "Renouvellement le {{date}}",
      "activated_contacts": "Contacts activés",
      "portal_title": "Portail de facturation Stripe",
      "portal_description": "Gérez vos moyens de paiement, factures et abonnement dans Stripe.",
      "open_portal": "Ouvrir le portail de facturation",
      "no_account": "Aucun compte de facturation n'est encore configuré pour ce partenaire.",
      "usage_by_organization": "Utilisation par compte",
      "usage_by_organization_description": "Les activations sont facturées en un seul total pour tous les comptes que vous gérez.",
      "usage_by_organization_lifetime": "Les quotas sont partagés entre tous les comptes que vous gérez, et se renouvellent chaque mois.",
      "no_organizations": "Vous ne gérez encore aucun compte.",
      "resubscribe_title": "Aucune facturation en cours",
      "resubscribe_description": "Démarrez un nouvel abonnement pour réactiver tous les comptes que vous gérez.",
      "resubscribe_cta": "Souscrire"
    },
    "plan_gate": {
      "title": "Démarrez votre abonnement partenaire",
      "subtitle": "{{name}} doit avoir un abonnement actif pour gérer des comptes.",
      "included": {
        "accounts": "Créez et gérez autant de comptes clients que vous voulez",
        "usage": "Un seul total d'utilisation pour tous les comptes, facturé une fois",
        "billing": "Une seule facture, aucun abonnement par compte",
        "support": "Tableau de bord partenaire, liens gérés et API partenaire"
      },
      "subscribe": "Souscrire",
      "disclaimer": "Les frais partenaire sont dus dès aujourd'hui. L'abonnement à l'usage est ajouté au premier compte qui connecte Instagram."
    }
  },
  "request_logs": {
    "title": "Journaux API & MCP",
    "search": "Rechercher dans les journaux",
    "empty": "Aucune requête enregistrée pour le moment",
    "sources": {
      "grape_api": "API",
      "mcp": "MCP"
    },
    "status": {
      "ok": "OK",
      "error": "Erreur"
    },
    "filters": {
      "all_sources": "Toutes les sources",
      "all_statuses": "Tous les statuts",
      "only_success": "Succès uniquement",
      "only_errors": "Erreurs uniquement"
    },
    "table": {
      "columns": {
        "source": "Source",
        "request": "Requête",
        "status": "Statut",
        "duration_ms": "Durée",
        "created_at": "Date"
      }
    },
    "detail": {
      "title": "Détails de la requête",
      "method": "Méthode HTTP",
      "path": "Chemin",
      "route": "Route",
      "mcp_method": "Méthode MCP",
      "tool_name": "Outil",
      "action": "Action",
      "duration": "Durée",
      "created_at": "Date",
      "ip_address": "Adresse IP",
      "user_agent": "Agent utilisateur",
      "error": "Erreur",
      "params": "Paramètres"
    }
  },
  "media_upload": {
    "title": "Envoyez votre fichier",
    "requested_by": "{{client}} a besoin d'un fichier pour terminer ce que vous avez commencé dans votre conversation.",
    "requested_generic": "Une application connectée à votre compte Inrō a besoin d'un fichier.",
    "for_image": "Une image est attendue.",
    "for_video": "Une vidéo est attendue.",
    "for_audio": "Un fichier audio est attendu.",
    "for_file": "Un fichier est attendu.",
    "drop_here": "Glissez un fichier ici",
    "or": "ou",
    "choose_from_library": "Choisir dans votre galerie",
    "max_size": "Jusqu'à {{max}}",
    "expires_in": "Ce lien expire {{when}}.",
    "expired_title": "Ce lien a expiré",
    "expired_message": "Les liens d'envoi sont à usage unique et de courte durée. Retournez dans votre application pour en demander un nouveau.",
    "uploading": "Envoi en cours…",
    "finishing": "Finalisation…",
    "success_title": "Fichier bien reçu",
    "success_message": "C'est terminé ici. Retournez dans votre application pour continuer.",
    "errors": {
      "too_large": "Ce fichier est trop volumineux. La limite est de {{max}}.",
      "wrong_type": "Ce fichier ne semble pas être du bon type.",
      "failed": "L'envoi n'a pas abouti. Vérifiez votre connexion et réessayez."
    }
  },
  "oauth": {
    "connect": {
      "signup_title": "Créez votre compte Inrō",
      "signup_description": "Créez votre compte pour terminer la connexion de {{app}} à Inrō.",
      "signup_description_generic": "Créez votre compte pour terminer la connexion à Inrō.",
      "login_title": "Content de vous revoir",
      "login_description": "Connectez-vous pour terminer la connexion de {{app}} à Inrō.",
      "login_description_generic": "Connectez-vous pour terminer la connexion à Inrō.",
      "app_icon_alt": "Logo {{app}}",
      "logo_alt": "Inrō"
    }
  },
  "instagram_preview": {
    "active_now": "En ligne",
    "followers_one": "1 abonné",
    "followers_other": "{{formattedCount}} abonnés",
    "business_account": "Compte professionnel",
    "view_profile": "Voir le profil",
    "message_placeholder": "Message…"
  },
  "batch_tasks": {
    "status": {
      "pending": "Démarrage…",
      "processing": "En cours…",
      "paused": "En pause",
      "completed": "Terminée",
      "failed": "Interrompue",
      "canceled": "Annulée"
    },
    "progress": "{{done}} sur {{total}}",
    "analyzed": "Analysés",
    "processed": "Traités",
    "executed": "Exécutées",
    "failed": "Échouées",
    "detected": "Détectés",
    "not_detected": "Non détectés",
    "detected_waiting": "Les contacts apparaissent ici au fur et à mesure des détections.",
    "detected_none": "Aucune valeur trouvée.",
    "stopped": "Interrompue avant la fin.",
    "stopped_credits": "Interrompue : plus de crédits IA. Relancez-la quand ils seront renouvelés.",
    "retry": "Réessayer",
    "show_more": "Afficher plus",
    "open": {
      "campaign_send": "Voir la campagne",
      "retroactive_automation": "Voir l'automatisation"
    },
    "sidebar_group_one": "{{count}} tâche",
    "sidebar_group_other": "{{count}} tâches",
    "types": {
      "campaign_send": "Campagne",
      "contact_bulk_update": "Mise à jour de contacts",
      "retroactive_automation": "Automatisation sur l'existant",
      "contact_property_detection": "Détection de propriété"
    }
  },
  "batch_task_logs": {
    "title": "Tâches en arrière-plan",
    "empty": "Aucune tâche pour l'instant",
    "filters": {
      "all_types": "Tous les types",
      "all_statuses": "Tous les statuts"
    },
    "table": {
      "columns": {
        "title": "Tâche",
        "task_type": "Type",
        "status": "Statut",
        "progress": "Progression",
        "created_at": "Démarrée"
      }
    }
  }
}
